import React, { useEffect, useState, useMemo, useDeferredValue } from 'react';
import {
  Container,
  VStack,
  HStack,
  Box,
  Text,
  Heading,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  StatArrow,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Input,
  Select,
  useToast,
  Spinner,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  useDisclosure,
  Alert,
  AlertIcon,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  FormControl,
  FormLabel,
  Textarea,
  NumberInput,
  NumberInputField,
  Button,
  InputGroup,
  InputLeftElement,
  Progress,
  Switch,
  Divider,
  Tooltip,
  IconButton,
  Checkbox,
  Wrap,
  WrapItem,
} from '@chakra-ui/react';
import {
  BarChart3,
  Users,
  User,
  DollarSign,
  TrendingUp,
  Trophy,
  Gamepad2,
  Activity,
  Plus,
  Trash2,
  RefreshCw,
  UserPlus,
  Percent,
  Send,
  Search,
  Gift,
  UserCheck,
  AlertTriangle,
  Shield,
  Calendar,
  Zap,
  CheckCircle,
  XCircle,
  Clock,
  Settings,
  FileText,
  Eye,
  Ban,
  MapPin,
  Copy,
  Key,
  Video,
  Mic,
  ToggleLeft,
  ToggleRight,
  Receipt,
  MessageCircle,
  Bell,
  Download,
  Filter,
  ArrowDownLeft,
  ArrowUpRight,
  Flag,
  Play,
  ChevronUp,
  Scale,
  Smartphone,
  Send as SendIcon,
  Star,
  Beaker,
  Smartphone as SmartphoneIcon,
  Mail as MailIcon,
  Paperclip,
} from 'lucide-react';
import gameApiService, { HostTournamentRow } from '../services/gameApiService';
import { DEFAULT_PAYMENTS_HOLD_MESSAGE } from '../services/paymentsHoldService';
import { POKER_COLORS } from '../theme/designSystem';
import PokerCard from '../components/ui/PokerCard';
import PokerButton from '../components/ui/PokerButton';
import AdminSendCoinsModal from '../components/admin/AdminSendCoinsModal';
import { auth, db } from '../firebase';
import { collection, getDocs, query, orderBy, limit, where, doc, getDoc, addDoc, updateDoc, Timestamp, writeBatch, deleteDoc, setDoc, serverTimestamp, onSnapshot, arrayUnion } from 'firebase/firestore';
import tournamentService from '../services/tournamentService';
//  REMOVED: tableCleanupService - now using server API

// import tableCleanupService from '../services/tableCleanupService';
import referralService from '../services/referralService';
import { tutorialService } from '../services/tutorialService';
import { Tournament, TOURNAMENT_TIERS, TournamentTier } from '../types/tournamentTypes';

//  NEW: Import compliance types

import { EnhancedRedemption, PlatformSettings, DEFAULT_PLATFORM_SETTINGS, US_STATES } from '../types/complianceTypes';

//  NEW: Import bypass code service

import bypassCodeService, { BypassCode, BypassCodeUsageLog } from '../services/bypassCodeService';

//  NEW: Import tax service for platform-wide tax reporting

import taxService, { Platform1099Report } from '../services/taxService';

//  SECURITY: Import security admin components

import { SecurityOverview, SecurityFlags, PlayerRiskDetail, CheatScanPanel } from '../components/admin/security';
import SupportAdminTab from '../components/admin/SupportAdminTab';
import AdminTournamentTesting from '../components/admin/AdminTournamentTesting';
import AdminPushTesting from '../components/admin/AdminPushTesting';
import AdminPlayerDossier from '../components/admin/AdminPlayerDossier';
import AdminEmailBroadcast from '../components/admin/AdminEmailBroadcast';
import AdminTrainingEarnings from '../components/admin/AdminTrainingEarnings';
import { API_BASE } from '../utils/apiBase';
import reportService, { 
  UserReport, 
  ReportStatus, 
  ReportAction, 
  ReportStats as ReportStatsType,
  BanAppeal,
  BannedUser,
  AuditLogEntry,
  REPORT_REASONS,
  STATUS_LABELS,
  ACTION_LABELS,
  getReasonIcon,
} from '../services/reportService';

//  NEW: Geo Restriction Constants

const RESTRICTED_STATES = ['WA', 'ID', 'CA', 'CT', 'MT', 'NJ', 'MI', 'NV', 'NY', 'IN', 'LA', 'ME', 'OK', 'TN', 'DE', 'MS', 'WV', 'MD', 'AZ', 'KY', 'PA'];
const RESTRICTED_STATE_NAMES: { [key: string]: string } = {
  'WA': 'Washington',
  'ID': 'Idaho', 
  'CA': 'California',
  'CT': 'Connecticut',
  'MT': 'Montana',
  'NJ': 'New Jersey',
  'MI': 'Michigan',
  'NV': 'Nevada',
  'NY': 'New York',
  'IN': 'Indiana',
  'LA': 'Louisiana',
  'ME': 'Maine',
  'OK': 'Oklahoma',
  'TN': 'Tennessee',
};

interface DashboardStats {
  totalUsers: number;
  activeUsers: number;
  totalTables: number;
  activeTables: number;
  totalPlayCoins: number;
  totalPKCash: number;
  totalRake: number;
  totalDeposits: number;
  totalWithdrawals: number;
  newUsersThisWeek: number;
  totalAgents: number;
  tournamentRakeTotal: number;
  tournamentRakeAgentPaid: number;
  tournamentRakeHouseNet: number;
  tournamentsRaked: number;
  //  NEW: Redemption stats

  pendingRedemptions: number;
  pendingRedemptionAmount: number;
  //  NEW: Bypass code stats

  totalBypassCodes: number;
  activeBypassCodes: number;
  bypassCodeUsageThisMonth: number;
  //  NEW: Report stats

  pendingReports: number;
  totalReports: number;
  //  NEW: Push notification stats

  pushEnabledUsers: number;
  androidPushUsers: number;
  iosPushUsers: number;
  totalAnnouncements: number;
  //  NEW: Revenue tracking

  voicePassRevenue: number;
  voicePassUnlimitedCount: number;
  voicePassRegularCount: number;
  voiceChatFeeRevenue: number;
  voiceChatFeeCount: number;
  gameItemRevenue: number;
  gameItemCount: number;
  totalRevenue: number;
}

interface UserData {
  id: string;
  email: string;
  username: string;
  playCoins: number;
  pkCash: number;
  gamesPlayed: number;
  referrerId?: string;
  createdAt: Date;
  kycStatus?: string;
  role?: string;
  banned?: boolean;
  banReason?: string;
  banExpiresAt?: Date;
}

interface TransactionData {
  id: string;
  odid: string;
  type: string;
  amount: number;
  currency: string;
  status: string;
  description?: string;
  createdAt: Date;
  // Enhanced fields
  tableId?: string;
  handId?: string;
  tournamentId?: string;
  metadata?: Record<string, any>;
}

//  NEW: User audit data for investigation

interface UserAuditData {
  id: string;
  email: string;
  username: string;
  displayName?: string;
  playCoins: number;
  pkCash: number;
  totalDeposited: number;
  totalWithdrawn: number;
  gamesPlayed: number;
  handsWon: number;
  referrerId?: string;
  referrerName?: string;
  isAgent: boolean;
  agentTier?: string;
  kycStatus?: string;
  createdAt: Date;
  lastActive?: Date;
}

//  NEW: Transaction filter interface

interface TransactionFilters {
  searchTerm: string;
  transactionType: string;
  currency: string;
  status: string;
  dateFrom: string;
  dateTo: string;
  minAmount: string;
  maxAmount: string;
}

interface AgentData {
  id: string;
  displayName: string;
  email: string;
  tier: string;
  totalReferrals: number;
  totalRakeEarned: number;
  active: boolean;
  role?: 'agent' | 'manager';
  managerId?: string;
  code?: string;
  customCode?: string;
  totalPurchaseCommission?: number;
  totalOverrideEarned?: number;
  overrideRakePercent?: number;
  canHostTournaments?: boolean;
  mediaAllowed?: 'none' | 'voice' | 'video';
  mediaComped?: boolean;
  creatorGroupId?: string;
}

interface AgentPayoutRow {
  id: string; agentId: string; username: string; email: string; amount: number; status: string;
  payoutMethod: 'usdc' | 'paypal' | 'legacy_stripe' | null;
  payoutDestination: { method: string; value: string; network?: string | null } | null;
  payoutBatchId: string | null; payoutProviderStatus: string | null; payoutReference: string | null; payoutError: string | null;
  kycStatus: string | null; requestedAt: string | null; approvedAt: string | null; paidAt: string | null;
  adminNote: string | null;
}

interface TournamentRakeData {
  id: string;
  tournamentId: string;
  tournamentName: string;
  totalBuyIns: number;
  totalRake: number;
  houseRake: number;
  agentPayouts: { agentId: string; amount: number; tier: string; playerCount: number }[];
  playerCount: number;
  timestamp: Date;
  currency: string;
}

//  NEW: Redemption data interface

interface RedemptionData {
  id: string;
  odD: string;
  username?: string;
  email?: string;
  amount: number;
  status: 'pending_review' | 'approved' | 'processing' | 'completed' | 'rejected' | 'failed';
  requestedAt: Date;
  kycStatus?: string;
  playthroughComplete?: boolean;
  stripeConnectAccountId?: string;
  reviewNote?: string;
  payoutMethod?: 'usdc' | 'paypal' | string;
  payoutDestination?: { method: string; value: string; network?: string | null } | null;
  kycName?: string | null;
  payoutBatchId?: string | null;
  payoutError?: string | null;
}

const AdminDashboard: React.FC = () => {
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isAgentOpen, onOpen: onAgentOpen, onClose: onAgentClose } = useDisclosure();
  const { isOpen: isSendOpen, onOpen: onSendOpen, onClose: onSendClose } = useDisclosure();
  const { isOpen: isRedemptionOpen, onOpen: onRedemptionOpen, onClose: onRedemptionClose } = useDisclosure();
  //  NEW: Bypass code modal

  const { isOpen: isBypassCodeOpen, onOpen: onBypassCodeOpen, onClose: onBypassCodeClose } = useDisclosure();
  //  NEW: Assign user to agent modal

  const { isOpen: isAssignUserOpen, onOpen: onAssignUserOpen, onClose: onAssignUserClose } = useDisclosure();
  
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState<DashboardStats>({
    totalUsers: 0, activeUsers: 0, totalTables: 0, activeTables: 0,
    totalPlayCoins: 0, totalPKCash: 0, totalRake: 0,
    totalDeposits: 0, totalWithdrawals: 0, newUsersThisWeek: 0,
    totalAgents: 0,
    tournamentRakeTotal: 0,
    tournamentRakeAgentPaid: 0,
    tournamentRakeHouseNet: 0,
    tournamentsRaked: 0,
    pendingRedemptions: 0,
    pendingRedemptionAmount: 0,
    totalBypassCodes: 0,
    activeBypassCodes: 0,
    bypassCodeUsageThisMonth: 0,
    pendingReports: 0,
    totalReports: 0,
    pushEnabledUsers: 0,
    androidPushUsers: 0,
    iosPushUsers: 0,
    totalAnnouncements: 0,
    //  Revenue tracking

    voicePassRevenue: 0,
    voicePassUnlimitedCount: 0,
    voicePassRegularCount: 0,
    voiceChatFeeRevenue: 0,
    voiceChatFeeCount: 0,
    gameItemRevenue: 0,
    gameItemCount: 0,
    totalRevenue: 0,
  });
  const [users, setUsers] = useState<UserData[]>([]);
  const [tournaments, setTournaments] = useState<Tournament[]>([]);
  const [transactions, setTransactions] = useState<TransactionData[]>([]);
  const [agents, setAgents] = useState<AgentData[]>([]);
  const [refreshing, setRefreshing] = useState(false);

  const [tournamentRakeTransactions, setTournamentRakeTransactions] = useState<TournamentRakeData[]>([]);
  const [generatingTournaments, setGeneratingTournaments] = useState(false);
  
  //  NEW: Tournament audit state

  const [selectedTournamentForAudit, setSelectedTournamentForAudit] = useState<Tournament | null>(null);

  //  NEW: Redemption state

  const [redemptions, setRedemptions] = useState<RedemptionData[]>([]);
  const [selectedRedemption, setSelectedRedemption] = useState<RedemptionData | null>(null);
  const [redemptionAction, setRedemptionAction] = useState<'approve' | 'reject' | null>(null);
  const [redemptionNote, setRedemptionNote] = useState('');
  const [processingRedemption, setProcessingRedemption] = useState(false);
  // Manual PayPal transaction id, or the NOWPayments 2FA code for USDC
  const [payoutReference, setPayoutReference] = useState('');
  const [usdcCode, setUsdcCode] = useState('');
  const [usdcAwaitingCode, setUsdcAwaitingCode] = useState(false);
  const executeRedemption = async (body: Record<string, any>) => {
    if (!auth.currentUser) throw new Error('Not authenticated');
    const token = await auth.currentUser.getIdToken();
    const r = await fetch(`${API_BASE}/executeRedemptionPayout`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: JSON.stringify(body),
    });
    const data = await r.json().catch(() => ({}));
    if (!r.ok || data?.error) throw new Error(data?.error || 'Payout call failed');
    return data;
  };

  //  NEW: Platform settings state

  const [platformSettings, setPlatformSettings] = useState<PlatformSettings>(DEFAULT_PLATFORM_SETTINGS);
  const [savingSettings, setSavingSettings] = useState(false);

  //  NEW: Bypass code state

  const [bypassCodes, setBypassCodes] = useState<BypassCode[]>([]);
  const [bypassCodeUsageLogs, setBypassCodeUsageLogs] = useState<BypassCodeUsageLog[]>([]);
  const [creatingBypassCode, setCreatingBypassCode] = useState(false);
  const [bypassCodeDescription, setBypassCodeDescription] = useState('');
  const [bypassCodeFilter, setBypassCodeFilter] = useState<'all' | 'admin' | 'agent'>('all');
  const [bypassCodeSearch, setBypassCodeSearch] = useState('');
  const [copiedCodeId, setCopiedCodeId] = useState<string | null>(null);

  //  NEW: Tax reporting state

  const [taxReport, setTaxReport] = useState<Platform1099Report | null>(null);
  const [loadingTaxReport, setLoadingTaxReport] = useState(false);
  const [taxYear, setTaxYear] = useState(new Date().getFullYear());

  //  NEW: Push Notification state

  const [pushAnnouncements, setPushAnnouncements] = useState<any[]>([]);
  const [pushAnnouncementTitle, setPushAnnouncementTitle] = useState('');
  const [pushAnnouncementBody, setPushAnnouncementBody] = useState('');
  const [sendingPushAnnouncement, setSendingPushAnnouncement] = useState(false);
  // Recipient targeting for announcements: null = broadcast to everyone
  const [pushTarget, setPushTarget] = useState<{ id: string; username: string } | null>(null);
  const [pushTargetQuery, setPushTargetQuery] = useState('');
  const [pushTargetResults, setPushTargetResults] = useState<Array<{ id: string; username: string }>>([]);
  const [pushTargetSearching, setPushTargetSearching] = useState(false);
  const [loadingPushData, setLoadingPushData] = useState(false);

  // Agent form state
  const [newAgentTier, setNewAgentTier] = useState<'standard' | 'premium' | 'vip'>('standard');
  const [agentUserSearch, setAgentUserSearch] = useState('');
  const [agentFilteredUsers, setAgentFilteredUsers] = useState<UserData[]>([]);
  const [selectedAgentUser, setSelectedAgentUser] = useState<UserData | null>(null);
  const [creatingAgent, setCreatingAgent] = useState(false);
  // Agent program: role/custom code/manager on create, per-agent settings, payout queue
  const [newAgentRole, setNewAgentRole] = useState<'agent' | 'manager'>('agent');
  const [newAgentCode, setNewAgentCode] = useState('');
  const [newAgentManagerId, setNewAgentManagerId] = useState('');
  const [settingsAgent, setSettingsAgent] = useState<AgentData | null>(null);
  const [settingsForm, setSettingsForm] = useState({ tier: 'standard', customCode: '', managerId: '', active: true, overrideRakePct: 5, canHostTournaments: false, mediaAllowed: 'none' as 'none' | 'voice' | 'video', mediaComped: false });
  // Creator tournaments waiting for approval (3rd+ in a month)
  const [pendingHostTournaments, setPendingHostTournaments] = useState<HostTournamentRow[]>([]);
  const [hostActionBusy, setHostActionBusy] = useState<string | null>(null);
  const [backfillingGroups, setBackfillingGroups] = useState(false);
  const handleHostTournamentAction = async (row: HostTournamentRow, action: 'approve' | 'reject') => {
    let note: string | undefined;
    if (action === 'reject') {
      const n = window.prompt(`Reason shown to ${row.hostName || 'the host'} (optional):`);
      if (n === null) return;
      note = n;
    }
    setHostActionBusy(row.id);
    const r = await gameApiService.adminHostTournamentAction({ tournamentId: row.id, action, note });
    setHostActionBusy(null);
    if (!r.success) { toast({ title: 'Action failed', description: r.error, status: 'error', duration: 5000 }); return; }
    toast({ title: action === 'approve' ? 'Tournament approved and listed' : 'Tournament declined', status: 'success', duration: 3000 });
    const list = await gameApiService.adminHostTournaments('pending');
    if (list.success) setPendingHostTournaments(list.tournaments);
  };
  const [savingAgentSettings, setSavingAgentSettings] = useState(false);
  const [agentPayoutRequests, setAgentPayoutRequests] = useState<AgentPayoutRow[]>([]);
  const [payoutBusyId, setPayoutBusyId] = useState<string | null>(null);
  const [showAllPayouts, setShowAllPayouts] = useState(false);

  //  NEW: Assign user to agent state

  const [assignTargetAgent, setAssignTargetAgent] = useState<AgentData | null>(null);
  const [assignUserSearch, setAssignUserSearch] = useState('');
  const [assignFilteredUsers, setAssignFilteredUsers] = useState<UserData[]>([]);
  const [selectedAssignUsers, setSelectedAssignUsers] = useState<UserData[]>([]);
  const [assigningUser, setAssigningUser] = useState(false);
  const [showOnlyUnassigned, setShowOnlyUnassigned] = useState(true);

  // Send Coins: the form itself lives in AdminSendCoinsModal (own state, so
  // typing there no longer re-renders this whole dashboard). We only keep
  // which player, if any, the modal should open with.
  const [sendCoinsPreset, setSendCoinsPreset] = useState<{ id: string; username: string } | null>(null);

  const [tournamentForm, setTournamentForm] = useState({
    name: '', description: '', startDate: '', startTime: '',
    buyInAmount: 1000, entryFee: 100, currency: 'playcoins' as 'playcoins' | 'pkcash',
    maxPlayers: 9, minPlayers: 2, startingChips: 5000,
    blindLevelDuration: 10, guaranteedPrize: 0,
  });

  // ============================================================================
  //  MAINTENANCE MODE & USER MANAGEMENT STATE

  // ============================================================================
  const { isOpen: isUserManageOpen, onOpen: onUserManageOpen, onClose: onUserManageClose } = useDisclosure();
  const [selectedUserForManage, setSelectedUserForManage] = useState<UserData | null>(null);
  const [userManageAction, setUserManageAction] = useState<'ban' | 'delete' | null>(null);
  const [banReason, setBanReason] = useState('');
  const [banDuration, setBanDuration] = useState(0); // 0 = permanent
  const [processingUserAction, setProcessingUserAction] = useState(false);
  const [userSearchFilter, setUserSearchFilter] = useState('');
  
  //  NEW: Geo Bypass State

  const [userGeoBypass, setUserGeoBypass] = useState(false);

  // Mass Delete State
  const [selectedUsersForDelete, setSelectedUsersForDelete] = useState<Set<string>>(new Set());
  const [massDeleteReason, setMassDeleteReason] = useState('');
  const [processingMassDelete, setProcessingMassDelete] = useState(false);
  const { isOpen: isMassDeleteOpen, onOpen: onMassDeleteOpen, onClose: onMassDeleteClose } = useDisclosure();

  // Maintenance Mode State
  const [maintenanceMode, setMaintenanceMode] = useState({
    enabled: false,
    message: '',
    scheduledAt: '',
    estimatedDuration: 30,
  });
  const [loadingMaintenance, setLoadingMaintenance] = useState(false);
  // Payments & KYC hold: persistent player notice + server-enforced blocks
  const [paymentsHold, setPaymentsHold] = useState({
    enabled: false, message: DEFAULT_PAYMENTS_HOLD_MESSAGE, blockPurchases: true, blockKyc: true, blockCashOuts: false, blockIap: false,
  });
  const [savingPaymentsHold, setSavingPaymentsHold] = useState(false);
  const [paymentsHoldDirty, setPaymentsHoldDirty] = useState(false);
  const [maintenanceCountdown, setMaintenanceCountdown] = useState<number | null>(null);
  // Poker intel rebuild (System tab)
  const [intelRebuilding, setIntelRebuilding] = useState(false);
  const [intelRebuildResult, setIntelRebuildResult] = useState<{ ok: boolean; msg: string } | null>(null);

  // Reset my own completion flag and relaunch the new-user tour, exactly as
  // a fresh signup sees it. Uses the existing ?startTutorial=true entry path.
  const handlePreviewTour = async () => {
    const uid = auth.currentUser?.uid;
    if (!uid) return;
    await tutorialService.resetTutorial(uid, 'main');
    window.location.href = '/?startTutorial=true';
  };

  // Card-privacy scrub (System tab): moves old shared privateCards maps
  // into the server-only store. One-time after the leak fix; idempotent.
  const [scrubbing, setScrubbing] = useState(false);
  const [scrubResult, setScrubResult] = useState<{ ok: boolean; msg: string } | null>(null);
  const handlePrivacyScrub = async () => {
    setScrubbing(true);
    setScrubResult(null);
    try {
      const token = await auth.currentUser?.getIdToken();
      const res = await fetch(`${API_BASE}/admin/scrubHandHistoryPrivateCards`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      });
      const r = await res.json();
      if (!res.ok) throw new Error(r.error || 'Scrub failed');
      setScrubResult({
        ok: true,
        msg: r.scrubbed > 0
          ? `Scanned ${r.scanned} recorded hands - moved ${r.scrubbed} card maps server-side. Done; no need to run again.`
          : `Scanned ${r.scanned} recorded hands - nothing left to scrub. All clean.`,
      });
    } catch (e: any) {
      setScrubResult({ ok: false, msg: e.message || 'Scrub failed' });
    } finally {
      setScrubbing(false);
    }
  };

  const handleRebuildIntel = async () => {
    setIntelRebuilding(true);
    setIntelRebuildResult(null);
    const r = await gameApiService.rebuildPokerIntel();
    setIntelRebuilding(false);
    setIntelRebuildResult(r.success
      ? { ok: true, msg: `Scanned ${r.handsScanned ?? 0} hands across all tables - ` +
          `${r.updated ?? 0} players updated, ${r.keptExisting ?? 0} kept their larger live count.` }
      : { ok: false, msg: r.error || 'Rebuild failed' });
  };

  // Announcement State
  const [announcementForm, setAnnouncementForm] = useState({
    title: '',
    message: '',
    type: 'info' as 'info' | 'warning' | 'maintenance' | 'update',
  });
  const [sendingAnnouncement, setSendingAnnouncement] = useState(false);

  // Force Kick State
  const [kickingAllPlayers, setKickingAllPlayers] = useState(false);
  const [showKickConfirm, setShowKickConfirm] = useState(false);

  // Reset data states
  const [showResetDialog, setShowResetDialog] = useState(false);
  const [resetConfirmText, setResetConfirmText] = useState('');
  const [isResetting, setIsResetting] = useState(false);
  const [resetProgress, setResetProgress] = useState('');
  const cancelResetRef = React.useRef<HTMLButtonElement>(null);

  //  NEW: Transaction Audit State

  const { isOpen: isUserAuditOpen, onOpen: onUserAuditOpen, onClose: onUserAuditClose } = useDisclosure();
  const [txFilters, setTxFilters] = useState<TransactionFilters>({
    searchTerm: '',
    transactionType: 'all',
    currency: 'all',
    status: 'all',
    dateFrom: '',
    dateTo: '',
    minAmount: '',
    maxAmount: '',
  });
  const [filteredTransactions, setFilteredTransactions] = useState<TransactionData[]>([]);
  // Filtering runs on a deferred copy so typing in the filter bar never blocks.
  const deferredTxFilters = useDeferredValue(txFilters);
  const [allTransactions, setAllTransactions] = useState<TransactionData[]>([]);
  const [userAuditData, setUserAuditData] = useState<UserAuditData | null>(null);
  const [userAuditTransactions, setUserAuditTransactions] = useState<TransactionData[]>([]);
  const [loadingUserAudit, setLoadingUserAudit] = useState(false);
  const [userLookupCache, setUserLookupCache] = useState<Map<string, { username: string; email: string }>>(new Map());
  const [txSearchLoading, setTxSearchLoading] = useState(false);

  //  NEW: Reports State

  const { isOpen: isReportDetailOpen, onOpen: onReportDetailOpen, onClose: onReportDetailClose } = useDisclosure();
  const [reports, setReports] = useState<UserReport[]>([]);
  const [reportStats, setReportStats] = useState<ReportStatsType | null>(null);
  const [reportsLoading, setReportsLoading] = useState(false);
  const [reportStatusFilter, setReportStatusFilter] = useState<ReportStatus | ''>('');
  const [reportSearchQuery, setReportSearchQuery] = useState('');
  const [selectedReport, setSelectedReport] = useState<UserReport | null>(null);
  const [reportActionLoading, setReportActionLoading] = useState(false);
  const [selectedReportAction, setSelectedReportAction] = useState<ReportAction>('none');
  const [reportActionNotes, setReportActionNotes] = useState('');
  const [tempBanDuration, setTempBanDuration] = useState<number>(24); // hours
  
  //  NEW: Appeals State

  const [appeals, setAppeals] = useState<BanAppeal[]>([]);
  const [appealsLoading, setAppealsLoading] = useState(false);
  const [appealStatusFilter, setAppealStatusFilter] = useState<'pending' | 'approved' | 'rejected' | ''>('pending');
  const [selectedAppeal, setSelectedAppeal] = useState<BanAppeal | null>(null);
  const [appealActionLoading, setAppealActionLoading] = useState(false);
  const [appealReviewNotes, setAppealReviewNotes] = useState('');
  const { isOpen: isAppealDetailOpen, onOpen: onAppealDetailOpen, onClose: onAppealDetailClose } = useDisclosure();
  
  //  NEW: Banned Users State

  const [bannedUsers, setBannedUsers] = useState<BannedUser[]>([]);
  const [bannedUsersLoading, setBannedUsersLoading] = useState(false);
  const [unbanLoading, setUnbanLoading] = useState<string | null>(null);
  
  //  NEW: Audit Log State

  const [auditLog, setAuditLog] = useState<AuditLogEntry[]>([]);
  const [auditLogLoading, setAuditLogLoading] = useState(false);
  const [auditActionFilter, setAuditActionFilter] = useState<string>('');
  
  //  NEW: Reports Sub-Tab State

  const [reportsSubTab, setReportsSubTab] = useState<'reports' | 'appeals' | 'banned' | 'audit'>('reports');


  // Filter users for agent search
  useEffect(() => {
    if (agentUserSearch.trim()) {
      const search = agentUserSearch.toLowerCase();
      const filtered = users.filter(u => 
        u.username.toLowerCase().includes(search) || 
        u.email.toLowerCase().includes(search) ||
        u.id.toLowerCase().includes(search)
      ).slice(0, 10);
      setAgentFilteredUsers(filtered);
    } else {
      setAgentFilteredUsers([]);
    }
  }, [agentUserSearch, users]);

  //  NEW: Filter users for assign to agent - shows all unassigned by default, search filters

  useEffect(() => {
    const search = assignUserSearch.toLowerCase().trim();
    const filtered = users.filter(u => {
      const matchesSearch = !search || 
        u.username.toLowerCase().includes(search) || 
        u.email.toLowerCase().includes(search) ||
        u.id.toLowerCase().includes(search);
      const matchesUnassigned = showOnlyUnassigned ? !u.referrerId : true;
      const notAlreadySelected = !selectedAssignUsers.find(su => su.id === u.id);
      return matchesSearch && matchesUnassigned && notAlreadySelected;
    });
    setAssignFilteredUsers(filtered);
  }, [assignUserSearch, users, showOnlyUnassigned, selectedAssignUsers]);

  //  NEW: Transaction filter effect

  useEffect(() => {
    if (!allTransactions.length) return;
    
    let filtered = [...allTransactions];
    
    // Search by user (username, email, or userId)
    if (deferredTxFilters.searchTerm) {
      const search = deferredTxFilters.searchTerm.toLowerCase();
      // First check if it's a userId
      const matchingUserIds = users
        .filter(u => 
          u.username.toLowerCase().includes(search) || 
          u.email.toLowerCase().includes(search) ||
          u.id.toLowerCase().includes(search)
        )
        .map(u => u.id);
      
      filtered = filtered.filter(tx => 
        tx.odid.toLowerCase().includes(search) ||
        matchingUserIds.includes(tx.odid)
      );
    }
    
    // Filter by type
    if (deferredTxFilters.transactionType !== 'all') {
      filtered = filtered.filter(tx => tx.type === deferredTxFilters.transactionType);
    }
    
    // Filter by currency
    if (deferredTxFilters.currency !== 'all') {
      filtered = filtered.filter(tx => tx.currency === deferredTxFilters.currency);
    }
    
    // Filter by status
    if (deferredTxFilters.status !== 'all') {
      filtered = filtered.filter(tx => tx.status === deferredTxFilters.status);
    }
    
    // Filter by date range
    if (deferredTxFilters.dateFrom) {
      const fromDate = new Date(deferredTxFilters.dateFrom);
      fromDate.setHours(0, 0, 0, 0);
      filtered = filtered.filter(tx => tx.createdAt >= fromDate);
    }
    
    if (deferredTxFilters.dateTo) {
      const toDate = new Date(deferredTxFilters.dateTo);
      toDate.setHours(23, 59, 59, 999);
      filtered = filtered.filter(tx => tx.createdAt <= toDate);
    }
    
    // Filter by amount range
    if (deferredTxFilters.minAmount) {
      const min = parseFloat(deferredTxFilters.minAmount);
      if (!isNaN(min)) {
        filtered = filtered.filter(tx => Math.abs(tx.amount) >= min);
      }
    }
    
    if (deferredTxFilters.maxAmount) {
      const max = parseFloat(deferredTxFilters.maxAmount);
      if (!isNaN(max)) {
        filtered = filtered.filter(tx => Math.abs(tx.amount) <= max);
      }
    }
    
    setFilteredTransactions(filtered.slice(0, 200));
  }, [deferredTxFilters, allTransactions, users]);

  //  NEW: Lookup user info for transaction display

  const getUserDisplay = (odid: string): { username: string; email: string } => {
    if (odid === 'PLATFORM') return { username: 'PLATFORM', email: '' };
    const cached = userLookupCache.get(odid);
    if (cached) return cached;
    const user = users.find(u => u.id === odid);
    if (user) {
      const display = { username: user.username, email: user.email };
      setUserLookupCache(prev => new Map(prev).set(odid, display));
      return display;
    }
    return { username: odid.substring(0, 8) + '...', email: '' };
  };

  //  NEW: Load full user audit data

  const loadUserAudit = async (odid: string) => {
    setLoadingUserAudit(true);
    try {
      // Load user profile
      const userDoc = await getDoc(doc(db, 'users', odid));
      const walletDoc = await getDoc(doc(db, 'wallets', odid));
      
      if (!userDoc.exists()) {
        toast({ title: 'User not found', status: 'error', duration: 3000 });
        setLoadingUserAudit(false);
        return;
      }
      
      const userData = userDoc.data();
      const walletData = walletDoc.exists() ? walletDoc.data() : {};
      
      // Get referrer name if exists
      let referrerName = '';
      if (userData.referrerId) {
        const referrerDoc = await getDoc(doc(db, 'users', userData.referrerId));
        if (referrerDoc.exists()) {
          referrerName = referrerDoc.data().username || referrerDoc.data().displayName || '';
        }
      }
      
      // Calculate totals from transactions
      const userTxs = allTransactions.filter(tx => tx.odid === odid);
      let totalDeposited = 0, totalWithdrawn = 0;
      userTxs.forEach(tx => {
        if ((tx.type === 'deposit' || tx.type === 'purchase') && tx.currency === 'pkcash') {
          totalDeposited += Math.abs(tx.amount);
        }
        if (tx.type === 'withdrawal' || tx.type === 'redemption') {
          totalWithdrawn += Math.abs(tx.amount);
        }
      });
      
      setUserAuditData({
        id: odid,
        email: userData.email || '',
        username: userData.username || userData.displayName || 'Unknown',
        displayName: userData.displayName,
        playCoins: walletData.playCoins || 0,
        pkCash: walletData.pkCash || 0,
        totalDeposited,
        totalWithdrawn,
        gamesPlayed: userData.gamesPlayed || userData.stats?.gamesPlayed || 0,
        handsWon: userData.handsWon || userData.stats?.handsWon || 0,
        referrerId: userData.referrerId,
        referrerName,
        isAgent: userData.isAgent || false,
        agentTier: userData.agentTier,
        kycStatus: userData.kycStatus,
        createdAt: userData.createdAt?.toDate() || new Date(),
        lastActive: userData.lastActive?.toDate(),
      });
      
      setUserAuditTransactions(userTxs);
      onUserAuditOpen();
    } catch (error) {
      console.error('Error loading user audit:', error);
      toast({ title: 'Failed to load user data', status: 'error', duration: 3000 });
    } finally {
      setLoadingUserAudit(false);
    }
  };

  //  NEW: Export transactions to CSV

  const exportTransactionsCSV = () => {
    const headers = ['Date', 'Type', 'User ID', 'Username', 'Amount', 'Currency', 'Status', 'Description'];
    const rows = filteredTransactions.map(tx => {
      const user = getUserDisplay(tx.odid);
      return [
        tx.createdAt.toISOString(),
        tx.type,
        tx.odid,
        user.username,
        tx.amount.toString(),
        tx.currency,
        tx.status,
        tx.description || '',
      ].map(v => `"${v}"`).join(',');
    });
    
    const csv = [headers.join(','), ...rows].join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `transactions_${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
    URL.revokeObjectURL(url);
    
    toast({ title: 'Exported', description: `${filteredTransactions.length} transactions`, status: 'success', duration: 2000 });
  };

  const loadDashboardData = async () => {
    try {
      setLoading(true);
      
      // ============================================================================
      // LOAD USERS
      // ============================================================================
      const usersSnap = await getDocs(collection(db, 'users'));
      const usersData: UserData[] = [];

      usersSnap.docs.forEach(docSnap => {
        const d = docSnap.data();
        usersData.push({
          id: docSnap.id,
          email: d.email || '',
          username: d.username || d.displayName || 'Unknown',
          playCoins: 0,
          pkCash: 0,
          gamesPlayed: d.gamesPlayed || 0,
          referrerId: d.referrerId,
          createdAt: d.createdAt?.toDate() || new Date(),
          kycStatus: d.kycStatus,
          role: d.role,
          banned: d.banned || false,
          banReason: d.banReason,
          banExpiresAt: d.banExpiresAt?.toDate(),
        });
      });

      // ============================================================================
      // LOAD WALLETS
      // ============================================================================
      const walletsSnap = await getDocs(collection(db, 'wallets'));
      let totalPC = 0, totalPK = 0;
      const walletMap: { [userId: string]: { playCoins: number; pkCash: number } } = {};

      walletsSnap.docs.forEach(docSnap => {
        const d = docSnap.data();
        const pc = d.playCoins || 0;
        const pk = d.pkCash || 0;
        totalPC += pc;
        totalPK += pk;
        walletMap[docSnap.id] = { playCoins: pc, pkCash: pk };
      });

      usersData.forEach(user => {
        if (walletMap[user.id]) {
          user.playCoins = walletMap[user.id].playCoins;
          user.pkCash = walletMap[user.id].pkCash;
        }
      });

      setUsers(usersData);

      // ============================================================================
      // LOAD PRESENCE (Active Users)
      // ============================================================================
      const presenceSnap = await getDocs(collection(db, 'presence'));
      const now = Date.now();
      const activeUsers = presenceSnap.docs.filter(docSnap => {
        const lastSeen = docSnap.data().lastSeen?.toMillis() || 0;
        return now - lastSeen < 5 * 60 * 1000;
      }).length;

      // ============================================================================
      // LOAD TABLES
      // ============================================================================
      const tablesSnap = await getDocs(collection(db, 'tables'));
      let activeTables = 0;
      tablesSnap.docs.forEach(docSnap => {
        const data = docSnap.data();
        const playerCount = data.players?.length || 0;
        if (playerCount > 0) activeTables++;
      });

      // ============================================================================
      // LOAD TRANSACTIONS & CALCULATE RAKE/DEPOSITS/WITHDRAWALS
      // ============================================================================
      const txSnap = await getDocs(
        query(collection(db, 'transactions'), orderBy('timestamp', 'desc'), limit(1000))
      );
      
      let rake = 0, deposits = 0, withdrawals = 0;
      const txData: TransactionData[] = [];

      txSnap.docs.forEach(docSnap => {
        const d = docSnap.data();
        const txType = d.type || '';
        const amount = Math.abs(d.amount || 0);
        const currency = d.currency || 'playcoins';

        if (txType === 'rake' || txType === 'rake_earned') {
          rake += amount;
        }
        
        if ((txType === 'deposit' || txType === 'purchase') && currency === 'pkcash') {
          deposits += d.usdPaid || amount;
        }
        
        if (txType === 'withdrawal') {
          withdrawals += amount;
        }

        txData.push({
          id: docSnap.id,
          odid: d.userId || d.odid || '',
          type: txType,
          amount: d.amount || 0,
          currency: currency,
          status: d.status || 'completed',
          description: d.description || '',
          createdAt: d.timestamp?.toDate() || d.createdAt?.toDate() || new Date(),
          tableId: d.tableId,
          handId: d.handId,
          tournamentId: d.tournamentId,
          metadata: d,
        });
      });

      setAllTransactions(txData);
      setTransactions(txData.slice(0, 50));
      setFilteredTransactions(txData.slice(0, 100));

      // ============================================================================
      // LOAD PLATFORM RAKE TOTALS
      // ============================================================================
      try {
        const rakeStatsDoc = await getDoc(doc(db, 'platformStats', 'rake'));
        if (rakeStatsDoc.exists()) {
          const rakeData = rakeStatsDoc.data();
          rake = (rakeData.totalPKCashRake || 0) + (rakeData.totalPlayCoinsRake || 0);
        }
      } catch (e) {
        console.log('No platform rake stats yet');
      }

      // ============================================================================
      // LOAD TOURNAMENT RAKE STATS
      // ============================================================================
      let tournamentRakeTotal = 0;
      let tournamentRakeAgentPaid = 0;
      let tournamentRakeHouseNet = 0;
      let tournamentsRaked = 0;

      try {
        const tournamentRakeStatsDoc = await getDoc(doc(db, 'platformStats', 'tournamentRake'));
        if (tournamentRakeStatsDoc.exists()) {
          const trData = tournamentRakeStatsDoc.data();
          tournamentRakeTotal = trData.totalPKCashRake || 0;
          tournamentsRaked = trData.totalTournamentsRaked || 0;
        }

        const trTxSnap = await getDocs(
          query(collection(db, 'tournamentRake'), orderBy('timestamp', 'desc'), limit(20))
        );
        
        const trTxData: TournamentRakeData[] = [];
        trTxSnap.docs.forEach(docSnap => {
          const d = docSnap.data();
          const agentTotal = (d.agentPayouts || []).reduce((sum: number, p: any) => sum + (p.amount || 0), 0);
          tournamentRakeAgentPaid += agentTotal;
          
          trTxData.push({
            id: docSnap.id,
            tournamentId: d.tournamentId || '',
            tournamentName: d.tournamentName || '',
            totalBuyIns: d.totalBuyIns || 0,
            totalRake: d.totalRake || 0,
            houseRake: d.houseRake || 0,
            agentPayouts: d.agentPayouts || [],
            playerCount: d.playerCount || 0,
            timestamp: d.timestamp?.toDate() || new Date(),
            currency: d.currency || 'pkcash',
          });
        });

        setTournamentRakeTransactions(trTxData);
        tournamentRakeHouseNet = tournamentRakeTotal - tournamentRakeAgentPaid;
      } catch (e) {
        console.log('No tournament rake stats yet');
      }

      // ============================================================================
      //  NEW: LOAD REVENUE STATS

      // ============================================================================
      let voicePassRevenue = 0;
      let voicePassUnlimitedCount = 0;
      let voicePassRegularCount = 0;
      let voiceChatFeeRevenue = 0;
      let voiceChatFeeCount = 0;
      let gameItemRevenue = 0;
      let gameItemCount = 0;
      let totalRevenue = 0;

      try {
        const revenueStatsDoc = await getDoc(doc(db, 'platformStats', 'revenue'));
        if (revenueStatsDoc.exists()) {
          const revenueData = revenueStatsDoc.data();
          voicePassRevenue = revenueData.voicePassRevenue || 0;
          voicePassUnlimitedCount = revenueData.voicePassUnlimitedCount || 0;
          voicePassRegularCount = revenueData.voicePassRegularCount || 0;
          voiceChatFeeRevenue = revenueData.voiceChatFeeRevenue || 0;
          voiceChatFeeCount = revenueData.voiceChatFeeCount || 0;
          gameItemRevenue = revenueData.gameItemRevenue || 0;
          gameItemCount = revenueData.gameItemCount || 0;
          totalRevenue = revenueData.totalRevenue || 0;
        }
      } catch (e) {
        console.log('No revenue stats yet');
      }

      // Calculate total revenue if not stored (fallback)
      if (totalRevenue === 0) {
        totalRevenue = rake + tournamentRakeHouseNet + voicePassRevenue + voiceChatFeeRevenue + gameItemRevenue;
      }

      // ============================================================================
      //  NEW: LOAD REDEMPTIONS

      // ============================================================================
      let pendingRedemptions = 0;
      let pendingRedemptionAmount = 0;

      try {
        const redemptionsSnap = await getDocs(
          query(collection(db, 'redemptions'), orderBy('requestedAt', 'desc'), limit(50))
        );

        const redemptionsData: RedemptionData[] = [];
        redemptionsSnap.docs.forEach(docSnap => {
          const d = docSnap.data();
          const userData = usersData.find(u => u.id === d.userId);
          
          if (d.status === 'pending_review') {
            pendingRedemptions++;
            pendingRedemptionAmount += d.amount || 0;
          }

          redemptionsData.push({
            id: docSnap.id,
            odD: d.userId || '',
            username: userData?.username || d.username,
            email: userData?.email || d.email,
            amount: d.amount || 0,
            status: d.status || 'pending_review',
            requestedAt: d.requestedAt?.toDate() || new Date(),
            kycStatus: d.kycStatus || d.complianceSnapshot?.kycStatus || 'verified', //  FIX: Default to verified (backend validated)

            playthroughComplete: d.complianceSnapshot?.playthroughComplete ?? true, //  FIX: If request exists, playthrough passed

            stripeConnectAccountId: d.stripeConnectAccountId,
            reviewNote: d.reviewNote,
            payoutMethod: d.payoutMethod || null,
            payoutDestination: d.payoutDestination || null,
            kycName: d.kycName || null,
            payoutBatchId: d.payoutBatchId || null,
            payoutError: d.payoutError || null,
          });
        });

        setRedemptions(redemptionsData);
      } catch (e) {
        console.log('No redemptions yet');
      }

      // ============================================================================
      //  NEW: LOAD PLATFORM SETTINGS

      // ============================================================================
      try {
        const settingsDoc = await getDoc(doc(db, 'platformSettings', 'default'));
        if (settingsDoc.exists()) {
          setPlatformSettings({ ...DEFAULT_PLATFORM_SETTINGS, ...settingsDoc.data() } as PlatformSettings);
        }
      } catch (e) {
        console.log('No platform settings yet, using defaults');
      }

      // ============================================================================
      //  NEW: LOAD BYPASS CODES

      // ============================================================================
      let totalBypassCodes = 0;
      let activeBypassCodes = 0;
      let bypassCodeUsageThisMonth = 0;

      try {
        const allCodes = await bypassCodeService.getAllCodes();
        setBypassCodes(allCodes);
        totalBypassCodes = allCodes.length;
        activeBypassCodes = allCodes.filter(c => c.active).length;

        // Get recent usage logs
        const usageLogs = await bypassCodeService.getRecentUsage(50);
        setBypassCodeUsageLogs(usageLogs);

        // Calculate this month's usage
        const startOfMonth = new Date();
        startOfMonth.setDate(1);
        startOfMonth.setHours(0, 0, 0, 0);
        bypassCodeUsageThisMonth = usageLogs.filter(log => log.usedAt >= startOfMonth).length;
      } catch (e) {
        console.log('Error loading bypass codes:', e);
      }

      // ============================================================================
      // LOAD AGENTS
      // ============================================================================
      const agentsData = await referralService.getAllAgents();
      setAgents(agentsData.map(a => ({
        id: a.id,
        displayName: a.displayName,
        email: a.email,
        tier: a.tier,
        totalReferrals: a.totalReferrals,
        totalRakeEarned: a.totalRakeEarned,
        active: a.active,
        role: a.role || 'agent',
        managerId: a.managerId,
        code: a.customCode || a.referralCode,
        customCode: a.customCode,
        totalPurchaseCommission: a.totalPurchaseCommission || 0,
        totalOverrideEarned: a.totalOverrideEarned || 0,
        overrideRakePercent: a.overrideRakePercent,
        canHostTournaments: (a as any).canHostTournaments === true,
        mediaAllowed: (a as any).mediaAllowed || 'none',
        mediaComped: (a as any).mediaComped === true,
        creatorGroupId: (a as any).creatorGroupId,
      })));
      gameApiService.adminAgentPayouts('open').then(r => { if (r.success) setAgentPayoutRequests(r.payouts); }).catch(() => {});
      gameApiService.adminHostTournaments('pending').then(r => { if (r.success) setPendingHostTournaments(r.tournaments); }).catch(() => {});

      // ============================================================================
      // CALCULATE NEW USERS THIS WEEK
      // ============================================================================
      const weekAgo = new Date();
      weekAgo.setDate(weekAgo.getDate() - 7);
      const newUsers = usersData.filter(u => u.createdAt >= weekAgo).length;

      // ============================================================================
      //  NEW: LOAD REPORTS

      // ============================================================================
      let pendingReports = 0;
      let totalReports = 0;
      try {
        const reportStatsData = await reportService.getReportStats();
        pendingReports = reportStatsData.pendingReports;
        totalReports = reportStatsData.totalReports;
        setReportStats(reportStatsData);
        
        // Load reports
        const reportsData = await reportService.getReports();
        setReports(reportsData);
      } catch (e) {
        console.log('No reports yet or error loading:', e);
      }

      // ============================================================================
      // SET ALL STATS
      // ============================================================================
      setStats({
        totalUsers: usersData.length,
        activeUsers,
        totalTables: tablesSnap.docs.length,
        activeTables,
        totalPlayCoins: totalPC,
        totalPKCash: totalPK,
        totalRake: rake,
        totalDeposits: deposits,
        totalWithdrawals: withdrawals,
        newUsersThisWeek: newUsers,
        totalAgents: agentsData.filter(a => a.active).length,
        tournamentRakeTotal,
        tournamentRakeAgentPaid,
        tournamentRakeHouseNet,
        tournamentsRaked,
        pendingRedemptions,
        pendingRedemptionAmount,
        totalBypassCodes,
        activeBypassCodes,
        bypassCodeUsageThisMonth,
        pendingReports,
        totalReports,
        // Push notification stats (loaded elsewhere or defaults)
        pushEnabledUsers: 0,
        androidPushUsers: 0,
        iosPushUsers: 0,
        totalAnnouncements: 0,
        //  Revenue tracking

        voicePassRevenue,
        voicePassUnlimitedCount,
        voicePassRegularCount,
        voiceChatFeeRevenue,
        voiceChatFeeCount,
        gameItemRevenue,
        gameItemCount,
        totalRevenue,
      });

    } catch (error) {
      console.error('Dashboard error:', error);
      toast({ title: 'Error loading data', status: 'error', duration: 3000 });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const unsub = tournamentService.subscribeToAllTournaments(setTournaments);
    return () => unsub();
  }, []);

  //  AUTO-SET: Mark current user as admin when they access admin dashboard

  useEffect(() => {
    // 🔒 LOCAL DEVELOPMENT ONLY. This grants the current user the isAdmin
    // flag, which the server's admin check reads - in production it would be
    // a self-service promotion to full admin for anyone who loads this page,
    // so it is hard-gated to a local dev host AND a non-production build,
    // and the Firestore rules independently reject isAdmin writes from
    // clients. Convenience for the emulator, impossible in prod.
    const isLocalDev = process.env.NODE_ENV !== 'production'
      && ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);
    if (!isLocalDev) return;
    const setAdminFlag = async () => {
      const currentUser = auth.currentUser;
      if (currentUser) {
        try {
          const userRef = doc(db, 'users', currentUser.uid);
          const userDoc = await getDoc(userRef);
          if (userDoc.exists() && !userDoc.data()?.isAdmin) {
            await updateDoc(userRef, { isAdmin: true });
            console.log('✅ [LOCAL DEV] Admin flag set for user:', currentUser.uid);
          }
        } catch (error) {
          console.error('Error setting admin flag:', error);
        }
      }
    };
    setAdminFlag();
  }, []);

  useEffect(() => { loadDashboardData(); }, []);

  const handleRefresh = async () => {
    setRefreshing(true);
    await loadDashboardData();
    setRefreshing(false);
    toast({ title: 'Refreshed', status: 'success', duration: 2000 });
  };

  const handleCleanup = async () => {
    //  FIX: Call server API instead of client-side service

    try {
      const token = await auth.currentUser?.getIdToken();
      const response = await fetch(`${API_BASE}/cleanupAllEmptyTables`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
      const result = await response.json();
      if (result.success) {
        toast({ title: `Deleted ${result.tablesDeleted} tables`, status: 'success', duration: 3000 });
      } else {
        toast({ title: result.error || 'Cleanup failed', status: 'error', duration: 3000 });
      }
    } catch (error) {
      console.error('Cleanup error:', error);
      toast({ title: 'Cleanup failed', status: 'error', duration: 3000 });
    }
    await loadDashboardData();
  };

  const handleMoneyAudit = async () => {
    try {
      const token = await auth.currentUser?.getIdToken();
      const res = await fetch(`${API_BASE}/admin/runMoneyAudit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ windowHours: 26 }),
      });
      const r = await res.json();
      if (!res.ok) throw new Error(r.error || 'Audit failed');
      if ((r.alarms || []).length > 0) {
        const lines = r.alarms.slice(0, 4).map((a: any) =>
          `${String(a.userId).substring(0, 8)} on ${a.tableId}: ${a.amount}`).join('; ');
        toast({
          title: `${r.alarms.length} dropped buy-in(s) found, ${(r.refunded || []).length} auto-refunded`,
          description: `${lines}. Players were repaid automatically with receipts. A payment path is misbehaving - tell Claude which flow you ran.`,
          status: 'warning', duration: 12000, isClosable: true,
        });
      } else {
        toast({
          title: 'Money audit clean',
          description: `${r.buyInsChecked} buy-in(s) checked: ${r.settled} settled, ${r.onTable} on tables, ${(r.pending || []).length} still seated. Every coin accounted for.`,
          status: 'success', duration: 7000,
        });
      }
    } catch (error: any) {
      toast({ title: error.message || 'Audit failed', status: 'error', duration: 4000 });
    }
  };

  const handleRefundStranded = async () => {
    if (!window.confirm('Scan every wallet for chips left on deleted tables and refund them?')) return;
    try {
      const token = await auth.currentUser?.getIdToken();
      const res = await fetch(`${API_BASE}/admin/refundStrandedChips`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      });
      const r = await res.json();
      if (!res.ok) throw new Error(r.error || 'Sweep failed');
      toast({
        title: r.entriesCleared > 0
          ? `Refunded ${r.totalRefunded.toLocaleString()} across ${r.players} player(s) (${r.entriesCleared} dead-table entries)`
          : 'No stranded chips found - every entry points at a live table',
        status: 'success', duration: 6000,
      });
    } catch (error: any) {
      toast({ title: error.message || 'Sweep failed', status: 'error', duration: 4000 });
    }
  };

  const handleResetFeaturedTables = async () => {
    if (!window.confirm('Reset all featured tables? This will delete and recreate them with fresh bots.')) return;
    try {
      const token = await auth.currentUser?.getIdToken();
      // Step 1: Delete existing featured tables
      const resetRes = await fetch(`${API_BASE}/admin/resetFeaturedTables`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      });
      const resetResult = await resetRes.json();
      toast({ title: `Reset: ${resetResult.message || 'Done'}`, status: 'info', duration: 3000 });

      // Step 2: Recreate featured tables via callable function
      const { httpsCallable } = await import('firebase/functions');
      const { functions } = await import('../services/firebase');
      const ensureFn = httpsCallable(functions, 'ensureFeaturedTables');
      await ensureFn({});
      toast({ title: 'Featured tables recreated with bots', status: 'success', duration: 3000 });
    } catch (error: any) {
      console.error('Reset featured tables error:', error);
      toast({ title: error.message || 'Reset failed', status: 'error', duration: 3000 });
    }
    await loadDashboardData();
  };

  // ============================================================================
  //  NEW: TAX REPORT HANDLERS

  // ============================================================================
  const loadTaxReport = async (year: number = taxYear) => {
    setLoadingTaxReport(true);
    try {
      const report = await taxService.getPlatform1099Report(year);
      setTaxReport(report);
    } catch (error) {
      console.error('Error loading tax report:', error);
      toast({ title: 'Error loading tax report', status: 'error', duration: 3000 });
    } finally {
      setLoadingTaxReport(false);
    }
  };

  // ============================================================================
  //  NEW: BYPASS CODE HANDLERS

  // ============================================================================
  const handleCreateBypassCode = async () => {
    const currentUser = auth.currentUser;
    if (!currentUser) return;

    setCreatingBypassCode(true);
    try {
      const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
      const username = userDoc.exists() ? userDoc.data().username || 'Admin' : 'Admin';

      const newCode = await bypassCodeService.createAdminBypassCode(
        currentUser.uid,
        username,
        bypassCodeDescription || undefined
      );

      toast({
        title: 'Bypass Code Created!',

        description: `Code: ${newCode.code}`,
        status: 'success',
        duration: 5000,
      });

      setBypassCodeDescription('');
      onBypassCodeClose();
      await loadDashboardData();
    } catch (error: any) {
      console.error('Error creating bypass code:', error);
      toast({
        title: 'Error creating code',
        description: error.message || 'Unknown error',
        status: 'error',
        duration: 3000,
      });
    } finally {
      setCreatingBypassCode(false);
    }
  };

  const handleToggleBypassCode = async (codeId: string, currentlyActive: boolean) => {
    try {
      if (currentlyActive) {
        await bypassCodeService.deactivateCode(codeId);
        toast({ title: 'Code deactivated', status: 'info', duration: 2000 });
      } else {
        await bypassCodeService.reactivateCode(codeId);
        toast({ title: 'Code reactivated', status: 'success', duration: 2000 });
      }
      await loadDashboardData();
    } catch (error) {
      toast({ title: 'Error updating code', status: 'error', duration: 3000 });
    }
  };

  const handleDeleteBypassCode = async (codeId: string) => {
    if (!window.confirm('Delete this bypass code permanently?')) return;

    try {
      await bypassCodeService.deleteCode(codeId);
      toast({ title: 'Code deleted', status: 'info', duration: 2000 });
      await loadDashboardData();
    } catch (error) {
      toast({ title: 'Error deleting code', status: 'error', duration: 3000 });
    }
  };

  const handleCopyBypassCode = (code: string, codeId: string) => {
    navigator.clipboard.writeText(code);
    setCopiedCodeId(codeId);
    setTimeout(() => setCopiedCodeId(null), 2000);
    toast({ title: 'Copied!', description: `Code ${code} copied to clipboard`, status: 'success', duration: 2000 });

  };

  // Filter bypass codes
  const filteredBypassCodes = bypassCodes.filter(code => {
    const matchesFilter = bypassCodeFilter === 'all' || code.ownerType === bypassCodeFilter;
    const matchesSearch = !bypassCodeSearch.trim() || 
      code.code.toLowerCase().includes(bypassCodeSearch.toLowerCase()) ||
      code.ownerName.toLowerCase().includes(bypassCodeSearch.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  // ============================================================================
  //  NEW: REDEMPTION HANDLERS

  // ============================================================================
  const handleRedemptionClick = (redemption: RedemptionData, action: 'approve' | 'reject') => {
    setSelectedRedemption(redemption);
    setRedemptionAction(action);
    setRedemptionNote('');
    setPayoutReference('');
    setUsdcCode('');
    setUsdcAwaitingCode(!!redemption.payoutBatchId);
    onRedemptionOpen();
  };

  const handleProcessRedemption = async () => {
    if (!selectedRedemption || !redemptionAction) return;

    setProcessingRedemption(true);
    try {
      const redemptionRef = doc(db, 'redemptions', selectedRedemption.id);
      
      if (redemptionAction === 'approve') {
        // Approve once, from pending_review only. A redemption already
        // approved or processing keeps its server-side status (a live USDC
        // batch must never be flipped back to approved by a second click).
        if (selectedRedemption.status === 'pending_review') {
          await updateDoc(redemptionRef, {
            status: 'approved',
            approvedAt: Timestamp.now(),
            approvedBy: auth.currentUser?.uid,
            reviewNote: redemptionNote || null,
            statusHistory: arrayUnion({ status: 'approved', changedAt: new Date().toISOString(), changedBy: auth.currentUser?.uid, reason: redemptionNote || 'Approved by admin' }),
            updatedAt: Timestamp.now(),
          });
        }

        // Pay it: by hand (PayPal, with the transaction id) or USDC via
        // NOWPayments (send, then the emailed 2FA code). Completion is one
        // server transaction: status, held balance, tax total.
        const method = selectedRedemption.payoutMethod || 'paypal';
        try {
          if (method === 'usdc') {
            if (usdcAwaitingCode) {
              const r = await executeRedemption({ redemptionId: selectedRedemption.id, action: 'verifyUsdc', code: usdcCode.trim() });
              toast({ title: 'USDC payout released', description: r.message || 'Completes when the network confirms.', status: 'success', duration: 6000 });
            } else {
              const r = await executeRedemption({ redemptionId: selectedRedemption.id, action: 'sendUsdc' });
              if (r.needsVerification) {
                setUsdcAwaitingCode(true);
                setProcessingRedemption(false);
                toast({ title: 'Check your email', description: r.message || 'Enter the NOWPayments verification code to release the payout.', status: 'info', duration: 8000 });
                await loadDashboardData();
                return; // keep the modal open for the code
              }
            }
          } else {
            await executeRedemption({ redemptionId: selectedRedemption.id, action: 'markPaid', payoutReference: payoutReference.trim() });
            toast({ title: 'Marked paid', description: `$${selectedRedemption.amount.toFixed(2)} to ${selectedRedemption.username} via PayPal. Held balance released.`, status: 'success', duration: 5000 });
          }
        } catch (payoutError: any) {
          toast({ title: 'Approved, payout not completed', description: payoutError?.message || 'Try again or pay by hand and mark paid.', status: 'warning', duration: 8000 });
        }
      } else {
        // Reject - return funds to user
        await updateDoc(redemptionRef, {
          status: 'rejected',
          rejectedAt: Timestamp.now(),
          rejectedBy: auth.currentUser?.uid,
          reviewNote: redemptionNote || 'Rejected by admin',
          statusHistory: [
            { status: 'rejected', changedAt: new Date().toISOString(), changedBy: auth.currentUser?.uid, reason: redemptionNote || 'Rejected by admin' }
          ],
          updatedAt: Timestamp.now(),
        });

        // Return held funds
        const walletRef = doc(db, 'wallets', selectedRedemption.odD);  //  FIX: Use odD (userId stored in odD field)

        const walletSnap = await getDoc(walletRef);
        if (walletSnap.exists()) {
          const walletData = walletSnap.data();
          await updateDoc(walletRef, {
            pkCash: (walletData.pkCash || 0) + selectedRedemption.amount,
            pkCashHeld: Math.max(0, (walletData.pkCashHeld || 0) - selectedRedemption.amount),
            updatedAt: Timestamp.now(),
          });
        }

        toast({
          title: 'Redemption Rejected',

          description: `$${selectedRedemption.amount.toFixed(2)} returned to ${selectedRedemption.username}'s wallet.`,
          status: 'info',
          duration: 5000,
        });
      }

      onRedemptionClose();
      await loadDashboardData();
    } catch (error) {
      console.error('Error processing redemption:', error);
      toast({ title: 'Error processing redemption', status: 'error', duration: 3000 });
    } finally {
      setProcessingRedemption(false);
    }
  };

  // ============================================================================
  //  NEW: PLATFORM SETTINGS HANDLERS

  // ============================================================================
  const handleSaveSettings = async () => {
    setSavingSettings(true);
    try {
      // Firestore rejects `undefined` values and fails the WHOLE write, so a
      // single unset optional field (amoeDailyPlatformLimit did exactly this)
      // silently discarded every other setting - including the geo
      // restricted-states list. Strip undefined keys before writing.
      const payload: Record<string, any> = {
        ...platformSettings,
        updatedAt: Timestamp.now(),
        updatedBy: auth.currentUser?.uid,
      };
      Object.keys(payload).forEach(k => {
        if (payload[k] === undefined) delete payload[k];
      });
      await setDoc(doc(db, 'platformSettings', 'default'), payload);

      toast({
        title: 'Settings Saved',
        description: `Platform settings updated. Blocked states: ${(platformSettings.restrictedStates || []).join(', ') || 'none'}`,
        status: 'success',
        duration: 4000,
      });
    } catch (error) {
      console.error('Error saving settings:', error);
      toast({
        title: 'Error saving settings',
        description: error instanceof Error ? error.message : 'Settings were NOT saved - check the console',
        status: 'error',
        duration: 8000,
      });
    } finally {
      setSavingSettings(false);
    }
  };

  const toggleRestrictedState = (stateCode: string) => {
    const current = platformSettings.restrictedStates || [];
    if (current.includes(stateCode)) {
      setPlatformSettings({
        ...platformSettings,
        restrictedStates: current.filter(s => s !== stateCode),
      });
    } else {
      setPlatformSettings({
        ...platformSettings,
        restrictedStates: [...current, stateCode],
      });
    }
  };

  // ============================================================================
  // GENERATE WEEKLY TOURNAMENTS
  // ============================================================================
  const handleGenerateWeeklyTournaments = async () => {
    setGeneratingTournaments(true);
    try {
      const result = await tournamentService.generateWeeklyTournaments(auth.currentUser?.uid || 'ADMIN');
      toast({
        title: 'Tournaments Generated!',

        description: `Created ${result.created} tournaments (${result.skipped} skipped)`,
        status: 'success',
        duration: 5000,
      });
      await loadDashboardData();
    } catch (error: any) {
      console.error('Failed to generate tournaments:', error);
      toast({
        title: 'Generation Failed',
        description: error.message || 'Could not generate tournaments',
        status: 'error',
        duration: 5000,
      });
    } finally {
      setGeneratingTournaments(false);
    }
  };

  const handleQuickCreateTournament = async (tier: TournamentTier) => {
    try {
      const config = TOURNAMENT_TIERS[tier];
      const now = new Date();
      const targetDays = [1, 3, 5];
      let nextDate: Date | null = null;

      for (let daysAhead = 0; daysAhead <= 7; daysAhead++) {
        const checkDate = new Date(now);
        checkDate.setDate(checkDate.getDate() + daysAhead);
        
        if (targetDays.includes(checkDate.getDay())) {
          const tournamentDate = new Date(checkDate);
          tournamentDate.setHours(17, 30, 0, 0);
          
          if (tournamentDate > now) {
            nextDate = tournamentDate;
            break;
          }
        }
      }

      if (!nextDate) {
        nextDate = new Date(now.getTime() + (24 * 60 * 60 * 1000));
        nextDate.setHours(17, 30, 0, 0);
      }

      await tournamentService.createTournamentFromTier(
        tier,
        nextDate,
        auth.currentUser?.uid || 'ADMIN'
      );

      toast({
        title: `${config.icon} Tournament Created!`,
        description: `${config.displayName} scheduled for ${nextDate.toLocaleString()}`,
        status: 'success',
        duration: 5000,
      });
      await loadDashboardData();
    } catch (error: any) {
      toast({
        title: 'Creation Failed',
        description: error.message,
        status: 'error',
        duration: 3000,
      });
    }
  };

  // =========================================================================
  //  TOURNAMENT ADMIN FUNCTIONS

  // =========================================================================

  const handleForceStartTournament = async (tournamentId: string) => {
    if (!window.confirm('Force start this tournament? This will create tables and seat players.')) return;
    
    try {
      const response = await fetch(`${API_BASE}/startTournament`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${await auth.currentUser?.getIdToken()}`
        },
        body: JSON.stringify({ tournamentId }),
      });
      const result = await response.json();
      
      if (result.success) {
        toast({
          title: 'Tournament Started!',

          description: `Created ${result.tables?.length || 0} tables with ${result.playerCount || 0} players`,
          status: 'success',
          duration: 5000,
        });
        await loadDashboardData();
      } else {
        throw new Error(result.error || 'Failed to start tournament');
      }
    } catch (error: any) {
      toast({
        title: 'Start Failed',
        description: error.message,
        status: 'error',
        duration: 3000,
      });
    }
  };

  const handleAdvanceBlindLevel = async (tournamentId: string) => {
    try {
      const response = await fetch(`${API_BASE}/advanceBlindLevel`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${await auth.currentUser?.getIdToken()}`
        },
        body: JSON.stringify({ tournamentId }),
      });
      const result = await response.json();
      
      if (result.success) {
        toast({
          title: '⬆ Blinds Advanced',

          description: `Level ${result.previousLevel} → ${result.newLevel} (${result.blinds?.smallBlind}/${result.blinds?.bigBlind})`,
          status: 'success',
          duration: 3000,
        });
        await loadDashboardData();
      } else {
        throw new Error(result.error || 'Failed to advance blinds');
      }
    } catch (error: any) {
      toast({
        title: 'Advance Failed',
        description: error.message,
        status: 'error',
        duration: 3000,
      });
    }
  };

  const handleBalanceTables = async (tournamentId: string) => {
    try {
      const response = await fetch(`${API_BASE}/balanceTournamentTables`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${await auth.currentUser?.getIdToken()}`
        },
        body: JSON.stringify({ tournamentId }),
      });
      const result = await response.json();
      
      if (result.success) {
        toast({
          title: 'Tables Balanced',

          description: `${result.moves?.length || 0} players moved across ${result.tablesBalanced} tables`,
          status: 'success',
          duration: 3000,
        });
        await loadDashboardData();
      } else {
        throw new Error(result.error || 'Failed to balance tables');
      }
    } catch (error: any) {
      toast({
        title: 'Balance Failed',
        description: error.message,
        status: 'error',
        duration: 3000,
      });
    }
  };

  const handleCancelTournament = async (tournamentId: string, tournamentName: string) => {
    if (!window.confirm(`Cancel "${tournamentName}" and refund ALL registered players? This cannot be undone.`)) return;
    
    try {
      const response = await fetch(`${API_BASE}/cancelTournament`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${await auth.currentUser?.getIdToken()}`
        },
        body: JSON.stringify({ tournamentId, reason: 'Cancelled by admin' }),
      });
      const result = await response.json();
      
      if (result.success) {
        toast({
          title: 'Tournament Cancelled',

          description: `${result.refunds?.length || 0} players refunded (${result.totalRefunded || 0} total)`,
          status: 'warning',
          duration: 5000,
        });
        setSelectedTournamentForAudit(null);
        await loadDashboardData();
      } else {
        throw new Error(result.error || 'Failed to cancel tournament');
      }
    } catch (error: any) {
      toast({
        title: 'Cancel Failed',
        description: error.message,
        status: 'error',
        duration: 3000,
      });
    }
  };

  const handleExportTournamentData = (tournament: Tournament) => {
    const exportData = {
      ...tournament,
      exportedAt: new Date().toISOString(),
      exportedBy: auth.currentUser?.uid,
    };
    
    const blob = new Blob([JSON.stringify(exportData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `tournament_${tournament.id}_${new Date().toISOString().split('T')[0]}.json`;
    a.click();
    URL.revokeObjectURL(url);
    
    toast({
      title: 'Exported',

      description: 'Tournament data downloaded as JSON',
      status: 'success',
      duration: 2000,
    });
  };

  // =========================================================================

  // Reset All Data - COMPLETE VERSION FOR PRODUCTION LAUNCH
  // Reset All Data - Calls backend endpoint (bypasses Firestore rules)
  const handleResetAllData = async () => {
    if (resetConfirmText !== 'RESET ALL DATA') {
      toast({ title: 'Type "RESET ALL DATA" to confirm', status: 'error', duration: 3000 });
      return;
    }

    setIsResetting(true);
    setResetProgress('Connecting to server...');
    
    try {
      const user = auth.currentUser;
      if (!user) throw new Error('Not authenticated');
      
      const token = await user.getIdToken();
      
      setResetProgress('Resetting all platform data...');
      
      const response = await fetch('https://api-efcly6byiq-uc.a.run.app/admin/resetAllData', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          confirmText: 'RESET ALL DATA',
        }),
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.error || 'Reset failed');
      }

      setResetProgress('Complete!');
      toast({ 
        title: 'FULL Platform Reset Complete!', 

        description: `Reset complete. Ready for launch!`,
        status: 'success', 
        duration: 8000,
        isClosable: true,
      });
      
      setShowResetDialog(false);
      setResetConfirmText('');
      await loadDashboardData();
      
    } catch (err: any) {
      console.error('Reset failed:', err);
      toast({ 
        title: 'Reset Failed', 
        description: err.message,
        status: 'error', 
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsResetting(false);
      setResetProgress('');
    }
  };
  const handleCreateTournament = async () => {
    if (!tournamentForm.name || !tournamentForm.startDate || !tournamentForm.startTime) {
      toast({ title: 'Fill all required fields', status: 'error', duration: 3000 });
      return;
    }

    const startDateTime = new Date(`${tournamentForm.startDate}T${tournamentForm.startTime}`);
    const regOpen = new Date(startDateTime); regOpen.setHours(regOpen.getHours() - 24);
    const regClose = new Date(startDateTime); regClose.setMinutes(regClose.getMinutes() - 5);

    await tournamentService.createTournament({
      name: tournamentForm.name, description: tournamentForm.description,
      startTime: startDateTime, registrationOpenTime: regOpen, registrationCloseTime: regClose,
      buyInAmount: tournamentForm.buyInAmount, entryFee: tournamentForm.entryFee,
      currency: tournamentForm.currency, type: 'freezeout', startingChips: tournamentForm.startingChips,
      blindLevels: [], blindLevelDuration: tournamentForm.blindLevelDuration,
      minPlayers: tournamentForm.minPlayers, maxPlayers: tournamentForm.maxPlayers,
      prizePool: 0, guaranteedPrize: tournamentForm.guaranteedPrize || undefined,
      payoutStructure: [{ position: 1, percentage: 50 }, { position: 2, percentage: 30 }, { position: 3, percentage: 20 }],
      status: 'registering', createdBy: auth.currentUser?.uid || '',
    });

    toast({ title: 'Tournament Created!', status: 'success', duration: 3000 });
    setTournamentForm({ name: '', description: '', startDate: '', startTime: '', buyInAmount: 1000,
      entryFee: 100, currency: 'playcoins', maxPlayers: 9, minPlayers: 2, startingChips: 5000,
      blindLevelDuration: 10, guaranteedPrize: 0 });
    onClose();
  };

  const handleDeleteTournament = async (id: string) => {
    if (!window.confirm('Delete this tournament?')) return;
    await tournamentService.deleteTournament(id);
    toast({ title: 'Deleted', status: 'info', duration: 2000 });
  };

  const handleCreateAgent = async () => {
    if (!selectedAgentUser) {
      toast({ title: 'Please select a user first', status: 'error', duration: 3000 });
      return;
    }

    setCreatingAgent(true);
    try {
      const code = newAgentCode.trim().toUpperCase();
      if (newAgentRole === 'manager') {
        const r = await gameApiService.adminCreateManager({
          userId: selectedAgentUser.id,
          customCode: code || undefined,
        });
        if (!r.success) throw new Error(r.error || 'Failed to create manager');
        toast({ title: 'Manager created', description: `${selectedAgentUser.username} earns the manager cut on every player under their agents`, status: 'success', duration: 5000 });
      } else {
        await referralService.createAgent(selectedAgentUser.id, newAgentTier, code || undefined);
        if (newAgentManagerId) {
          const r = await gameApiService.adminAgentSettings({ agentId: selectedAgentUser.id, managerId: newAgentManagerId });
          if (!r.success) toast({ title: 'Agent created, manager not set', description: r.error, status: 'warning', duration: 5000 });
        }
        toast({ 
          title: 'Agent created!', 
          description: `${selectedAgentUser.username} is now a ${newAgentTier} agent${code ? ` with code ${code}` : ''}`,
          status: 'success', 
          duration: 4000 
        });
      }
      setSelectedAgentUser(null);
      setAgentUserSearch('');
      setNewAgentTier('standard');
      setNewAgentRole('agent');
      setNewAgentCode('');
      setNewAgentManagerId('');
      onAgentClose();
      await loadDashboardData();
    } catch (error: any) {
      toast({ 
        title: 'Error creating agent', 
        description: error.message || 'Unknown error',
        status: 'error', 
        duration: 3000 
      });
    } finally {
      setCreatingAgent(false);
    }
  };

  const openAgentSettings = (a: AgentData) => {
    setSettingsAgent(a);
    setSettingsForm({
      tier: a.tier || 'standard',
      customCode: a.customCode || '',
      managerId: a.managerId || '',
      active: a.active,
      overrideRakePct: Math.round((a.overrideRakePercent ?? 0.05) * 100),
      canHostTournaments: a.canHostTournaments === true,
      mediaAllowed: a.mediaAllowed || 'none',
      mediaComped: a.mediaComped === true,
    });
  };
  const handleSaveAgentSettings = async () => {
    if (!settingsAgent) return;
    setSavingAgentSettings(true);
    const payload: any = {
      agentId: settingsAgent.id,
      tier: settingsForm.tier,
      customCode: settingsForm.customCode.trim().toUpperCase(),
      managerId: settingsAgent.role === 'manager' ? undefined : (settingsForm.managerId || null),
      active: settingsForm.active,
      canHostTournaments: settingsForm.canHostTournaments,
      mediaAllowed: settingsForm.mediaAllowed,
      mediaComped: settingsForm.mediaComped,
    };
    const r = await gameApiService.adminAgentSettings(payload);
    setSavingAgentSettings(false);
    if (!r.success) { toast({ title: 'Could not save', description: r.error, status: 'error', duration: 5000 }); return; }
    toast({ title: 'Agent updated', status: 'success', duration: 3000 });
    setSettingsAgent(null);
    await loadDashboardData();
  };
  const handlePayoutAction = async (row: AgentPayoutRow, action: 'approve' | 'paid' | 'sendUsdc' | 'verifyUsdc' | 'reject') => {
    let note: string | undefined;
    const extra: { payoutReference?: string; code?: string } = {};
    const dest = row.payoutDestination?.value || '(no destination on file)';
    if (action === 'reject') {
      const n = window.prompt(`Return $${row.amount.toFixed(2)} to ${row.username}'s rake balance. Reason (shown to the agent):`);
      if (n === null) return;
      note = n;
    }
    if (action === 'paid') {
      const ref = window.prompt(`You sent $${row.amount.toFixed(2)} to ${row.username} at ${dest} yourself. Paste the ${row.payoutMethod === 'usdc' ? 'transaction hash' : 'PayPal transaction id'} to close it out:`);
      if (ref === null) return;
      if (ref.trim().length < 3) { toast({ title: 'Reference required', description: 'The transaction id is what proves the payout later.', status: 'warning', duration: 4000 }); return; }
      extra.payoutReference = ref.trim();
    }
    if (action === 'sendUsdc' && !window.confirm(`Send $${row.amount.toFixed(2)} USDC to ${row.username} at ${dest} through NOWPayments now? NOWPayments will email you a code to release it.`)) return;
    if (action === 'verifyUsdc') {
      const c = window.prompt('Enter the verification code NOWPayments emailed you:');
      if (c === null) return;
      extra.code = c.trim();
    }
    setPayoutBusyId(row.id);
    const r = await gameApiService.adminAgentPayoutAction(row.id, action, note, extra);
    setPayoutBusyId(null);
    if (!r.success) { toast({ title: 'Payout action failed', description: r.error, status: 'error', duration: 6000 }); return; }
    toast({ title: action === 'approve' ? 'Approved' : action === 'reject' ? 'Returned to agent' : action === 'sendUsdc' ? 'Withdrawal created' : action === 'verifyUsdc' ? 'Payout released' : 'Paid', description: r.message, status: 'success', duration: 5000 });
    const list = await gameApiService.adminAgentPayouts(showAllPayouts ? 'all' : 'open');
    if (list.success) setAgentPayoutRequests(list.payouts);
  };
  const handleSelectAgentUser = (user: UserData) => {
    setSelectedAgentUser(user);
    setAgentUserSearch('');
    setAgentFilteredUsers([]);
  };

  const handleDeactivateAgent = async (userId: string) => {
    if (!window.confirm('Deactivate this agent?')) return;
    try {
      await referralService.deactivateAgent(userId);
      toast({ title: 'Agent deactivated', status: 'info', duration: 2000 });
      await loadDashboardData();
    } catch (error) {
      toast({ title: 'Error deactivating agent', status: 'error', duration: 3000 });
    }
  };

  //  NEW: Open assign user modal for a specific agent

  const handleOpenAssignUser = (agent: AgentData) => {
    setAssignTargetAgent(agent);
    setAssignUserSearch('');
    setAssignFilteredUsers([]);
    setSelectedAssignUsers([]);
    setShowOnlyUnassigned(true);
    onAssignUserOpen();
  };

  //  NEW: Add user to selection

  const handleSelectAssignUser = (user: UserData) => {
    if (!selectedAssignUsers.find(u => u.id === user.id)) {
      setSelectedAssignUsers([...selectedAssignUsers, user]);
    }
    setAssignUserSearch('');
    setAssignFilteredUsers([]);
  };

  //  NEW: Remove user from selection

  const handleRemoveAssignUser = (userId: string) => {
    setSelectedAssignUsers(selectedAssignUsers.filter(u => u.id !== userId));
  };

  //  NEW: Assign multiple users to agent (admin only)

  const handleAssignUserToAgent = async () => {
    if (!assignTargetAgent || selectedAssignUsers.length === 0) {
      toast({ title: 'Please select at least one user', status: 'error', duration: 3000 });
      return;
    }

    setAssigningUser(true);
    let successCount = 0;
    let failCount = 0;

    try {
      for (const user of selectedAssignUsers) {
        try {
          await referralService.trackReferral(
            assignTargetAgent.id,
            user.id,
            user.email
          );
          successCount++;
        } catch (error: any) {
          console.error(`Error assigning ${user.username}:`, error);
          failCount++;
        }
      }

      if (successCount > 0) {
        toast({
          title: `${successCount} User${successCount > 1 ? 's' : ''} Assigned!`,

          description: `Assigned to agent ${assignTargetAgent.displayName}${failCount > 0 ? ` (${failCount} failed)` : ''}`,
          status: 'success',
          duration: 5000,
        });
      }

      if (failCount > 0 && successCount === 0) {
        toast({
          title: 'Assignment Failed',
          description: `Failed to assign ${failCount} user${failCount > 1 ? 's' : ''}`,
          status: 'error',
          duration: 3000,
        });
      }

      // Reset and close
      setAssignTargetAgent(null);
      setSelectedAssignUsers([]);
      setAssignUserSearch('');
      onAssignUserClose();
      await loadDashboardData();
    } catch (error: any) {
      console.error('Error assigning users to agent:', error);
      toast({
        title: 'Error assigning users',
        description: error.message || 'Unknown error',
        status: 'error',
        duration: 3000,
      });
    } finally {
      setAssigningUser(false);
    }
  };


  // ============================================================================
  //  USER MANAGEMENT HANDLERS (Ban/Delete)

  // ============================================================================
  
  const handleOpenUserManage = async (user: UserData) => {
    setSelectedUserForManage(user);
    setUserManageAction(null);
    setBanReason('');
    setBanDuration(0);
    
    //  NEW: Load user's geo bypass status

    try {
      const userDoc = await getDoc(doc(db, 'users', user.id));
      if (userDoc.exists()) {
        setUserGeoBypass(userDoc.data()?.bypassGeoRestriction === true);
      } else {
        setUserGeoBypass(false);
      }
    } catch (error) {
      console.error('Error loading user geo bypass:', error);
      setUserGeoBypass(false);
    }
    
    onUserManageOpen();
  };
  
  //  NEW: Toggle Geo Bypass Handler

  const handleToggleGeoBypass = async () => {
    if (!selectedUserForManage) return;
    
    try {
      const newValue = !userGeoBypass;
      await updateDoc(doc(db, 'users', selectedUserForManage.id), {
        bypassGeoRestriction: newValue,
        updatedAt: Timestamp.now(),
      });
      
      setUserGeoBypass(newValue);
      
      toast({
        title: newValue ? 'Geo Bypass Enabled' : 'Geo Bypass Disabled',
        description: newValue 
          ? `${selectedUserForManage.username} can now access all features regardless of location.`
          : `${selectedUserForManage.username} is now subject to normal geo restrictions.`,
        status: 'success',
        duration: 3000,
      });
    } catch (error: any) {
      console.error('Error toggling geo bypass:', error);
      toast({
        title: 'Error',
        description: error.message || 'Failed to update geo bypass setting.',
        status: 'error',
        duration: 3000,
      });
    }
  };

  const handleBanUser = async () => {
    if (!selectedUserForManage) return;
    
    setProcessingUserAction(true);
    try {
      const token = await auth.currentUser?.getIdToken();
      const response = await fetch(
        `${API_BASE}/admin/banUser`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({
            userId: selectedUserForManage.id,
            banned: true,
            reason: banReason || 'Violation of terms',
            duration: banDuration,
          }),
        }
      );

      const result = await response.json();
      
      if (response.ok) {
        toast({
          title: 'User Banned',

          description: `${selectedUserForManage.username} has been banned${banDuration > 0 ? ` for ${banDuration} hours` : ' permanently'}`,
          status: 'warning',
          duration: 5000,
        });
        onUserManageClose();
        await loadDashboardData();
      } else {
        throw new Error(result.error || 'Failed to ban user');
      }
    } catch (error: any) {
      console.error('Ban user error:', error);
      toast({ title: 'Error banning user', description: error.message, status: 'error', duration: 5000 });
    } finally {
      setProcessingUserAction(false);
    }
  };

  const handleUnbanUser = async (userId: string, username: string) => {
    try {
      const token = await auth.currentUser?.getIdToken();
      const response = await fetch(
        `${API_BASE}/admin/banUser`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({ userId, banned: false }),
        }
      );

      if (response.ok) {
        toast({ title: 'User Unbanned', description: `${username} has been unbanned`, status: 'success', duration: 3000 });

        await loadDashboardData();
      }
    } catch (error: any) {
      toast({ title: 'Error unbanning user', description: error.message, status: 'error', duration: 3000 });
    }
  };

  const handleDeleteUser = async () => {
    if (!selectedUserForManage) return;
    
    setProcessingUserAction(true);
    try {
      const token = await auth.currentUser?.getIdToken();
      const response = await fetch(
        `${API_BASE}/admin/deleteUser`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({
            userId: selectedUserForManage.id,
            reason: banReason || 'Admin action',
          }),
        }
      );

      const result = await response.json();
      
      if (response.ok) {
        toast({
          title: 'User Deleted',

          description: `${selectedUserForManage.username}'s account has been permanently deleted`,
          status: 'info',
          duration: 5000,
        });
        onUserManageClose();
        await loadDashboardData();
      } else {
        throw new Error(result.error || 'Failed to delete user');
      }
    } catch (error: any) {
      console.error('Delete user error:', error);
      toast({ title: 'Error deleting user', description: error.message, status: 'error', duration: 5000 });
    } finally {
      setProcessingUserAction(false);
    }
  };

  // ============================================================================
  //  MASS DELETE HANDLERS

  // ============================================================================

  const handleMassDelete = async () => {
    if (selectedUsersForDelete.size === 0) return;
    
    setProcessingMassDelete(true);
    try {
      const token = await auth.currentUser?.getIdToken();
      const response = await fetch(
        `${API_BASE}/admin/massDeleteUsers`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({
            userIds: Array.from(selectedUsersForDelete),
            reason: massDeleteReason || 'Mass delete by admin',
          }),
        }
      );

      const result = await response.json();
      
      if (response.ok) {
        toast({
          title: 'Mass Delete Complete',

          description: `${result.summary.deleted} users deleted, ${result.summary.failed} failed`,
          status: result.summary.failed > 0 ? 'warning' : 'success',
          duration: 5000,
        });
        
        // Clear selection and close modal
        setSelectedUsersForDelete(new Set());
        setMassDeleteReason('');
        onMassDeleteClose();
        await loadDashboardData();
      } else {
        throw new Error(result.error || 'Failed to mass delete users');
      }
    } catch (error: any) {
      console.error('Mass delete error:', error);
      toast({ title: 'Error', description: error.message, status: 'error', duration: 5000 });
    } finally {
      setProcessingMassDelete(false);
    }
  };

  const toggleUserSelection = (userId: string) => {
    setSelectedUsersForDelete(prev => {
      const newSet = new Set(prev);
      if (newSet.has(userId)) {
        newSet.delete(userId);
      } else {
        newSet.add(userId);
      }
      return newSet;
    });
  };

  const toggleSelectAll = () => {
    const nonAdminUsers = filteredUsersList.slice(0, 100).filter(u => u.role !== 'admin' && !(u as any).isAdmin);
    if (selectedUsersForDelete.size === nonAdminUsers.length) {
      setSelectedUsersForDelete(new Set());
    } else {
      setSelectedUsersForDelete(new Set(nonAdminUsers.map(u => u.id)));
    }
  };

  // ============================================================================
  //  MAINTENANCE MODE HANDLERS

  // ============================================================================

  const loadMaintenanceStatus = async () => {
    //  PRODUCTION: Read directly from Firestore (no API call needed for read)

    try {
      const maintenanceDoc = await getDoc(doc(db, 'system', 'maintenance'));
      if (maintenanceDoc.exists()) {
        const data = maintenanceDoc.data();
        setMaintenanceMode({
          enabled: data.enabled || false,
          message: data.message || '',
          scheduledAt: data.scheduledAt?.toDate?.()?.toISOString?.() || '',
          estimatedDuration: data.estimatedDuration || 30,
        });
        console.log('✅ Maintenance status loaded from Firestore:', data.enabled);
      } else {
        // Document doesn't exist - maintenance is off
        setMaintenanceMode({
          enabled: false,
          message: '',
          scheduledAt: '',
          estimatedDuration: 30,
        });
        console.log('✅ No maintenance document - maintenance is off');
      }
    } catch (error) {
      console.error('Error loading maintenance status from Firestore:', error);
      // Default to maintenance off on error
      setMaintenanceMode({
        enabled: false,
        message: '',
        scheduledAt: '',
        estimatedDuration: 30,
      });
    }
  };

  const handleToggleMaintenance = async (enable: boolean) => {
    setLoadingMaintenance(true);
    try {
      //  PRODUCTION: Write directly to Firestore (more reliable than API)

      const maintenanceRef = doc(db, 'system', 'maintenance');
      const userId = auth.currentUser?.uid;
      
      if (!userId) {
        toast({ title: 'Not authenticated', status: 'error', duration: 3000 });
        setLoadingMaintenance(false);
        return;
      }

      if (enable) {
        await setDoc(maintenanceRef, {
          enabled: true,
          message: maintenanceMode.message || 'System is under maintenance. Please check back soon.',
          scheduledAt: maintenanceMode.scheduledAt ? Timestamp.fromDate(new Date(maintenanceMode.scheduledAt)) : null,
          estimatedDuration: maintenanceMode.estimatedDuration || 30,
          startedAt: serverTimestamp(),
          startedBy: userId,
          updatedAt: serverTimestamp(),
        });
        console.log('🔧 Maintenance mode ENABLED');
      } else {
        await setDoc(maintenanceRef, {
          enabled: false,
          message: null,
          endedAt: serverTimestamp(),
          endedBy: userId,
          updatedAt: serverTimestamp(),
        });
        console.log('✅ Maintenance mode DISABLED');
      }

      toast({
        title: enable ? ' Maintenance Mode Enabled' : ' Maintenance Mode Disabled',

        status: enable ? 'warning' : 'success',
        duration: 3000,
      });
      setMaintenanceMode(prev => ({ ...prev, enabled: enable }));
    } catch (error: any) {
      console.error('Error toggling maintenance:', error);
      toast({ title: 'Error updating maintenance mode', description: error.message, status: 'error', duration: 3000 });
    } finally {
      setLoadingMaintenance(false);
    }
  };

  const handleSendAnnouncement = async () => {
    if (!announcementForm.message.trim()) {
      toast({ title: 'Message is required', status: 'error', duration: 3000 });
      return;
    }

    setSendingAnnouncement(true);
    try {
      //  PRODUCTION: Write directly to Firestore

      const userId = auth.currentUser?.uid;
      if (!userId) {
        toast({ title: 'Not authenticated', status: 'error', duration: 3000 });
        setSendingAnnouncement(false);
        return;
      }

      // Add to announcements collection
      const announcementRef = await addDoc(collection(db, 'announcements'), {
        title: announcementForm.title || 'System Announcement',
        message: announcementForm.message,
        type: announcementForm.type || 'info',
        active: true,
        createdAt: serverTimestamp(),
        createdBy: userId,
      });

      // Update the current announcement document for real-time listeners
      await setDoc(doc(db, 'system', 'currentAnnouncement'), {
        id: announcementRef.id,
        title: announcementForm.title || 'System Announcement',
        message: announcementForm.message,
        type: announcementForm.type || 'info',
        active: true,
        createdAt: serverTimestamp(),
      });

      console.log('📢 Announcement sent:', announcementForm.title || announcementForm.message.substring(0, 50));
      toast({ title: 'Announcement Sent', status: 'success', duration: 3000 });

      setAnnouncementForm({ title: '', message: '', type: 'info' });
    } catch (error: any) {
      console.error('Error sending announcement:', error);
      toast({ title: 'Error sending announcement', description: error.message, status: 'error', duration: 3000 });
    } finally {
      setSendingAnnouncement(false);
    }
  };

  const handleClearAnnouncement = async () => {
    try {
      //  PRODUCTION: Write directly to Firestore

      const userId = auth.currentUser?.uid;
      await setDoc(doc(db, 'system', 'currentAnnouncement'), {
        active: false,
        clearedAt: serverTimestamp(),
        clearedBy: userId || null,
      });
      console.log('📢 Announcement cleared');
      toast({ title: 'Announcement cleared', status: 'info', duration: 2000 });
    } catch (error) {
      console.error('Error clearing announcement:', error);
      toast({ title: 'Error clearing announcement', status: 'error', duration: 2000 });
    }
  };

  const handleForceKickAll = async () => {
    setKickingAllPlayers(true);
    try {
      const token = await auth.currentUser?.getIdToken();
      const response = await fetch(
        `${API_BASE}/admin/forceKickAll`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({ reason: 'System maintenance' }),
        }
      );

      const result = await response.json();
      
      if (response.ok) {
        toast({
          title: 'All Players Kicked',

          description: `${result.playersKicked} players removed, ${result.chipsReturned.toLocaleString()} chips returned, ${result.tablesCleared} tables cleared`,
          status: 'warning',
          duration: 10000,
        });
        setShowKickConfirm(false);
        await loadDashboardData();
      }
    } catch (error: any) {
      toast({ title: 'Error kicking players', description: error.message, status: 'error', duration: 5000 });
    } finally {
      setKickingAllPlayers(false);
    }
  };

  // Load maintenance status with real-time listener
  useEffect(() => {
    // Initial load
    loadMaintenanceStatus();
    
    // Real-time listener for maintenance status changes
    const maintenanceRef = doc(db, 'system', 'maintenance');
    const unsubscribe = onSnapshot(maintenanceRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.data();
        setMaintenanceMode({
          enabled: data.enabled || false,
          message: data.message || '',
          scheduledAt: data.scheduledAt?.toDate?.()?.toISOString?.() || '',
          estimatedDuration: data.estimatedDuration || 30,
        });
      } else {
        setMaintenanceMode({
          enabled: false,
          message: '',
          scheduledAt: '',
          estimatedDuration: 30,
        });
      }
    }, (error) => {
      console.error('Error listening to maintenance status:', error);
    });
    const unsubHold = onSnapshot(doc(db, 'system', 'paymentsHold'), (snap) => {
      const d: any = snap.exists() ? snap.data() : {};
      setPaymentsHold({
        enabled: d.enabled === true,
        message: d.message || DEFAULT_PAYMENTS_HOLD_MESSAGE,
        blockPurchases: d.blockPurchases !== false,
        blockKyc: d.blockKyc !== false,
        blockCashOuts: d.blockCashOuts === true,
        blockIap: d.blockIap === true,
      });
      setPaymentsHoldDirty(false);
    }, (error) => console.error('Error listening to payments hold:', error));
    
    return () => { unsubscribe(); unsubHold(); };
  }, []);

  const savePaymentsHold = async (next: typeof paymentsHold) => {
    setSavingPaymentsHold(true);
    try {
      await setDoc(doc(db, 'system', 'paymentsHold'), {
        ...next,
        message: next.message.trim() || DEFAULT_PAYMENTS_HOLD_MESSAGE,
        updatedAt: serverTimestamp(),
        updatedBy: auth.currentUser?.uid || null,
      }, { merge: true });
      setPaymentsHold(next);
      setPaymentsHoldDirty(false);
      toast({ title: next.enabled ? 'Payments hold is ON' : 'Payments hold is OFF', status: next.enabled ? 'warning' : 'success', duration: 3000 });
    } catch (error: any) {
      toast({ title: 'Could not save payments hold', description: error.message, status: 'error', duration: 4000 });
    } finally {
      setSavingPaymentsHold(false);
    }
  };

  // Filter users based on search
  const deferredUserSearch = useDeferredValue(userSearchFilter);
  const filteredUsersList = useMemo(() => {
    if (!deferredUserSearch.trim()) return users;
    const search = deferredUserSearch.toLowerCase();
    return users.filter(u => 
      u.username?.toLowerCase().includes(search) ||
      u.email?.toLowerCase().includes(search) ||
      u.id?.toLowerCase().includes(search)
    );
  }, [users, deferredUserSearch]);

  // ============================================================================
  // STATUS BADGE HELPER
  // ============================================================================
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'pending_review':
        return <Badge colorScheme="yellow"><Clock size={12} /> Pending</Badge>;
      case 'approved':
        return <Badge colorScheme="blue"><CheckCircle size={12} /> Approved</Badge>;
      case 'processing':
        return <Badge colorScheme="purple"><Spinner size="xs" /> Processing</Badge>;
      case 'completed':
        return <Badge colorScheme="green"><CheckCircle size={12} /> Completed</Badge>;
      case 'rejected':
        return <Badge colorScheme="red"><XCircle size={12} /> Rejected</Badge>;
      case 'failed':
        return <Badge colorScheme="red"><AlertTriangle size={12} /> Failed</Badge>;
      default:
        return <Badge>{status}</Badge>;
    }
  };

  if (loading) {
    return (
      <Container maxW="7xl" py={8} pl={{ base: 4, md: 24 }}>
        <VStack minH="50vh" justify="center">
          <Spinner size="xl" color={POKER_COLORS.cyan} />
          <Text color="gray.400">Loading dashboard...</Text>
        </VStack>
      </Container>
    );
  }

  return (
    <Container maxW="7xl" py={8} pl={{ base: 4, md: 24 }} pb={{ base: 24, md: 8 }}>
      <VStack spacing={6} align="stretch">
        {/* Header */}
        <HStack justify="space-between" flexWrap="wrap" gap={4}>
          <Box>
            <Heading color={POKER_COLORS.cyan} size="lg" display="flex" alignItems="center" gap={3}>
              <Activity size={28} /> Admin Dashboard
            </Heading>
            <Text color="gray.400">Monitor your poker platform</Text>
          </Box>
          <HStack>
            <PokerButton size="sm" variant="secondary" leftIcon={<RefreshCw size={16} />} onClick={handleRefresh} isLoading={refreshing}>
              Refresh
            </PokerButton>
            <PokerButton size="sm" variant="primary" leftIcon={<Plus size={16} />} onClick={onOpen}>
              Create Tournament
            </PokerButton>
          </HStack>
        </HStack>

        {/* Primary Stats */}
        <SimpleGrid columns={{ base: 2, md: 4 }} spacing={4}>
          <PokerCard p={4}>
            <Stat>
              <StatLabel color="gray.400"><HStack><Users size={14} /><Text>Total Users</Text></HStack></StatLabel>
              <StatNumber color={POKER_COLORS.cyan}>{stats.totalUsers}</StatNumber>
              <StatHelpText color="green.400"><StatArrow type="increase" />{stats.newUsersThisWeek} this week</StatHelpText>
            </Stat>
          </PokerCard>
          <PokerCard p={4}>
            <Stat>
              <StatLabel color="gray.400"><HStack><Activity size={14} /><Text>Active Now</Text></HStack></StatLabel>
              <StatNumber color={POKER_COLORS.darkGreen}>{stats.activeUsers}</StatNumber>
              <StatHelpText color="gray.500">{stats.activeTables} active tables</StatHelpText>
            </Stat>
          </PokerCard>
          <PokerCard p={4}>
            <Stat>
              <StatLabel color="gray.400"><HStack><DollarSign size={14} /><Text>PKCash in Circ.</Text></HStack></StatLabel>
              <StatNumber color={POKER_COLORS.gold}>${stats.totalPKCash.toFixed(2)}</StatNumber>
              <StatHelpText color="gray.500">Real money</StatHelpText>
            </Stat>
          </PokerCard>
          <PokerCard p={4}>
            <Stat>
              <StatLabel color="gray.400"><HStack><TrendingUp size={14} /><Text>Total Rake</Text></HStack></StatLabel>
              <StatNumber color={POKER_COLORS.darkGreen}>${stats.totalRake.toFixed(2)}</StatNumber>
              <StatHelpText color="gray.500">Cash game revenue</StatHelpText>
            </Stat>
          </PokerCard>
        </SimpleGrid>

        {/* Secondary Stats - Including Pending Redemptions */}
        <SimpleGrid columns={{ base: 2, md: 6 }} spacing={4}>
          <PokerCard p={4}>
            <Text color="gray.500" fontSize="sm">PlayCoins</Text>
            <Text color={POKER_COLORS.cyan} fontSize="xl" fontWeight="bold">{stats.totalPlayCoins.toLocaleString()}</Text>
          </PokerCard>
          <PokerCard p={4}>
            <Text color="gray.500" fontSize="sm">Deposits</Text>
            <Text color="green.400" fontSize="xl" fontWeight="bold">${stats.totalDeposits.toFixed(2)}</Text>
          </PokerCard>
          <PokerCard p={4}>
            <Text color="gray.500" fontSize="sm">Withdrawals</Text>
            <Text color="red.400" fontSize="xl" fontWeight="bold">${stats.totalWithdrawals.toFixed(2)}</Text>
          </PokerCard>
          <PokerCard p={4}>
            <Text color="gray.500" fontSize="sm">Agents</Text>
            <Text color={POKER_COLORS.gold} fontSize="xl" fontWeight="bold">{stats.totalAgents}</Text>
          </PokerCard>
          {/*  NEW: Pending Redemptions */}

          <PokerCard p={4} borderColor={stats.pendingRedemptions > 0 ? 'orange.400' : undefined} borderWidth={stats.pendingRedemptions > 0 ? 2 : 0}>
            <Text color="gray.500" fontSize="sm"> Pending Payouts</Text>

            <Text color="orange.400" fontSize="xl" fontWeight="bold">{stats.pendingRedemptions}</Text>
            <Text color="gray.600" fontSize="xs">${stats.pendingRedemptionAmount.toFixed(2)}</Text>
          </PokerCard>
          <PokerCard p={4} borderColor={POKER_COLORS.gold} borderWidth={1}>
            <Text color="gray.500" fontSize="sm"> Tournament Rake</Text>

            <Text color={POKER_COLORS.gold} fontSize="xl" fontWeight="bold">${stats.tournamentRakeTotal.toFixed(2)}</Text>
            <Text color="gray.600" fontSize="xs">{stats.tournamentsRaked} tournaments</Text>
          </PokerCard>
        </SimpleGrid>

        {/*  REVENUE BREAKDOWN - Comprehensive Revenue Tracking */}

        <PokerCard glow={true} borderColor="green.500">
          <VStack spacing={4} align="stretch">
            <HStack justify="space-between" align="center">
              <HStack spacing={3}>
                <Box bg="green.900" p={3} borderRadius="lg">
                  <DollarSign size={28} color="#22c55e" />
                </Box>
                <VStack align="start" spacing={0}>
                  <Text color="green.400" fontWeight="bold" fontSize="xl">
                    Total Revenue
                  </Text>
                  <Text color="gray.400" fontSize="sm">
                    All platform income streams
                  </Text>
                </VStack>
              </HStack>
              <VStack align="end" spacing={0}>
                <Text color="green.400" fontSize="3xl" fontWeight="bold">
                  ${(stats.totalRake + stats.tournamentRakeHouseNet + stats.voicePassRevenue + stats.voiceChatFeeRevenue + stats.gameItemRevenue).toFixed(2)}
                </Text>
                <Text color="gray.500" fontSize="xs">Lifetime earnings</Text>
              </VStack>
            </HStack>

            <Divider borderColor="gray.700" />

            <SimpleGrid columns={{ base: 2, md: 5 }} spacing={4}>
              {/* Cash Game Rake */}
              <Box bg="#0D1B2A" p={4} borderRadius="lg" borderLeft="3px solid" borderColor="cyan.400">
                <Text color="gray.400" fontSize="xs" mb={1}> Cash Game Rake</Text>

                <Text color="cyan.400" fontSize="xl" fontWeight="bold">${stats.totalRake.toFixed(2)}</Text>
              </Box>

              {/* Tournament Rake (Net) */}
              <Box bg="#0D1B2A" p={4} borderRadius="lg" borderLeft="3px solid" borderColor="yellow.400">
                <Text color="gray.400" fontSize="xs" mb={1}> Tournament Rake</Text>

                <Text color="yellow.400" fontSize="xl" fontWeight="bold">${stats.tournamentRakeHouseNet.toFixed(2)}</Text>
                <Text color="gray.600" fontSize="xs">Net after agents</Text>
              </Box>

              {/* Voice Pass Revenue (24hr unlimited) */}
              <Box bg="#0D1B2A" p={4} borderRadius="lg" borderLeft="3px solid" borderColor="purple.400">
                <Text color="gray.400" fontSize="xs" mb={1}> Voice Passes</Text>

                <Text color="purple.400" fontSize="xl" fontWeight="bold">${stats.voicePassRevenue.toFixed(2)}</Text>
                <Text color="gray.600" fontSize="xs">
                  {stats.voicePassUnlimitedCount} unlimited
                </Text>
              </Box>

              {/* Voice Chat Fees (one-time per table) */}
              <Box bg="#0D1B2A" p={4} borderRadius="lg" borderLeft="3px solid" borderColor="blue.400">
                <Text color="gray.400" fontSize="xs" mb={1}> Voice Chat Fees</Text>

                <Text color="blue.400" fontSize="xl" fontWeight="bold">${stats.voiceChatFeeRevenue.toFixed(2)}</Text>
                <Text color="gray.600" fontSize="xs">{stats.voiceChatFeeCount} tables</Text>
              </Box>

              {/* Game Item Revenue */}
              <Box bg="#0D1B2A" p={4} borderRadius="lg" borderLeft="3px solid" borderColor="pink.400">
                <Text color="gray.400" fontSize="xs" mb={1}> Game Items</Text>

                <Text color="pink.400" fontSize="xl" fontWeight="bold">${stats.gameItemRevenue.toFixed(2)}</Text>
                <Text color="gray.600" fontSize="xs">{stats.gameItemCount} items sold</Text>
              </Box>
            </SimpleGrid>

            {/* Profit Summary */}
            <Box bg="linear-gradient(90deg, rgba(34,197,94,0.1) 0%, rgba(34,197,94,0.05) 100%)" p={4} borderRadius="lg">
              <HStack justify="space-between" flexWrap="wrap" gap={4}>
                <VStack align="start" spacing={1}>
                  <Text color="gray.400" fontSize="sm">Net Profit (Revenue - Withdrawals)</Text>
                  <Text color={stats.totalRake + stats.tournamentRakeHouseNet + stats.voicePassRevenue + stats.voiceChatFeeRevenue + stats.gameItemRevenue - stats.totalWithdrawals >= 0 ? "green.400" : "red.400"} fontSize="2xl" fontWeight="bold">
                    ${(stats.totalRake + stats.tournamentRakeHouseNet + stats.voicePassRevenue + stats.voiceChatFeeRevenue + stats.gameItemRevenue - stats.totalWithdrawals).toFixed(2)}
                  </Text>
                </VStack>
                <VStack align="end" spacing={1}>
                  <Text color="gray.400" fontSize="sm">Total Deposits</Text>
                  <Text color="blue.400" fontSize="xl" fontWeight="bold">${stats.totalDeposits.toFixed(2)}</Text>
                </VStack>
                <VStack align="end" spacing={1}>
                  <Text color="gray.400" fontSize="sm">Total Withdrawals</Text>
                  <Text color="red.400" fontSize="xl" fontWeight="bold">${stats.totalWithdrawals.toFixed(2)}</Text>
                </VStack>
              </HStack>
            </Box>
          </VStack>
        </PokerCard>

        {/* Send Coins Quick Action */}
        <PokerCard glow={true}>
          <HStack justify="space-between" align="center">
            <HStack spacing={4}>
              <Box bg={`${POKER_COLORS.gold}22`} p={3} borderRadius="lg">
                <Gift color={POKER_COLORS.gold} size={28} />
              </Box>
              <VStack align="start" spacing={0}>
                <Text color={POKER_COLORS.gold} fontWeight="bold" fontSize="lg">
                  Send Coins to User
                </Text>
                <Text color="gray.400" fontSize="sm">
                  Credit PlayCoins or PKCash to any user with a custom message
                </Text>
              </VStack>
            </HStack>
            <PokerButton 
              variant="primary" 
              leftIcon={<Send size={18} />} 
              onClick={() => { setSendCoinsPreset(null); onSendOpen(); }}
              bg={POKER_COLORS.gold}
              color="black"
              _hover={{ opacity: 0.9, transform: 'scale(1.02)' }}
            >
              Send Coins
            </PokerButton>
          </HStack>
        </PokerCard>

        {/*  Voice/Video Chat Bypass Codes - NEW DYNAMIC SYSTEM */}

        <PokerCard glow={true} borderColor={POKER_COLORS.cyan}>
          <HStack justify="space-between" align="center" flexWrap="wrap" gap={4}>
            <HStack spacing={4}>
              <Box bg={`${POKER_COLORS.cyan}22`} p={3} borderRadius="lg">
                <Key size={28} color={POKER_COLORS.cyan} />
              </Box>
              <VStack align="start" spacing={0}>
                <Text color={POKER_COLORS.cyan} fontWeight="bold" fontSize="lg">
                  Voice/Video Bypass Codes
                </Text>
                <Text color="gray.400" fontSize="sm">
                  {stats.activeBypassCodes} active codes • {stats.bypassCodeUsageThisMonth} uses this month
                </Text>
              </VStack>
            </HStack>
            <HStack spacing={3}>
              <PokerButton 
                variant="primary" 
                size="sm"
                leftIcon={<Plus size={16} />}
                onClick={onBypassCodeOpen}
                bg={POKER_COLORS.cyan}
              >
                Create Code
              </PokerButton>
            </HStack>
          </HStack>
        </PokerCard>

        {/*  UPDATED TABS - Added Redemptions and Settings */}

        {/* isLazy: only the active panel is mounted. With all 19 mounted, every
            keystroke in any field re-rendered every table on every tab. */}
        <Tabs variant="enclosed" colorScheme="cyan" isLazy>
          <TabList borderColor={`${POKER_COLORS.cyan}33`} flexWrap="wrap">
            <Tab color="gray.400" _selected={{ color: POKER_COLORS.cyan, bg: `${POKER_COLORS.cyan}22` }}><HStack><Trophy size={16} /><Text>Tournaments</Text></HStack></Tab>
            <Tab color="gray.400" _selected={{ color: POKER_COLORS.gold, bg: `${POKER_COLORS.gold}22` }}><HStack><DollarSign size={16} /><Text>Tournament Rake</Text></HStack></Tab>
            {/*  NEW: Redemptions Tab */}

            <Tab color="gray.400" _selected={{ color: 'orange.400', bg: 'orange.900' }}>
              <HStack>
                <Send size={16} />
                <Text>Redemptions</Text>
                {stats.pendingRedemptions > 0 && (
                  <Badge colorScheme="orange" ml={1}>{stats.pendingRedemptions}</Badge>
                )}
              </HStack>
            </Tab>
            {/*  NEW: Bypass Codes Tab */}

            <Tab color="gray.400" _selected={{ color: POKER_COLORS.cyan, bg: `${POKER_COLORS.cyan}22` }}>
              <HStack>
                <Key size={16} />
                <Text>Bypass Codes</Text>
                <Badge colorScheme="cyan" ml={1}>{stats.activeBypassCodes}</Badge>
              </HStack>
            </Tab>
            <Tab color="gray.400" _selected={{ color: POKER_COLORS.cyan, bg: `${POKER_COLORS.cyan}22` }}><HStack><Users size={16} /><Text>Users</Text></HStack></Tab>
            <Tab color="gray.400" _selected={{ color: POKER_COLORS.cyan, bg: `${POKER_COLORS.cyan}22` }}><HStack><Percent size={16} /><Text>Agents</Text></HStack></Tab>
            <Tab color="gray.400" _selected={{ color: POKER_COLORS.cyan, bg: `${POKER_COLORS.cyan}22` }}><HStack><Gamepad2 size={16} /><Text>Tables</Text></HStack></Tab>
            <Tab color="gray.400" _selected={{ color: POKER_COLORS.cyan, bg: `${POKER_COLORS.cyan}22` }}><HStack><DollarSign size={16} /><Text>Transactions</Text></HStack></Tab>
            {/*  NEW: Tax/1099 Reporting Tab */}

            <Tab 
              color="gray.400" 
              _selected={{ color: 'green.400', bg: 'green.900' }}
              onClick={() => !taxReport && loadTaxReport()}
            >
              <HStack>
                <Receipt size={16} />
                <Text>Tax/1099</Text>
                {taxReport && taxReport.usersRequiring1099 > 0 && (
                  <Badge colorScheme="yellow" fontSize="xs">{taxReport.usersRequiring1099}</Badge>
                )}
              </HStack>
            </Tab>
            {/*  SECURITY: Security Tab */}

            <Tab color="gray.400" _selected={{ color: 'red.400', bg: 'red.900' }}>
              <HStack>
                <Shield size={16} />
                <Text>Security</Text>
              </HStack>
            </Tab>
            {/*  NEW: Settings Tab */}

			<Tab color="gray.400" _selected={{ color: 'cyan.400', bg: 'cyan.900' }}><HStack><MessageCircle size={16} /><Text>Support</Text></HStack></Tab>
            {/*  NEW: Reports Tab */}

            <Tab color="gray.400" _selected={{ color: 'orange.400', bg: 'orange.900' }}>
              <HStack>
                <Flag size={16} />
                <Text>Reports</Text>
                {stats.pendingReports > 0 && (
                  <Badge colorScheme="orange" ml={1}>{stats.pendingReports}</Badge>
                )}
              </HStack>
            </Tab>
            <Tab color="gray.400" _selected={{ color: 'purple.400', bg: 'purple.900' }}><HStack><Settings size={16} /><Text>Settings</Text></HStack></Tab>
            {/*  NEW: Monthly Challenges Tab */}

            <Tab color="gray.400" _selected={{ color: 'yellow.400', bg: 'yellow.900' }}>
              <HStack>
                <Trophy size={16} />
                <Text>Challenges</Text>
              </HStack>
            </Tab>
            {/* Tab order MUST mirror TabPanels order: Chakra pairs them by
                index. These two were swapped - clicking System showed the
                Push panel and vice versa - which is why nobody could find
                anything that lived on the System tab. */}
            <Tab color="gray.400" _selected={{ color: 'red.400', bg: 'red.900' }}><HStack><Shield size={16} /><Text>System</Text></HStack></Tab>
            <Tab color="gray.400" _selected={{ color: 'cyan.400', bg: 'cyan.900' }}>
              <HStack>
                <Bell size={16} />
                <Text>Push</Text>
                {stats.pushEnabledUsers > 0 && (
                  <Badge colorScheme="cyan" ml={1}>{stats.pushEnabledUsers}</Badge>
                )}
              </HStack>
            </Tab>
            <Tab color="gray.400" _selected={{ color: 'cyan.400', bg: 'cyan.900' }}><HStack><Beaker size={16} /><Text>Tourney Test</Text></HStack></Tab>
            <Tab color="gray.400" _selected={{ color: 'cyan.400', bg: 'cyan.900' }}><HStack><SmartphoneIcon size={16} /><Text>Push Test</Text></HStack></Tab>
            <Tab color="gray.400" _selected={{ color: 'cyan.400', bg: 'cyan.900' }}><HStack><MailIcon size={16} /><Text>Email</Text></HStack></Tab>
            <Tab color="gray.400" _selected={{ color: 'yellow.400', bg: 'yellow.900' }}><HStack><DollarSign size={16} /><Text>Training $</Text></HStack></Tab>
          </TabList>

          <TabPanels>
            {/* Tournaments Tab */}
            <TabPanel px={0}>
              <VStack spacing={4} align="stretch">
                <PokerCard>
                  <HStack justify="space-between" mb={4}>
                    <VStack align="start" spacing={0}>
                      <Text color={POKER_COLORS.cyan} fontWeight="bold">Quick Create Tournaments</Text>
                      <Text color="gray.500" fontSize="sm">Create scheduled tournaments instantly</Text>
                    </VStack>
                    <PokerButton 
                      size="sm" 
                      variant="primary" 
                      leftIcon={<Calendar size={14} />} 
                      onClick={handleGenerateWeeklyTournaments}
                      isLoading={generatingTournaments}
                      loadingText="Generating..."
                    >
                      Generate Week
                    </PokerButton>
                  </HStack>
                  
                  {/* PKCash Tournaments */}
                  <Text color={POKER_COLORS.gold} fontWeight="bold" fontSize="sm" mb={2}> PKCash Tournaments</Text>

                  <SimpleGrid columns={{ base: 1, md: 3 }} spacing={3} mb={4}>
                    <PokerButton 
                      variant="secondary" 
                      leftIcon={<Zap size={16} />}
                      onClick={() => handleQuickCreateTournament('low')}
                      bg="#CD7F3233"
                      borderColor="#CD7F32"
                      color="#CD7F32"
                      _hover={{ bg: '#CD7F3255' }}
                    >
                       Create $5 Daily Grind

                    </PokerButton>
                    <PokerButton 
                      variant="secondary" 
                      leftIcon={<Zap size={16} />}
                      onClick={() => handleQuickCreateTournament('mid')}
                      bg="#C0C0C033"
                      borderColor="#C0C0C0"
                      color="#C0C0C0"
                      _hover={{ bg: '#C0C0C055' }}
                    >
                       Create $25 Silver Stakes

                    </PokerButton>
                    <PokerButton 
                      variant="secondary" 
                      leftIcon={<Zap size={16} />}
                      onClick={() => handleQuickCreateTournament('high')}
                      bg="#FFD70033"
                      borderColor="#FFD700"
                      color="#FFD700"
                      _hover={{ bg: '#FFD70055' }}
                    >
                       Create $100 Diamond Series

                    </PokerButton>
                  </SimpleGrid>

                  {/* PlayCoins Tournaments */}
                  <Text color={POKER_COLORS.cyan} fontWeight="bold" fontSize="sm" mb={2}> PlayCoins Tournaments (Restricted States)</Text>

                  <SimpleGrid columns={{ base: 1, md: 3 }} spacing={3}>
                    <PokerButton 
                      variant="secondary" 
                      leftIcon={<Zap size={16} />}
                      onClick={() => handleQuickCreateTournament('pc_low' as TournamentTier)}
                      bg="#CD7F3222"
                      borderColor="#CD7F32"
                      color="#CD7F32"
                      _hover={{ bg: '#CD7F3244' }}
                    >
                       Create 500 PC Bronze

                    </PokerButton>
                    <PokerButton 
                      variant="secondary" 
                      leftIcon={<Zap size={16} />}
                      onClick={() => handleQuickCreateTournament('pc_mid' as TournamentTier)}
                      bg="#C0C0C022"
                      borderColor="#C0C0C0"
                      color="#C0C0C0"
                      _hover={{ bg: '#C0C0C044' }}
                    >
                       Create 2.5K PC Silver

                    </PokerButton>
                    <PokerButton 
                      variant="secondary" 
                      leftIcon={<Zap size={16} />}
                      onClick={() => handleQuickCreateTournament('pc_high' as TournamentTier)}
                      bg="#FFD70022"
                      borderColor="#FFD700"
                      color="#FFD700"
                      _hover={{ bg: '#FFD70044' }}
                    >
                       Create 10K PC Gold

                    </PokerButton>
                  </SimpleGrid>
                </PokerCard>

                <PokerCard>
                  <HStack justify="space-between" mb={4}>
                    <Text color={POKER_COLORS.cyan} fontWeight="bold">Tournaments ({tournaments.length})</Text>
                    <HStack spacing={2}>
                      {/* No Refresh button: the list is a live Firestore
                          subscription, and the fetchTournaments() the old
                          button called never existed in this file - clicking
                          it crashed the dashboard. */}
                      <PokerButton size="sm" variant="primary" leftIcon={<Plus size={14} />} onClick={onOpen}>Custom</PokerButton>
                    </HStack>
                  </HStack>
                  {tournaments.length === 0 ? (
                    <VStack py={8}>
                      <Trophy size={48} color={POKER_COLORS.cyan} />
                      <Text color="gray.500" textAlign="center">No tournaments yet.</Text>
                      <Text color="gray.600" fontSize="sm">Click "Generate Week" to create the schedule!</Text>
                    </VStack>
                  ) : (
                    <Box overflowX="auto">
                      <Table size="sm">
                        <Thead>
                          <Tr>
                            <Th color="gray.500">Name</Th>
                            <Th color="gray.500">Date</Th>
                            <Th color="gray.500">Buy-in</Th>
                            <Th color="gray.500">Players</Th>
                            <Th color="gray.500">Prize Pool</Th>
                            <Th color="gray.500">Status</Th>
                            <Th color="gray.500">Flags</Th>
                            <Th color="gray.500">Actions</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {tournaments.map(t => (
                            <Tr key={t.id} _hover={{ bg: 'whiteAlpha.50' }}>
                              <Td color="white" fontWeight="medium">{t.name}</Td>
                              <Td color="gray.300" fontSize="xs">{new Date(t.startTime).toLocaleString()}</Td>
                              <Td color={t.currency === 'pkcash' ? POKER_COLORS.gold : POKER_COLORS.cyan}>
                                {t.currency === 'pkcash' ? `$${t.buyInAmount}` : `${t.buyInAmount.toLocaleString()} PC`}
                              </Td>
                              <Td color="white">{t.registeredPlayers?.length || 0}/{t.maxPlayers}</Td>
                              <Td color={POKER_COLORS.gold}>
                                {t.currency === 'pkcash' ? `$${(t.prizePool || 0).toFixed(2)}` : (t.prizePool || 0).toLocaleString()}
                              </Td>
                              <Td>
                                <Badge 
                                  colorScheme={
                                    t.status === 'registering' ? 'green' : 
                                    t.status === 'running' || t.status === 'late_reg' ? 'yellow' : 
                                    t.status === 'completed' ? 'blue' :
                                    t.status === 'cancelled' ? 'red' : 'gray'
                                  }
                                  fontSize="xs"
                                >
                                  {t.status}
                                </Badge>
                              </Td>
                              <Td>
                                <HStack spacing={1}>
                                  {(t as any).tournamentFinalized && (
                                    <Tooltip label="Finalized - Prizes Paid">
                                      <Badge colorScheme="green" fontSize="2xs"> FINAL</Badge>

                                    </Tooltip>
                                  )}
                                  {(t as any).tournamentStarted && (
                                    <Tooltip label="Tournament Started">
                                      <Badge colorScheme="blue" fontSize="2xs">LIVE</Badge>
                                    </Tooltip>
                                  )}
                                  {(t as any).activeTables?.length > 0 && (
                                    <Tooltip label={`${(t as any).activeTables.length} active tables`}>
                                      <Badge colorScheme="purple" fontSize="2xs">{(t as any).activeTables.length}T</Badge>
                                    </Tooltip>
                                  )}
                                </HStack>
                              </Td>
                              <Td>
                                <HStack spacing={1}>
                                  {/* View Details */}
                                  <Tooltip label="View Details">
                                    <IconButton
                                      aria-label="View"
                                      icon={<Eye size={14} />}
                                      size="xs"
                                      variant="ghost"
                                      colorScheme="cyan"
                                      onClick={() => setSelectedTournamentForAudit(t)}
                                    />
                                  </Tooltip>
                                  
                                  {/* Start Tournament (only for registering status) */}
                                  {(t.status === 'registering' || t.status === 'scheduled') && (t.registeredPlayers?.length || 0) >= (t.minPlayers || 2) && (
                                    <Tooltip label="Force Start Tournament">
                                      <IconButton
                                        aria-label="Start"
                                        icon={<Play size={14} />}
                                        size="xs"
                                        variant="ghost"
                                        colorScheme="green"
                                        onClick={() => handleForceStartTournament(t.id)}
                                      />
                                    </Tooltip>
                                  )}
                                  
                                  {/* Advance Blinds (only for running tournaments) */}
                                  {(t.status === 'running' || t.status === 'late_reg') && (
                                    <Tooltip label="Advance Blind Level">
                                      <IconButton
                                        aria-label="Blinds"
                                        icon={<ChevronUp size={14} />}
                                        size="xs"
                                        variant="ghost"
                                        colorScheme="yellow"
                                        onClick={() => handleAdvanceBlindLevel(t.id)}
                                      />
                                    </Tooltip>
                                  )}
                                  
                                  {/* Balance Tables (only for running with multiple tables) */}
                                  {(t.status === 'running' || t.status === 'late_reg') && (t as any).activeTables?.length > 1 && (
                                    <Tooltip label="Balance Tables">
                                      <IconButton
                                        aria-label="Balance"
                                        icon={<Scale size={14} />}
                                        size="xs"
                                        variant="ghost"
                                        colorScheme="purple"
                                        onClick={() => handleBalanceTables(t.id)}
                                      />
                                    </Tooltip>
                                  )}
                                  
                                  {/* Cancel Tournament (not for completed/cancelled) */}
                                  {t.status !== 'completed' && t.status !== 'cancelled' && (
                                    <Tooltip label="Cancel & Refund All">
                                      <IconButton
                                        aria-label="Cancel"
                                        icon={<XCircle size={14} />}
                                        size="xs"
                                        variant="ghost"
                                        colorScheme="red"
                                        onClick={() => handleCancelTournament(t.id, t.name)}
                                      />
                                    </Tooltip>
                                  )}
                                  
                                  {/* Delete (only scheduled/cancelled) */}
                                  {(t.status === 'scheduled' || t.status === 'cancelled' || t.status === 'registering') && (
                                    <Tooltip label="Delete Tournament">
                                      <IconButton
                                        aria-label="Delete"
                                        icon={<Trash2 size={14} />}
                                        size="xs"
                                        variant="ghost"
                                        colorScheme="red"
                                        onClick={() => handleDeleteTournament(t.id)}
                                      />
                                    </Tooltip>
                                  )}
                                </HStack>
                              </Td>
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
                    </Box>
                  )}
                </PokerCard>

                {/* Tournament Audit Panel */}
                {selectedTournamentForAudit && (
                  <PokerCard>
                    <HStack justify="space-between" mb={4}>
                      <VStack align="start" spacing={0}>
                        <Text color={POKER_COLORS.cyan} fontWeight="bold">
                           Tournament Audit: {selectedTournamentForAudit.name}

                        </Text>
                        <Text color="gray.500" fontSize="xs">ID: {selectedTournamentForAudit.id}</Text>
                      </VStack>
                      <PokerButton size="xs" variant="secondary" onClick={() => setSelectedTournamentForAudit(null)}>
                        Close
                      </PokerButton>
                    </HStack>
                    
                    <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} mb={4}>
                      {/* Status Card */}
                      <Box p={3} bg="blackAlpha.400" borderRadius="lg" border="1px solid" borderColor="gray.700">
                        <Text color="gray.500" fontSize="xs" mb={1}>Status & State</Text>
                        <VStack align="start" spacing={1}>
                          <HStack>
                            <Text color="gray.400" fontSize="sm">Status:</Text>
                            <Badge colorScheme={
                              selectedTournamentForAudit.status === 'running' ? 'green' :
                              selectedTournamentForAudit.status === 'completed' ? 'blue' : 'yellow'
                            }>{selectedTournamentForAudit.status}</Badge>
                          </HStack>
                          <HStack>
                            <Text color="gray.400" fontSize="sm">Finalized:</Text>
                            <Text color={(selectedTournamentForAudit as any).tournamentFinalized ? 'green.400' : 'yellow.400'} fontSize="sm">
                              {(selectedTournamentForAudit as any).tournamentFinalized ? ' YES' : '⏳ NO'}

                            </Text>
                          </HStack>
                          <HStack>
                            <Text color="gray.400" fontSize="sm">Started:</Text>
                            <Text color={(selectedTournamentForAudit as any).tournamentStarted ? 'green.400' : 'gray.400'} fontSize="sm">
                              {(selectedTournamentForAudit as any).tournamentStarted ? ' YES' : ' NO'}

                            </Text>
                          </HStack>
                          <HStack>
                            <Text color="gray.400" fontSize="sm">Blind Level:</Text>
                            <Text color="white" fontSize="sm">{(selectedTournamentForAudit as any).currentBlindLevel || 1}</Text>
                          </HStack>
                        </VStack>
                      </Box>
                      
                      {/* Players Card */}
                      <Box p={3} bg="blackAlpha.400" borderRadius="lg" border="1px solid" borderColor="gray.700">
                        <Text color="gray.500" fontSize="xs" mb={1}>Players</Text>
                        <VStack align="start" spacing={1}>
                          <HStack>
                            <Text color="gray.400" fontSize="sm">Registered:</Text>
                            <Text color="white" fontSize="sm">{selectedTournamentForAudit.registeredPlayers?.length || 0}</Text>
                          </HStack>
                          <HStack>
                            <Text color="gray.400" fontSize="sm">Active:</Text>
                            <Text color="green.400" fontSize="sm">{(selectedTournamentForAudit as any).activePlayers?.length || 0}</Text>
                          </HStack>
                          <HStack>
                            <Text color="gray.400" fontSize="sm">Eliminated:</Text>
                            <Text color="red.400" fontSize="sm">{(selectedTournamentForAudit as any).eliminatedPlayers?.length || 0}</Text>
                          </HStack>
                          <HStack>
                            <Text color="gray.400" fontSize="sm">Tables:</Text>
                            <Text color="purple.400" fontSize="sm">{(selectedTournamentForAudit as any).activeTables?.length || 0}</Text>
                          </HStack>
                        </VStack>
                      </Box>
                      
                      {/* Money Card */}
                      <Box p={3} bg="blackAlpha.400" borderRadius="lg" border="1px solid" borderColor="gray.700">
                        <Text color="gray.500" fontSize="xs" mb={1}>Financials ({selectedTournamentForAudit.currency?.toUpperCase()})</Text>
                        <VStack align="start" spacing={1}>
                          <HStack>
                            <Text color="gray.400" fontSize="sm">Buy-in:</Text>
                            <Text color={POKER_COLORS.gold} fontSize="sm">
                              {selectedTournamentForAudit.currency === 'pkcash' ? '$' : ''}{selectedTournamentForAudit.buyInAmount}
                            </Text>
                          </HStack>
                          <HStack>
                            <Text color="gray.400" fontSize="sm">Prize Pool:</Text>
                            <Text color={POKER_COLORS.gold} fontSize="sm">
                              {selectedTournamentForAudit.currency === 'pkcash' ? '$' : ''}{(selectedTournamentForAudit.prizePool || 0).toFixed(2)}
                            </Text>
                          </HStack>
                          <HStack>
                            <Text color="gray.400" fontSize="sm">Rake:</Text>
                            <Text color="orange.400" fontSize="sm">
                              {selectedTournamentForAudit.houseRakePercent || 0}% 
                              ({selectedTournamentForAudit.currency === 'pkcash' ? '$' : ''}
                              {((selectedTournamentForAudit.registeredPlayers?.length || 0) * selectedTournamentForAudit.buyInAmount * (selectedTournamentForAudit.houseRakePercent || 0) / 100).toFixed(2)})
                            </Text>
                          </HStack>
                          <HStack>
                            <Text color="gray.400" fontSize="sm">Prizes Paid:</Text>
                            <Text color={(selectedTournamentForAudit as any).awardedPrizes ? 'green.400' : 'gray.400'} fontSize="sm">
                              {Object.keys((selectedTournamentForAudit as any).awardedPrizes || {}).length}
                            </Text>
                          </HStack>
                        </VStack>
                      </Box>
                    </SimpleGrid>
                    
                    {/* Registered Players List */}
                    <Box p={3} bg="blackAlpha.400" borderRadius="lg" border="1px solid" borderColor="gray.700" mb={4}>
                      <Text color="gray.500" fontSize="xs" mb={2}>Registered Players ({selectedTournamentForAudit.registeredPlayers?.length || 0})</Text>
                      <Wrap spacing={2}>
                        {(selectedTournamentForAudit.registeredPlayers || []).map((playerId: string, idx: number) => (
                          <WrapItem key={playerId}>
                            <Badge 
                              colorScheme={
                                (selectedTournamentForAudit as any).eliminatedPlayers?.includes(playerId) ? 'red' :
                                (selectedTournamentForAudit as any).activePlayers?.includes(playerId) ? 'green' : 'gray'
                              }
                              fontSize="2xs"
                            >
                              {playerId.substring(0, 8)}...
                              {(selectedTournamentForAudit as any).eliminations?.[playerId]?.position && 
                                ` (#${(selectedTournamentForAudit as any).eliminations[playerId].position})`
                              }
                            </Badge>
                          </WrapItem>
                        ))}
                      </Wrap>
                    </Box>
                    
                    {/* Admin Actions */}
                    <Box p={3} bg="blackAlpha.400" borderRadius="lg" border="1px solid" borderColor="red.900">
                      <Text color="red.400" fontSize="xs" mb={2}> Admin Actions</Text>

                      <HStack spacing={2} flexWrap="wrap">
                        {selectedTournamentForAudit.status !== 'completed' && selectedTournamentForAudit.status !== 'cancelled' && (
                          <>
                            <PokerButton 
                              size="xs" 
                              colorScheme="red" 
                              variant="outline"
                              onClick={() => handleCancelTournament(selectedTournamentForAudit.id, selectedTournamentForAudit.name)}
                            >
                              Cancel & Refund All
                            </PokerButton>
                            {(selectedTournamentForAudit.status === 'running' || selectedTournamentForAudit.status === 'late_reg') && (
                              <>
                                <PokerButton 
                                  size="xs" 
                                  colorScheme="yellow" 
                                  variant="outline"
                                  onClick={() => handleAdvanceBlindLevel(selectedTournamentForAudit.id)}
                                >
                                  Advance Blinds
                                </PokerButton>
                                <PokerButton 
                                  size="xs" 
                                  colorScheme="purple" 
                                  variant="outline"
                                  onClick={() => handleBalanceTables(selectedTournamentForAudit.id)}
                                >
                                  Balance Tables
                                </PokerButton>
                              </>
                            )}
                          </>
                        )}
                        <PokerButton 
                          size="xs" 
                          colorScheme="cyan" 
                          variant="outline"
                          onClick={() => handleExportTournamentData(selectedTournamentForAudit)}
                        >
                          Export JSON
                        </PokerButton>
                      </HStack>
                    </Box>
                  </PokerCard>
                )}
              </VStack>
            </TabPanel>

            {/* Tournament Rake Tab */}
            <TabPanel px={0}>
              <VStack spacing={4} align="stretch">
                <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
                  <PokerCard p={4} borderColor={POKER_COLORS.gold} borderWidth={1}>
                    <Text color="gray.500" fontSize="sm">Total Tournament Rake</Text>
                    <Text color={POKER_COLORS.gold} fontSize="2xl" fontWeight="bold">${stats.tournamentRakeTotal.toFixed(2)}</Text>
                  </PokerCard>
                  <PokerCard p={4}>
                    <Text color="gray.500" fontSize="sm">Agent Payouts</Text>
                    <Text color="purple.400" fontSize="2xl" fontWeight="bold">${stats.tournamentRakeAgentPaid.toFixed(2)}</Text>
                  </PokerCard>
                  <PokerCard p={4}>
                    <Text color="gray.500" fontSize="sm">House Net</Text>
                    <Text color="green.400" fontSize="2xl" fontWeight="bold">${stats.tournamentRakeHouseNet.toFixed(2)}</Text>
                  </PokerCard>
                </SimpleGrid>

                <PokerCard>
                  <Text color={POKER_COLORS.gold} fontWeight="bold" mb={4}>Recent Tournament Rake</Text>
                  {tournamentRakeTransactions.length === 0 ? (
                    <Text color="gray.500" textAlign="center" py={4}>No tournament rake collected yet</Text>
                  ) : (
                    <Box overflowX="auto">
                      <Table size="sm">
                        <Thead>
                          <Tr>
                            <Th color="gray.500">Tournament</Th>
                            <Th color="gray.500">Players</Th>
                            <Th color="gray.500">Buy-ins</Th>
                            <Th color="gray.500">Rake</Th>
                            <Th color="gray.500">House</Th>
                            <Th color="gray.500">Date</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {tournamentRakeTransactions.map(tx => (
                            <Tr key={tx.id}>
                              <Td color="white">{tx.tournamentName}</Td>
                              <Td color="gray.400">{tx.playerCount}</Td>
                              <Td color={POKER_COLORS.gold}>${tx.totalBuyIns.toFixed(2)}</Td>
                              <Td color="yellow.400">${tx.totalRake.toFixed(2)}</Td>
                              <Td color="green.400">${tx.houseRake.toFixed(2)}</Td>
                              <Td color="gray.500">{tx.timestamp.toLocaleDateString()}</Td>
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
                    </Box>
                  )}
                </PokerCard>
              </VStack>
            </TabPanel>

            {/*  NEW: Redemptions Tab */}

            <TabPanel px={0}>
              <VStack spacing={4} align="stretch">
                <PokerCard>
                  <HStack justify="space-between" mb={4}>
                    <Text color="orange.400" fontWeight="bold">Pending Redemptions ({stats.pendingRedemptions})</Text>
                    <Text color="gray.400" fontSize="sm">Total: ${stats.pendingRedemptionAmount.toFixed(2)}</Text>
                  </HStack>

                  {redemptions.filter(r => ['pending_review', 'approved', 'processing'].includes(r.status)).length === 0 ? (
                    <VStack py={8}>
                      <CheckCircle size={48} color="green" />
                      <Text color="gray.500">No pending redemptions</Text>
                    </VStack>
                  ) : (
                    <Box overflowX="auto">
                      <Table size="sm">
                        <Thead>
                          <Tr>
                            <Th color="gray.500">User</Th>
                            <Th color="gray.500">Amount</Th>
                            <Th color="gray.500">KYC</Th>
                            <Th color="gray.500">Playthrough</Th>
                            <Th color="gray.500">Requested</Th>
                            <Th color="gray.500">Actions</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {redemptions.filter(r => ['pending_review', 'approved', 'processing'].includes(r.status)).map(r => (
                            <Tr key={r.id}>
                              <Td>
                                <VStack align="start" spacing={0}>
                                  <Text color="white">{r.username || r.odD?.substring(0, 8) || 'Unknown'}</Text>
                                  <Text color="gray.500" fontSize="xs">{r.email}</Text>
                                </VStack>
                              </Td>
                              <Td color={POKER_COLORS.gold} fontWeight="bold">${r.amount.toFixed(2)}</Td>
                              <Td>
                                <Badge colorScheme="green">
                                   Verified

                                </Badge>
                              </Td>
                              <Td>
                                <Badge colorScheme="green">
                                   Validated

                                </Badge>
                              </Td>
                              <Td color="gray.400">{r.requestedAt.toLocaleDateString()}</Td>
                              <Td>
                                <HStack spacing={2}>
                                  <Button
                                    size="xs"
                                    colorScheme="green"
                                    leftIcon={<CheckCircle size={12} />}
                                    onClick={() => handleRedemptionClick(r, 'approve')}
                                  >
                                    {r.status === 'processing' ? (r.payoutBatchId ? 'Enter code / mark paid' : 'Retry') : r.status === 'approved' ? 'Pay' : 'Approve'}
                                  </Button>
                                  {r.status !== 'processing' && (
                                  <Button
                                    size="xs"
                                    colorScheme="red"
                                    leftIcon={<XCircle size={12} />}
                                    onClick={() => handleRedemptionClick(r, 'reject')}
                                  >
                                    Reject
                                  </Button>
                                  )}
                                  {r.status !== 'pending_review' && <Badge colorScheme={r.status === 'processing' ? 'purple' : 'blue'} fontSize="0.6rem">{r.status}{r.payoutMethod ? ` · ${r.payoutMethod}` : ''}</Badge>}
                                </HStack>
                              </Td>
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
                    </Box>
                  )}
                </PokerCard>

                {/* All Redemptions History */}
                <PokerCard>
                  <Text color={POKER_COLORS.cyan} fontWeight="bold" mb={4}>Redemption History</Text>
                  <Box overflowX="auto">
                    <Table size="sm">
                      <Thead>
                        <Tr>
                          <Th color="gray.500">User</Th>
                          <Th color="gray.500">Amount</Th>
                          <Th color="gray.500">Status</Th>
                          <Th color="gray.500">Requested</Th>
                          <Th color="gray.500">Note</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {redemptions.map(r => (
                          <Tr key={r.id}>
                            <Td color="white">{r.username || r.odD?.substring(0, 8) || 'Unknown'}</Td>
                            <Td color={POKER_COLORS.gold}>${r.amount.toFixed(2)}</Td>
                            <Td>{getStatusBadge(r.status)}</Td>
                            <Td color="gray.400">{r.requestedAt.toLocaleDateString()}</Td>
                            <Td color="gray.500" fontSize="xs">{r.reviewNote || '-'}</Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </Box>
                </PokerCard>
              </VStack>
            </TabPanel>

            {/*  NEW: Bypass Codes Tab */}

            <TabPanel px={0}>
              <VStack spacing={4} align="stretch">
                {/* Stats Cards */}
                <SimpleGrid columns={{ base: 1, md: 4 }} spacing={4}>
                  <PokerCard p={4}>
                    <Text color="gray.500" fontSize="sm">Total Codes</Text>
                    <Text color={POKER_COLORS.cyan} fontSize="2xl" fontWeight="bold">{stats.totalBypassCodes}</Text>
                  </PokerCard>
                  <PokerCard p={4}>
                    <Text color="gray.500" fontSize="sm">Active Codes</Text>
                    <Text color="green.400" fontSize="2xl" fontWeight="bold">{stats.activeBypassCodes}</Text>
                  </PokerCard>
                  <PokerCard p={4}>
                    <Text color="gray.500" fontSize="sm">Uses This Month</Text>
                    <Text color={POKER_COLORS.gold} fontSize="2xl" fontWeight="bold">{stats.bypassCodeUsageThisMonth}</Text>
                  </PokerCard>
                  <PokerCard p={4}>
                    <Text color="gray.500" fontSize="sm">Agent Codes</Text>
                    <Text color="purple.400" fontSize="2xl" fontWeight="bold">{bypassCodes.filter(c => c.ownerType === 'agent').length}</Text>
                  </PokerCard>
                </SimpleGrid>

                {/* Code Management */}
                <PokerCard>
                  <HStack justify="space-between" mb={4} flexWrap="wrap" gap={3}>
                    <HStack spacing={3}>
                      <Text color={POKER_COLORS.cyan} fontWeight="bold">Bypass Codes ({filteredBypassCodes.length})</Text>
                      <Select 
                        size="sm" 
                        value={bypassCodeFilter} 
                        onChange={(e) => setBypassCodeFilter(e.target.value as any)}
                        bg={POKER_COLORS.darkBg}
                        borderColor={POKER_COLORS.cyan}
                        color="white"
                        w="auto"
                      >
                        <option value="all" style={{background: '#0D1B2A'}}>All</option>
                        <option value="admin" style={{background: '#0D1B2A'}}>Admin</option>
                        <option value="agent" style={{background: '#0D1B2A'}}>Agent</option>
                      </Select>
                    </HStack>
                    <HStack spacing={3}>
                      <Input 
                        placeholder="Search codes..."
                        size="sm"
                        value={bypassCodeSearch}
                        onChange={(e) => setBypassCodeSearch(e.target.value)}
                        bg={POKER_COLORS.darkBg}
                        borderColor="gray.600"
                        color="white"
                        w="200px"
                      />
                      <PokerButton 
                        size="sm" 
                        variant="primary" 
                        leftIcon={<Plus size={14} />}
                        onClick={onBypassCodeOpen}
                      >
                        Create Code
                      </PokerButton>
                    </HStack>
                  </HStack>

                  {filteredBypassCodes.length === 0 ? (
                    <VStack py={8}>
                      <Key size={48} color={POKER_COLORS.cyan} />
                      <Text color="gray.500" textAlign="center">No bypass codes found</Text>
                      <Text color="gray.600" fontSize="sm">Create one to allow users to skip the $0.50 fee</Text>
                    </VStack>
                  ) : (
                    <Box overflowX="auto">
                      <Table size="sm">
                        <Thead>
                          <Tr>
                            <Th color="gray.500">Code</Th>
                            <Th color="gray.500">Owner</Th>
                            <Th color="gray.500">Type</Th>
                            <Th color="gray.500">Uses</Th>
                            <Th color="gray.500">Last Used</Th>
                            <Th color="gray.500">Status</Th>
                            <Th color="gray.500">Actions</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {filteredBypassCodes.map(code => (
                            <Tr key={code.id}>
                              <Td>
                                <HStack>
                                  <Text color={POKER_COLORS.cyan} fontFamily="mono" fontWeight="bold">{code.code}</Text>
                                  <Tooltip label={copiedCodeId === code.id ? 'Copied!' : 'Copy code'}>
                                    <IconButton
                                      aria-label="Copy code"
                                      icon={<Copy size={14} />}
                                      size="xs"
                                      variant="ghost"
                                      colorScheme="cyan"
                                      onClick={() => handleCopyBypassCode(code.code, code.id)}
                                    />
                                  </Tooltip>
                                </HStack>
                              </Td>
                              <Td color="white">{code.ownerName}</Td>
                              <Td>
                                <Badge colorScheme={code.ownerType === 'admin' ? 'purple' : 'cyan'}>
                                  {code.ownerType}
                                </Badge>
                              </Td>
                              <Td color={POKER_COLORS.gold}>{code.usageCount}</Td>
                              <Td color="gray.400">
                                {code.lastUsedAt ? code.lastUsedAt.toLocaleDateString() : 'Never'}
                              </Td>
                              <Td>
                                <Badge colorScheme={code.active ? 'green' : 'red'}>
                                  {code.active ? 'Active' : 'Inactive'}
                                </Badge>
                              </Td>
                              <Td>
                                <HStack spacing={1}>
                                  <Tooltip label={code.active ? 'Deactivate' : 'Reactivate'}>
                                    <IconButton
                                      aria-label="Toggle code"
                                      icon={code.active ? <ToggleRight size={16} /> : <ToggleLeft size={16} />}
                                      size="xs"
                                      colorScheme={code.active ? 'green' : 'gray'}
                                      variant="ghost"
                                      onClick={() => handleToggleBypassCode(code.id, code.active)}
                                    />
                                  </Tooltip>
                                  <Tooltip label="Delete code">
                                    <IconButton
                                      aria-label="Delete code"
                                      icon={<Trash2 size={14} />}
                                      size="xs"
                                      colorScheme="red"
                                      variant="ghost"
                                      onClick={() => handleDeleteBypassCode(code.id)}
                                    />
                                  </Tooltip>
                                </HStack>
                              </Td>
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
                    </Box>
                  )}
                </PokerCard>

                {/* Recent Usage Logs */}
                <PokerCard>
                  <Text color={POKER_COLORS.gold} fontWeight="bold" mb={4}>Recent Bypass Code Usage</Text>
                  {bypassCodeUsageLogs.length === 0 ? (
                    <Text color="gray.500" textAlign="center" py={4}>No usage yet</Text>
                  ) : (
                    <Box overflowX="auto">
                      <Table size="sm">
                        <Thead>
                          <Tr>
                            <Th color="gray.500">Code</Th>
                            <Th color="gray.500">Used By</Th>
                            <Th color="gray.500">Owner</Th>
                            <Th color="gray.500">Table</Th>
                            <Th color="gray.500">Date</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {bypassCodeUsageLogs.slice(0, 20).map(log => (
                            <Tr key={log.id}>
                              <Td color={POKER_COLORS.cyan} fontFamily="mono">{log.code}</Td>
                              <Td color="white">{log.usedByName || log.usedBy.substring(0, 8)}</Td>
                              <Td color="gray.400">{log.ownerName}</Td>
                              <Td color="gray.400">{log.tableName || log.tableId.substring(0, 8)}</Td>
                              <Td color="gray.500">{log.usedAt.toLocaleString()}</Td>
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
                    </Box>
                  )}
                </PokerCard>
              </VStack>
            </TabPanel>

            {/* Users Tab */}
            <TabPanel px={0}>
              <PokerCard>
                <HStack justify="space-between" mb={4} flexWrap="wrap" gap={2}>
                  <HStack>
                    <Text color={POKER_COLORS.cyan} fontWeight="bold">Users ({filteredUsersList.length})</Text>
                    {selectedUsersForDelete.size > 0 && (
                      <Badge colorScheme="red" ml={2}>{selectedUsersForDelete.size} selected</Badge>
                    )}
                  </HStack>
                  <HStack>
                    <Input
                      placeholder="Search users..."
                      value={userSearchFilter}
                      onChange={(e) => setUserSearchFilter(e.target.value)}
                      size="sm"
                      width="200px"
                      bg={POKER_COLORS.darkBg}
                      borderColor={POKER_COLORS.cyan}
                      color="white"
                    />
                    {selectedUsersForDelete.size > 0 && (
                      <PokerButton
                        size="sm"
                        variant="danger"
                        leftIcon={<Trash2 size={14} />}
                        onClick={onMassDeleteOpen}
                        bg="red.600"
                        _hover={{ bg: 'red.500' }}
                      >
                        Delete {selectedUsersForDelete.size} Users
                      </PokerButton>
                    )}
                    <PokerButton 
                      size="sm" 
                      variant="primary" 
                      leftIcon={<Send size={14} />} 
                      onClick={() => { setSendCoinsPreset(null); onSendOpen(); }}
                      bg={POKER_COLORS.gold}
                      color="black"
                    >
                      Send Coins
                    </PokerButton>
                  </HStack>
                </HStack>
                <Text color="gray.500" fontSize="xs" mb={2}> Select users with checkboxes for mass delete, or click  to manage individual users</Text>

                <Box overflowX="auto">
                  <Table size="sm">
                    <Thead>
                      <Tr>
                        <Th color="gray.500" width="40px">
                          <Checkbox
                            isChecked={selectedUsersForDelete.size > 0 && selectedUsersForDelete.size === filteredUsersList.slice(0, 100).filter(u => u.role !== 'admin' && !(u as any).isAdmin).length}
                            isIndeterminate={selectedUsersForDelete.size > 0 && selectedUsersForDelete.size < filteredUsersList.slice(0, 100).filter(u => u.role !== 'admin' && !(u as any).isAdmin).length}
                            onChange={toggleSelectAll}
                            colorScheme="cyan"
                          />
                        </Th>
                        <Th color="gray.500">Username</Th>
                        <Th color="gray.500">Email</Th>
                        <Th color="gray.500">PlayCoins</Th>
                        <Th color="gray.500">PKCash</Th>
                        <Th color="gray.500">Status</Th>
                        <Th color="gray.500">Joined</Th>
                        <Th color="gray.500">Actions</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {filteredUsersList.slice(0, 100).map(u => {
                        const isUserAdmin = u.role === 'admin' || (u as any).isAdmin;
                        return (
                          <Tr 
                            key={u.id} 
                            _hover={{ bg: `${POKER_COLORS.cyan}11` }}
                            opacity={(u as any).banned ? 0.6 : 1}
                            bg={selectedUsersForDelete.has(u.id) ? `${POKER_COLORS.red}22` : 'transparent'}
                          >
                            <Td>
                              <Checkbox
                                isChecked={selectedUsersForDelete.has(u.id)}
                                onChange={() => toggleUserSelection(u.id)}
                                isDisabled={isUserAdmin}
                                colorScheme="cyan"
                                title={isUserAdmin ? "Cannot delete admin accounts" : "Select for deletion"}
                              />
                            </Td>
                            <Td color="white">
                              <HStack>
                                <Text>{u.username}</Text>
                                {isUserAdmin && <Badge colorScheme="purple" size="sm">Admin</Badge>}
                              </HStack>
                            </Td>
                            <Td color="gray.400">{u.email}</Td>
                            <Td color={POKER_COLORS.cyan}>{u.playCoins.toLocaleString()}</Td>
                            <Td color={POKER_COLORS.gold}>${u.pkCash.toFixed(2)}</Td>
                            <Td>
                              {(u as any).banned ? (
                                <Badge colorScheme="red"> Banned</Badge>

                              ) : u.kycStatus === 'verified' ? (
                                <Badge colorScheme="green">Verified</Badge>
                              ) : (
                                <Badge colorScheme="gray">Active</Badge>
                              )}
                            </Td>
                            <Td color="gray.500">{u.createdAt.toLocaleDateString()}</Td>
                            <Td>
                              <HStack spacing={1}>
                                <PokerButton
                                  size="xs"
                                  variant="secondary"
                                  onClick={() => { setSendCoinsPreset({ id: u.id, username: u.username }); onSendOpen(); }}
                                  title="Send Coins (PlayCoins or PKCash)"
                                >
                                  <Gift size={13} />
                                </PokerButton>
                                {(u as any).banned ? (
                                  <PokerButton
                                    size="xs"
                                    variant="primary"
                                    bg="green.600"
                                    onClick={() => handleUnbanUser(u.id, u.username)}
                                    title="Unban User"
                                  >
                                    <UserCheck size={13} />
                                  </PokerButton>
                                ) : (
                                  <PokerButton
                                    size="xs"
                                    variant="danger"
                                    onClick={() => handleOpenUserManage(u)}
                                    title="Manage User (ban / delete / audit)"
                                  >
                                    <Settings size={13} />
                                  </PokerButton>
                                )}
                              </HStack>
                            </Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                </Box>
                {filteredUsersList.length > 100 && (
                  <Text color="gray.500" fontSize="xs" mt={2} textAlign="center">
                    Showing first 100 of {filteredUsersList.length} users. Use search to find specific users.
                  </Text>
                )}
              </PokerCard>
            </TabPanel>

            {/* Agents Tab */}
            <TabPanel px={0}>
              <PokerCard>
                <HStack justify="space-between" mb={4}>
                  <Text color={POKER_COLORS.cyan} fontWeight="bold">Agents ({agents.length})</Text>
                  <PokerButton size="sm" variant="primary" leftIcon={<UserPlus size={14} />} onClick={onAgentOpen}>Add Agent</PokerButton>
                </HStack>
                {agents.length === 0 ? (
                  <Text color="gray.500" textAlign="center" py={8}>No agents yet. Add one to enable referral commissions!</Text>
                ) : (
                  <Box overflowX="auto">
                    <Table size="sm">
                      <Thead><Tr><Th color="gray.500">Name</Th><Th color="gray.500">Code</Th><Th color="gray.500">Role</Th><Th color="gray.500">Tier</Th><Th color="gray.500">Referrals</Th><Th color="gray.500">Earned</Th><Th color="gray.500">Status</Th><Th color="gray.500">Actions</Th></Tr></Thead>
                      <Tbody>
                        {agents.map(a => (
                          <Tr key={a.id}>
                            <Td><Text color="white">{a.displayName}</Text><Text color="gray.500" fontSize="xs">{a.email}</Text></Td>
                            <Td><Text color={POKER_COLORS.cyan} fontFamily="mono" fontWeight="bold">{a.code}</Text></Td>
                            <Td>
                              {a.role === 'manager'
                                ? <Badge colorScheme="orange">Manager</Badge>
                                : <Badge colorScheme="gray">Agent{a.managerId ? ` · under ${agents.find(m => m.id === a.managerId)?.displayName || 'manager'}` : ''}</Badge>}
                            </Td>
                            <Td><Badge colorScheme={a.tier === 'vip' ? 'yellow' : a.tier === 'premium' ? 'purple' : 'blue'}>{a.tier}</Badge></Td>
                            <Td color="white">{a.totalReferrals}</Td>
                            <Td><Text color={POKER_COLORS.gold}>${(a.totalRakeEarned + (a.totalPurchaseCommission || 0) + (a.totalOverrideEarned || 0)).toFixed(2)}</Text><Text color="gray.500" fontSize="xs">rake ${a.totalRakeEarned.toFixed(2)}{a.totalOverrideEarned ? ` · override $${a.totalOverrideEarned.toFixed(2)}` : ''}</Text></Td>
                            <Td><Badge colorScheme={a.active ? 'green' : 'red'}>{a.active ? 'Active' : 'Inactive'}</Badge></Td>
                            <Td>
                              <HStack spacing={2}>
                                <PokerButton size="xs" variant="secondary" onClick={() => openAgentSettings(a)} leftIcon={<Settings size={12} />}>
                                  Settings
                                </PokerButton>
                                {a.active && (
                                  <>
                                    <PokerButton 
                                      size="xs" 
                                      variant="primary" 
                                      onClick={() => handleOpenAssignUser(a)}
                                      leftIcon={<UserPlus size={12} />}
                                    >
                                      Assign User
                                    </PokerButton>
                                    <PokerButton size="xs" variant="secondary" onClick={() => handleDeactivateAgent(a.id)}>
                                      <Trash2 size={14} />
                                    </PokerButton>
                                  </>
                                )}
                              </HStack>
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </Box>
                )}
              </PokerCard>

              {/* Creator tournaments awaiting approval */}
              <PokerCard>
                <HStack justify="space-between" mb={3} flexWrap="wrap" gap={2}>
                  <Text color={POKER_COLORS.cyan} fontWeight="bold">Creator Tournaments Awaiting Approval ({pendingHostTournaments.length})</Text>
                  <Button size="xs" variant="outline" isLoading={backfillingGroups} onClick={async () => {
                    setBackfillingGroups(true);
                    const r = await gameApiService.adminBackfillCreatorGroups();
                    setBackfillingGroups(false);
                    toast({ title: r.success ? `Creator groups ready: ${r.groups} groups, ${r.playersAdded} players added` : 'Backfill failed', description: r.success ? undefined : r.error, status: r.success ? 'success' : 'error', duration: 5000 });
                  }}>Create creator groups for all agents</Button>
                </HStack>
                <Text color="gray.500" fontSize="xs" mb={3}>
                  Creators get two tournaments a month without asking. Anything past that lands here. Approve lists it in the lobby and pushes the creator's crew; decline cancels it and tells the host why.
                </Text>
                {pendingHostTournaments.length === 0 ? (
                  <Text color="gray.500" fontSize="sm">Nothing waiting.</Text>
                ) : (
                  <VStack align="stretch" spacing={2}>
                    {pendingHostTournaments.map(t => (
                      <HStack key={t.id} p={3} bg="whiteAlpha.50" borderRadius="md" justify="space-between" flexWrap="wrap" gap={2}>
                        <Box minW={0}>
                          <HStack spacing={2} flexWrap="wrap">
                            <Text color="white" fontWeight="semibold" fontSize="sm">{t.name}</Text>
                            <Badge colorScheme="yellow" fontSize="0.6rem">by {t.hostName || t.hostId.slice(0, 8)}</Badge>
                            {t.media !== 'off' && <Badge colorScheme="green" fontSize="0.6rem">{t.media === 'video' ? `video · ${t.mediaScope === 'final' ? 'final table' : 'all tables'}` : 'voice'}</Badge>}
                            <Badge fontSize="0.6rem">{t.entry === 'code' ? 'code entry' : t.entry === 'group' ? 'crew only' : 'open'}</Badge>
                          </HStack>
                          <Text color="gray.400" fontSize="xs">{t.startTime ? new Date(t.startTime).toLocaleString() : ''} · {t.currency === 'pkcash' ? `$${t.buyInAmount}` : t.buyInAmount === 0 ? 'Free' : `${t.buyInAmount.toLocaleString()} PC`} · {t.structure} · up to {t.maxPlayers}</Text>
                        </Box>
                        <HStack spacing={2}>
                          <Button size="xs" colorScheme="green" isLoading={hostActionBusy === t.id} onClick={() => handleHostTournamentAction(t, 'approve')}>Approve</Button>
                          <Button size="xs" colorScheme="red" variant="outline" isLoading={hostActionBusy === t.id} onClick={() => handleHostTournamentAction(t, 'reject')}>Decline</Button>
                        </HStack>
                      </HStack>
                    ))}
                  </VStack>
                )}
              </PokerCard>

              {/* Agent payout requests */}
              <PokerCard>
                <HStack justify="space-between" mb={3} flexWrap="wrap" gap={2}>
                  <Text color={POKER_COLORS.cyan} fontWeight="bold">Agent Payout Requests ({agentPayoutRequests.length})</Text>
                  <Button size="xs" variant={showAllPayouts ? 'solid' : 'outline'} onClick={async () => { const next = !showAllPayouts; setShowAllPayouts(next); const r = await gameApiService.adminAgentPayouts(next ? 'all' : 'open'); if (r.success) setAgentPayoutRequests(r.payouts); }}>
                    {showAllPayouts ? 'Showing all' : 'Open only'}
                  </Button>
                </HStack>
                <Text color="gray.500" fontSize="xs" mb={3}>
                  Approve reviews the request. PayPal: send the money from your PayPal by hand, then Mark paid with the transaction id. USDC: Send USDC creates the NOWPayments withdrawal, then Verify code releases it and it closes itself when the network confirms. Reject returns the amount to the agent's rake balance.
                </Text>
                {agentPayoutRequests.length === 0 ? (
                  <Text color="gray.500" textAlign="center" py={6}>No {showAllPayouts ? '' : 'open '}payout requests.</Text>
                ) : (
                  <Box overflowX="auto">
                    <Table size="sm">
                      <Thead><Tr><Th color="gray.500">Agent</Th><Th color="gray.500">Amount</Th><Th color="gray.500">Requested</Th><Th color="gray.500">Status</Th><Th color="gray.500">Send to</Th><Th color="gray.500">Actions</Th></Tr></Thead>
                      <Tbody>
                        {agentPayoutRequests.map(row => {
                          const open = row.status === 'pending_review' || row.status === 'approved' || row.status === 'processing';
                          const busy = payoutBusyId === row.id;
                          const usdc = row.payoutMethod === 'usdc';
                          const inFlight = row.status === 'processing' && !!row.payoutBatchId;
                          const released = inFlight && row.payoutProviderStatus === 'verified';
                          return (
                            <Tr key={row.id}>
                              <Td><Text color="white">{row.username}</Text><Text color="gray.500" fontSize="xs">{row.email}</Text></Td>
                              <Td color={POKER_COLORS.gold} fontWeight="bold">${Number(row.amount).toFixed(2)}</Td>
                              <Td color="gray.400" fontSize="xs">{row.requestedAt ? new Date(row.requestedAt).toLocaleString() : ''}</Td>
                              <Td><Badge colorScheme={row.status === 'paid' ? 'green' : row.status === 'rejected' ? 'red' : row.status === 'approved' ? 'cyan' : 'orange'}>{row.status.replace('_', ' ')}</Badge>{row.adminNote && <Text color="gray.500" fontSize="xs">{row.adminNote}</Text>}</Td>
                              <Td fontSize="xs">
                                <Text color={usdc ? 'purple.300' : 'cyan.300'} fontWeight="bold">{usdc ? `USDC${row.payoutDestination?.network ? ` (${row.payoutDestination.network})` : ''}` : row.payoutMethod === 'paypal' ? 'PayPal' : 'none'}</Text>
                                <Text color="gray.300" wordBreak="break-all">{row.payoutDestination?.value || ''}</Text>
                                {row.payoutReference && <Text color="green.300">{row.payoutReference}</Text>}
                                {row.payoutError && <Text color="red.300">{row.payoutError}</Text>}
                                {inFlight && <Text color="orange.300">{released ? 'released, confirming on-chain' : 'withdrawal created, needs code'}</Text>}
                              </Td>
                              <Td>
                                {open ? (
                                  <HStack spacing={1} flexWrap="wrap">
                                    {row.status === 'pending_review' && <Button size="xs" colorScheme="cyan" variant="outline" isLoading={busy} onClick={() => handlePayoutAction(row, 'approve')}>Approve</Button>}
                                    {usdc && !inFlight && <Button size="xs" colorScheme="purple" isLoading={busy} isDisabled={!row.payoutDestination?.value} onClick={() => handlePayoutAction(row, 'sendUsdc')}>Send USDC</Button>}
                                    {usdc && inFlight && !released && <Button size="xs" colorScheme="purple" isLoading={busy} onClick={() => handlePayoutAction(row, 'verifyUsdc')}>Verify code</Button>}
                                    {!released && <Button size="xs" variant="outline" isLoading={busy} onClick={() => handlePayoutAction(row, 'paid')}>Mark paid</Button>}
                                    {!released && <Button size="xs" colorScheme="red" variant="ghost" isLoading={busy} onClick={() => handlePayoutAction(row, 'reject')}>Reject</Button>}
                                  </HStack>
                                ) : (
                                  <Text color="gray.500" fontSize="xs">{row.paidAt ? `paid ${new Date(row.paidAt).toLocaleDateString()}` : ''}</Text>
                                )}
                              </Td>
                            </Tr>
                          );
                        })}
                      </Tbody>
                    </Table>
                  </Box>
                )}
              </PokerCard>
            </TabPanel>

            {/* Tables Tab */}
            <TabPanel px={0}>
              <PokerCard>
                <HStack justify="space-between" mb={4} flexWrap="wrap" gap={2}>
                  <Text color={POKER_COLORS.cyan} fontWeight="bold">Tables ({stats.totalTables})</Text>
                  <HStack spacing={2}>
                    <PokerButton size="sm" variant="secondary" leftIcon={<RefreshCw size={14} />} onClick={handleResetFeaturedTables}>Reset Featured</PokerButton>
                    <PokerButton size="sm" variant="secondary" leftIcon={<Trash2 size={14} />} onClick={handleCleanup}>Cleanup Empty</PokerButton>
                    <PokerButton size="sm" variant="secondary" leftIcon={<DollarSign size={14} />} onClick={handleRefundStranded}>Refund Stranded</PokerButton>
                    <PokerButton size="sm" variant="secondary" leftIcon={<Shield size={14} />} onClick={handleMoneyAudit}>Run Money Audit</PokerButton>
                  </HStack>
                </HStack>
                <SimpleGrid columns={2} spacing={4}>
                  <Box p={4} bg={`${POKER_COLORS.darkTeal}44`} borderRadius="lg">
                    <Text color="gray.500" fontSize="sm">Active</Text>
                    <Text color={POKER_COLORS.darkGreen} fontSize="2xl" fontWeight="bold">{stats.activeTables}</Text>
                  </Box>
                  <Box p={4} bg={`${POKER_COLORS.darkTeal}44`} borderRadius="lg">
                    <Text color="gray.500" fontSize="sm">Empty</Text>
                    <Text color="red.400" fontSize="2xl" fontWeight="bold">{stats.totalTables - stats.activeTables}</Text>
                  </Box>
                </SimpleGrid>
              </PokerCard>
            </TabPanel>

            {/*  ENHANCED: Transaction Audit Tab */}

            <TabPanel px={0}>
              <VStack spacing={4} align="stretch">
                {/* Header */}
                <PokerCard>
                  <HStack justify="space-between" flexWrap="wrap" gap={2}>
                    <HStack>
                      <DollarSign size={24} color={POKER_COLORS.cyan} />
                      <Text color={POKER_COLORS.cyan} fontWeight="bold" fontSize="xl">Transaction Audit</Text>
                      <Badge colorScheme="cyan">{filteredTransactions.length} / {allTransactions.length}</Badge>
                    </HStack>
                    <HStack spacing={2}>
                      <PokerButton 
                        size="sm" 
                        variant="secondary" 
                        leftIcon={<Download size={14} />} 
                        onClick={exportTransactionsCSV}
                        isDisabled={!filteredTransactions.length}
                      >
                        Export CSV
                      </PokerButton>
                      <PokerButton 
                        size="sm" 
                        variant="primary" 
                        leftIcon={<RefreshCw size={14} />} 
                        onClick={loadDashboardData}
                        isLoading={refreshing}
                      >
                        Refresh
                      </PokerButton>
                    </HStack>
                  </HStack>
                </PokerCard>

                {/* Filters */}
                <PokerCard>
                  <VStack spacing={4} align="stretch">
                    <HStack justify="space-between">
                      <Text color="gray.300" fontWeight="bold">
                        <Filter size={16} style={{ display: 'inline', marginRight: 8 }} />
                        Filters
                      </Text>
                      <PokerButton
                        size="xs"
                        variant="secondary"
                        onClick={() => setTxFilters({
                          searchTerm: '',
                          transactionType: 'all',
                          currency: 'all',
                          status: 'all',
                          dateFrom: '',
                          dateTo: '',
                          minAmount: '',
                          maxAmount: '',
                        })}
                      >
                        Clear All
                      </PokerButton>
                    </HStack>
                    
                    <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4}>
                      {/* User Search */}
                      <Box>
                        <Text color="gray.500" fontSize="xs" mb={1}>Search User</Text>
                        <InputGroup size="sm">
                          <InputLeftElement><Search size={14} color="#718096" /></InputLeftElement>
                          <Input
                            placeholder="Username, email, or ID..."
                            value={txFilters.searchTerm}
                            onChange={(e) => setTxFilters(f => ({ ...f, searchTerm: e.target.value }))}
                            bg="blackAlpha.400"
                            borderColor="gray.600"
                            color="white"
                          />
                        </InputGroup>
                      </Box>
                      
                      {/* Transaction Type */}
                      <Box>
                        <Text color="gray.500" fontSize="xs" mb={1}>Transaction Type</Text>
                        <Select
                          size="sm"
                          value={txFilters.transactionType}
                          onChange={(e) => setTxFilters(f => ({ ...f, transactionType: e.target.value }))}
                          bg="blackAlpha.400"
                          borderColor="gray.600"
                          color="white"
                        >
                          <option value="all" style={{ background: '#0a1929' }}>All Types</option>
                          <optgroup label="Money In">
                            <option value="deposit" style={{ background: '#0a1929' }}>Deposit</option>
                            <option value="purchase" style={{ background: '#0a1929' }}>Purchase</option>
                            <option value="daily_bonus" style={{ background: '#0a1929' }}>Daily Bonus</option>
                            <option value="signup_bonus" style={{ background: '#0a1929' }}>Signup Bonus</option>
                            <option value="referral_bonus" style={{ background: '#0a1929' }}>Referral Bonus</option>
                            <option value="amoe_grant" style={{ background: '#0a1929' }}>AMOE Grant</option>
                            <option value="admin_grant" style={{ background: '#0a1929' }}>Admin Grant</option>
                            <option value="challenge_prize" style={{ background: '#0a1929' }}>Challenge Prize</option>
                            <option value="tournament_prize" style={{ background: '#0a1929' }}>Tournament Prize</option>
                            <option value="game_win" style={{ background: '#0a1929' }}>Game Win</option>
                            <option value="table_cash_out" style={{ background: '#0a1929' }}>Table Cash Out</option>
                            <option value="transfer_in" style={{ background: '#0a1929' }}>Transfer In</option>
                            <option value="tournament_refund" style={{ background: '#0a1929' }}>Tournament Refund</option>
                          </optgroup>
                          <optgroup label="Money Out">
                            <option value="withdrawal" style={{ background: '#0a1929' }}>Withdrawal</option>
                            <option value="redemption" style={{ background: '#0a1929' }}>Redemption</option>
                            <option value="table_buy_in" style={{ background: '#0a1929' }}>Table Buy In</option>
                            <option value="rebuy" style={{ background: '#0a1929' }}>Rebuy</option>
                            <option value="game_loss" style={{ background: '#0a1929' }}>Game Loss</option>
                            <option value="tournament_registration" style={{ background: '#0a1929' }}>Tournament Registration</option>
                            <option value="transfer_out" style={{ background: '#0a1929' }}>Transfer Out</option>
                            <option value="rake" style={{ background: '#0a1929' }}>Rake</option>
                          </optgroup>
                        </Select>
                      </Box>
                      
                      {/* Currency */}
                      <Box>
                        <Text color="gray.500" fontSize="xs" mb={1}>Currency</Text>
                        <Select
                          size="sm"
                          value={txFilters.currency}
                          onChange={(e) => setTxFilters(f => ({ ...f, currency: e.target.value }))}
                          bg="blackAlpha.400"
                          borderColor="gray.600"
                          color="white"
                        >
                          <option value="all" style={{ background: '#0a1929' }}>All Currencies</option>
                          <option value="pkcash" style={{ background: '#0a1929' }}>PKCash </option>

                          <option value="playcoins" style={{ background: '#0a1929' }}>PlayCoins </option>

                        </Select>
                      </Box>
                      
                      {/* Status */}
                      <Box>
                        <Text color="gray.500" fontSize="xs" mb={1}>Status</Text>
                        <Select
                          size="sm"
                          value={txFilters.status}
                          onChange={(e) => setTxFilters(f => ({ ...f, status: e.target.value }))}
                          bg="blackAlpha.400"
                          borderColor="gray.600"
                          color="white"
                        >
                          <option value="all" style={{ background: '#0a1929' }}>All Statuses</option>
                          <option value="completed" style={{ background: '#0a1929' }}>Completed </option>

                          <option value="pending" style={{ background: '#0a1929' }}>Pending ⏳</option>
                          <option value="processing" style={{ background: '#0a1929' }}>Processing </option>

                          <option value="failed" style={{ background: '#0a1929' }}>Failed </option>

                          <option value="rejected" style={{ background: '#0a1929' }}>Rejected </option>

                        </Select>
                      </Box>
                    </SimpleGrid>
                    
                    <SimpleGrid columns={{ base: 2, md: 4 }} spacing={4}>
                      {/* Date From */}
                      <Box>
                        <Text color="gray.500" fontSize="xs" mb={1}>Date From</Text>
                        <Input
                          type="date"
                          size="sm"
                          value={txFilters.dateFrom}
                          onChange={(e) => setTxFilters(f => ({ ...f, dateFrom: e.target.value }))}
                          bg="blackAlpha.400"
                          borderColor="gray.600"
                          color="white"
                        />
                      </Box>
                      
                      {/* Date To */}
                      <Box>
                        <Text color="gray.500" fontSize="xs" mb={1}>Date To</Text>
                        <Input
                          type="date"
                          size="sm"
                          value={txFilters.dateTo}
                          onChange={(e) => setTxFilters(f => ({ ...f, dateTo: e.target.value }))}
                          bg="blackAlpha.400"
                          borderColor="gray.600"
                          color="white"
                        />
                      </Box>
                      
                      {/* Min Amount */}
                      <Box>
                        <Text color="gray.500" fontSize="xs" mb={1}>Min Amount</Text>
                        <Input
                          type="number"
                          size="sm"
                          placeholder="0.00"
                          value={txFilters.minAmount}
                          onChange={(e) => setTxFilters(f => ({ ...f, minAmount: e.target.value }))}
                          bg="blackAlpha.400"
                          borderColor="gray.600"
                          color="white"
                        />
                      </Box>
                      
                      {/* Max Amount */}
                      <Box>
                        <Text color="gray.500" fontSize="xs" mb={1}>Max Amount</Text>
                        <Input
                          type="number"
                          size="sm"
                          placeholder="999999"
                          value={txFilters.maxAmount}
                          onChange={(e) => setTxFilters(f => ({ ...f, maxAmount: e.target.value }))}
                          bg="blackAlpha.400"
                          borderColor="gray.600"
                          color="white"
                        />
                      </Box>
                    </SimpleGrid>
                  </VStack>
                </PokerCard>

                {/* Transactions Table */}
                <PokerCard>
                  <Box overflowX="auto" maxH="600px" overflowY="auto">
                    <Table size="sm">
                      <Thead position="sticky" top={0} bg={POKER_COLORS.darkBg} zIndex={1}>
                        <Tr>
                          <Th color="gray.500">Date/Time</Th>
                          <Th color="gray.500">Type</Th>
                          <Th color="gray.500">User</Th>
                          <Th color="gray.500" isNumeric>Amount</Th>
                          <Th color="gray.500">Currency</Th>
                          <Th color="gray.500">Status</Th>
                          <Th color="gray.500">Details</Th>
                          <Th color="gray.500">Actions</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {filteredTransactions.length === 0 ? (
                          <Tr>
                            <Td colSpan={8}>
                              <Text color="gray.500" textAlign="center" py={8}>
                                No transactions match your filters
                              </Text>
                            </Td>
                          </Tr>
                        ) : (
                          filteredTransactions.map(tx => {
                            const userDisplay = getUserDisplay(tx.odid);
                            const isCredit = tx.amount >= 0 || tx.type.includes('win') || tx.type.includes('bonus') || 
                                           tx.type.includes('prize') || tx.type.includes('grant') || tx.type.includes('cash_out') ||
                                           tx.type.includes('refund') || tx.type.includes('transfer_in');
                            return (
                              <Tr key={tx.id} _hover={{ bg: 'whiteAlpha.50' }}>
                                <Td>
                                  <VStack align="start" spacing={0}>
                                    <Text color="white" fontSize="sm">{tx.createdAt.toLocaleDateString()}</Text>
                                    <Text color="gray.500" fontSize="xs">{tx.createdAt.toLocaleTimeString()}</Text>
                                  </VStack>
                                </Td>
                                <Td>
                                  <Badge 
                                    colorScheme={
                                      tx.type.includes('purchase') || tx.type.includes('deposit') ? 'green' : 
                                      tx.type.includes('withdrawal') || tx.type.includes('redemption') ? 'red' : 
                                      tx.type.includes('rake') ? 'yellow' :
                                      tx.type.includes('admin') || tx.type.includes('grant') ? 'purple' :
                                      tx.type.includes('win') || tx.type.includes('prize') || tx.type.includes('bonus') ? 'teal' :
                                      tx.type.includes('loss') ? 'orange' :
                                      tx.type.includes('buy_in') || tx.type.includes('rebuy') || tx.type.includes('registration') ? 'blue' :
                                      tx.type.includes('transfer') ? 'pink' :
                                      'gray'
                                    }
                                    fontSize="xs"
                                  >
                                    {tx.type.replace(/_/g, ' ')}
                                  </Badge>
                                </Td>
                                <Td>
                                  <VStack align="start" spacing={0}>
                                    <Text color="white" fontSize="sm" fontWeight="medium">{userDisplay.username}</Text>
                                    {userDisplay.email && (
                                      <Text color="gray.500" fontSize="xs">{userDisplay.email}</Text>
                                    )}
                                  </VStack>
                                </Td>
                                <Td isNumeric>
                                  <HStack justify="flex-end" spacing={1}>
                                    {isCredit ? (
                                      <ArrowDownLeft size={12} color="#48bb78" />
                                    ) : (
                                      <ArrowUpRight size={12} color="#f56565" />
                                    )}
                                    <Text color={isCredit ? 'green.400' : 'red.400'} fontWeight="bold">
                                      {isCredit ? '+' : ''}{tx.amount.toFixed(2)}
                                    </Text>
                                  </HStack>
                                </Td>
                                <Td>
                                  <Badge colorScheme={tx.currency === 'pkcash' ? 'yellow' : 'cyan'} variant="outline">
                                    {tx.currency === 'pkcash' ? ' PKCash' : ' PlayCoins'}

                                  </Badge>
                                </Td>
                                <Td>
                                  <Badge 
                                    colorScheme={
                                      tx.status === 'completed' ? 'green' : 
                                      tx.status === 'pending' ? 'yellow' : 
                                      tx.status === 'processing' ? 'blue' :
                                      tx.status === 'failed' || tx.status === 'rejected' ? 'red' :
                                      'gray'
                                    }
                                  >
                                    {tx.status}
                                  </Badge>
                                </Td>
                                <Td>
                                  <VStack align="start" spacing={0}>
                                    {tx.description && (
                                      <Text color="gray.400" fontSize="xs" maxW="150px" isTruncated title={tx.description}>
                                        {tx.description}
                                      </Text>
                                    )}
                                    {tx.tableId && (
                                      <Text color="gray.600" fontSize="xs">Table: {tx.tableId.substring(0, 8)}...</Text>
                                    )}
                                    {tx.tournamentId && (
                                      <Text color="gray.600" fontSize="xs">Tournament</Text>
                                    )}
                                  </VStack>
                                </Td>
                                <Td>
                                  <HStack spacing={1}>
                                    <Tooltip label="View User Details">
                                      <IconButton
                                        aria-label="View user"
                                        icon={<Eye size={14} />}
                                        size="xs"
                                        variant="ghost"
                                        colorScheme="cyan"
                                        onClick={() => loadUserAudit(tx.odid)}
                                        isLoading={loadingUserAudit}
                                        isDisabled={tx.odid === 'PLATFORM'}
                                      />
                                    </Tooltip>
                                    <Tooltip label="Copy Transaction ID">
                                      <IconButton
                                        aria-label="Copy ID"
                                        icon={<Copy size={14} />}
                                        size="xs"
                                        variant="ghost"
                                        colorScheme="gray"
                                        onClick={() => {
                                          navigator.clipboard.writeText(tx.id);
                                          toast({ title: 'Copied!', status: 'info', duration: 1000 });
                                        }}
                                      />
                                    </Tooltip>
                                  </HStack>
                                </Td>
                              </Tr>
                            );
                          })
                        )}
                      </Tbody>
                    </Table>
                  </Box>
                  
                  {filteredTransactions.length >= 200 && (
                    <Box pt={4} textAlign="center">
                      <Text color="gray.500" fontSize="sm">
                        Showing first 200 results. Use filters to narrow down.
                      </Text>
                    </Box>
                  )}
                </PokerCard>
              </VStack>
            </TabPanel>

            {/*  NEW: Tax/1099 Reporting Tab */}

            <TabPanel px={0}>
              <VStack spacing={6} align="stretch">
                {/* Header */}
                <HStack justify="space-between">
                  <VStack align="start" spacing={1}>
                    <Heading size="md" color="green.400">
                      Tax & 1099 Reporting ({taxYear})
                    </Heading>
                    <Text color="gray.400" fontSize="sm">
                      PKCash earnings tracking for IRS compliance
                    </Text>
                  </VStack>
                  <HStack spacing={3}>
                    <Select 
                      value={taxYear} 
                      onChange={(e) => {
                        const year = parseInt(e.target.value);
                        setTaxYear(year);
                        loadTaxReport(year);
                      }}
                      bg="whiteAlpha.100"
                      borderColor="green.600"
                      color="white"
                      w="120px"
                    >
                      {[2024, 2025, 2026].map(y => (
                        <option key={y} value={y} style={{ background: '#1a1a2e' }}>{y}</option>
                      ))}
                    </Select>
                    <PokerButton 
                      variant="secondary" 
                      onClick={() => loadTaxReport(taxYear)}
                      isLoading={loadingTaxReport}
                      leftIcon={<RefreshCw size={16} />}
                    >
                      Refresh
                    </PokerButton>
                  </HStack>
                </HStack>

                {loadingTaxReport && (
                  <VStack py={12} spacing={4}>
                    <Spinner size="xl" color="green.400" />
                    <Text color="gray.400">Loading tax report...</Text>
                  </VStack>
                )}

                {!taxReport && !loadingTaxReport && (
                  <VStack py={12} spacing={4}>
                    <Receipt size={48} color={POKER_COLORS.cyan} />
                    <Text color="gray.400">Click refresh to load tax report</Text>
                    <PokerButton variant="primary" onClick={() => loadTaxReport()}>
                      Load Tax Report
                    </PokerButton>
                  </VStack>
                )}

                {taxReport && !loadingTaxReport && (
                  <>
                    {/* Summary Stats */}
                    <SimpleGrid columns={{ base: 2, md: 4 }} spacing={4}>
                      <PokerCard>
                        <Stat>
                          <StatLabel color="gray.400">Total Users</StatLabel>
                          <StatNumber color="white">{taxReport.totalUsers}</StatNumber>
                          <StatHelpText color="gray.500">With PKCash activity</StatHelpText>
                        </Stat>
                      </PokerCard>
                      <PokerCard>
                        <Stat>
                          <StatLabel color="gray.400">Requiring 1099</StatLabel>
                          <StatNumber color="yellow.400">{taxReport.usersRequiring1099}</StatNumber>
                          <StatHelpText color="gray.500">≥ ${taxReport.threshold1099} earnings</StatHelpText>
                        </Stat>
                      </PokerCard>
                      <PokerCard>
                        <Stat>
                          <StatLabel color="gray.400">Total Reportable</StatLabel>
                          <StatNumber color="green.400">${taxReport.totalReportableIncome.toFixed(2)}</StatNumber>
                          <StatHelpText color="gray.500">Gross PKCash income</StatHelpText>
                        </Stat>
                      </PokerCard>
                      <PokerCard>
                        <Stat>
                          <StatLabel color="gray.400">1099 Threshold</StatLabel>
                          <StatNumber color="gray.300">${taxReport.threshold1099}</StatNumber>
                          <StatHelpText color="gray.500">IRS requirement</StatHelpText>
                        </Stat>
                      </PokerCard>
                    </SimpleGrid>

                    {/* Users Requiring 1099 */}
                    <PokerCard>
                      <HStack justify="space-between" mb={4}>
                        <Text color="green.400" fontWeight="bold">Users Requiring 1099-MISC</Text>
                        <Badge colorScheme="yellow">{taxReport.usersRequiring1099} users</Badge>
                      </HStack>
                      
                      {taxReport.userBreakdown.filter(u => u.totalIncome >= taxReport.threshold1099).length === 0 ? (
                        <VStack py={8} spacing={3}>
                          <CheckCircle size={48} color="#48BB78" />
                          <Text color="gray.400">No users above 1099 threshold yet</Text>
                        </VStack>
                      ) : (
                        <Box overflowX="auto">
                          <Table size="sm">
                            <Thead>
                              <Tr>
                                <Th color="gray.400">User</Th>
                                <Th color="gray.400">Email</Th>
                                <Th color="gray.400" isNumeric>Total Income</Th>
                                <Th color="gray.400">W-9 Status</Th>
                                <Th color="gray.400">1099 Status</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {taxReport.userBreakdown
                                .filter(u => u.totalIncome >= taxReport.threshold1099)
                                .map((user) => (
                                  <Tr key={user.odD}>
                                    <Td color="white">{user.displayName}</Td>
                                    <Td color="gray.400">{user.email || 'No email'}</Td>
                                    <Td isNumeric color="green.400" fontWeight="bold">
                                      ${user.totalIncome.toFixed(2)}
                                    </Td>
                                    <Td>
                                      <Badge colorScheme={
                                        user.w9Status === 'complete' ? 'green' :
                                        user.w9Status === 'pending' ? 'yellow' : 'red'
                                      }>
                                        {user.w9Status}
                                      </Badge>
                                    </Td>
                                    <Td>
                                      <Badge colorScheme={
                                        user.form1099Status === 'sent' ? 'green' :
                                        user.form1099Status === 'generated' ? 'blue' :
                                        user.form1099Status === 'pending' ? 'yellow' : 'gray'
                                      }>
                                        {user.form1099Status}
                                      </Badge>
                                    </Td>
                                  </Tr>
                                ))}
                            </Tbody>
                          </Table>
                        </Box>
                      )}
                    </PokerCard>

                    {/* All Users with Income */}
                    <PokerCard>
                      <HStack justify="space-between" mb={4}>
                        <Text color="gray.300" fontWeight="bold">All Users with PKCash Income</Text>
                        <Text color="gray.500" fontSize="sm">{taxReport.userBreakdown.length} users</Text>
                      </HStack>
                      <Box overflowX="auto" maxH="400px" overflowY="auto">
                        <Table size="sm">
                          <Thead position="sticky" top={0} bg="gray.800">
                            <Tr>
                              <Th color="gray.400">User</Th>
                              <Th color="gray.400" isNumeric>Total Income</Th>
                              <Th color="gray.400">1099 Required</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {taxReport.userBreakdown.map((user) => (
                              <Tr key={user.odD}>
                                <Td color="white">{user.displayName}</Td>
                                <Td isNumeric color={user.totalIncome >= 600 ? 'yellow.400' : 'gray.400'}>
                                  ${user.totalIncome.toFixed(2)}
                                </Td>
                                <Td>
                                  {user.totalIncome >= 600 ? (
                                    <Badge colorScheme="yellow">Yes</Badge>
                                  ) : (
                                    <Badge colorScheme="gray">No</Badge>
                                  )}
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        </Table>
                      </Box>
                    </PokerCard>

                    {/* Important Info */}
                    <Box
                      bg="yellow.900"
                      border="1px solid"
                      borderColor="yellow.600"
                      borderRadius="lg"
                      p={4}
                    >
                      <HStack align="start" spacing={3}>
                        <AlertTriangle size={20} color="#ECC94B" style={{ marginTop: 2, flexShrink: 0 }} />
                        <VStack align="start" spacing={2}>
                          <Text color="yellow.200" fontWeight="bold">1099-MISC Requirements</Text>
                          <Text color="yellow.100" fontSize="sm">
                            • Issue 1099-MISC to all users earning ≥$600 in PKCash by January 31st<br/>
                            • Collect W-9 forms before processing withdrawals over $600<br/>
                            • Report total miscellaneous income to IRS<br/>
                            • PKCash = real dollar value for tax purposes
                          </Text>
                        </VStack>
                      </HStack>
                    </Box>
                  </>
                )}
              </VStack>
            </TabPanel>

            {/*  SECURITY: Security Tab */}

            <TabPanel px={0}>
              <VStack spacing={6} align="stretch">
                {/* Cheat & Bot Detection - PokerIntel gameplay analytics */}
                <CheatScanPanel />

                {/* Evidence dossier - pick a user, get the whole record, export */}
                <AdminPlayerDossier />

                {/* Security Overview */}
                <SecurityOverview />

                {/* Security Flags */}
                <SecurityFlags />
              </VStack>
           </TabPanel>

            {/*  Support Tab */}

            <TabPanel px={0}>
              <SupportAdminTab adminId={auth.currentUser?.uid || ''} adminName="Admin" />
            </TabPanel>

            {/*  Reports Tab */}

            <TabPanel px={0}>
              <VStack spacing={6} align="stretch">
                {/* Stats Cards */}
                <SimpleGrid columns={{ base: 2, md: 5 }} spacing={4}>
                  <PokerCard p={4} borderColor="gray.700" borderWidth={1}>
                    <Stat>
                      <StatLabel color="gray.400">Total Reports</StatLabel>
                      <StatNumber color="white">{reportStats?.totalReports || 0}</StatNumber>
                      <StatHelpText color="gray.500">All time</StatHelpText>
                    </Stat>
                  </PokerCard>
                  <PokerCard p={4} borderColor="yellow.600" borderWidth={1}>
                    <Stat>
                      <StatLabel color="gray.400">Pending Review</StatLabel>
                      <StatNumber color="yellow.400">{reportStats?.pendingReports || 0}</StatNumber>
                      <StatHelpText color="gray.500">Needs attention</StatHelpText>
                    </Stat>
                  </PokerCard>
                  <PokerCard p={4} borderColor="orange.600" borderWidth={1}>
                    <Stat>
                      <StatLabel color="gray.400">Pending Appeals</StatLabel>
                      <StatNumber color="orange.400">{reportStats?.pendingAppeals || 0}</StatNumber>
                      <StatHelpText color="gray.500">Ban appeals</StatHelpText>
                    </Stat>
                  </PokerCard>
                  <PokerCard p={4} borderColor="gray.700" borderWidth={1}>
                    <Stat>
                      <StatLabel color="gray.400">This Week</StatLabel>
                      <StatNumber color={POKER_COLORS.cyan}>{reportStats?.thisWeekReports || 0}</StatNumber>
                      <StatHelpText color="gray.500">Last 7 days</StatHelpText>
                    </Stat>
                  </PokerCard>
                  <PokerCard p={4} borderColor="red.600" borderWidth={1}>
                    <Stat>
                      <StatLabel color="gray.400">Banned Users</StatLabel>
                      <StatNumber color="red.400">{bannedUsers.length}</StatNumber>
                      <StatHelpText color="gray.500">Currently banned</StatHelpText>
                    </Stat>
                  </PokerCard>
                </SimpleGrid>

                {/* Sub-Tab Buttons */}
                <HStack spacing={2} flexWrap="wrap">
                  <Button
                    variant={reportsSubTab === 'reports' ? 'solid' : 'outline'}
                    colorScheme={reportsSubTab === 'reports' ? 'cyan' : 'gray'}
                    size="sm"
                    leftIcon={<Flag size={16} />}
                    onClick={() => setReportsSubTab('reports')}
                  >
                    Reports
                    {(reportStats?.pendingReports || 0) > 0 && (
                      <Badge ml={2} colorScheme="yellow" borderRadius="full">{reportStats?.pendingReports}</Badge>
                    )}
                  </Button>
                  <Button
                    variant={reportsSubTab === 'appeals' ? 'solid' : 'outline'}
                    colorScheme={reportsSubTab === 'appeals' ? 'orange' : 'gray'}
                    size="sm"
                    leftIcon={<MessageCircle size={16} />}
                    onClick={async () => {
                      setReportsSubTab('appeals');
                      if (appeals.length === 0) {
                        setAppealsLoading(true);
                        const data = await reportService.getBanAppeals(appealStatusFilter || undefined);
                        setAppeals(data);
                        setAppealsLoading(false);
                      }
                    }}
                  >
                    Appeals
                    {(reportStats?.pendingAppeals || 0) > 0 && (
                      <Badge ml={2} colorScheme="orange" borderRadius="full">{reportStats?.pendingAppeals}</Badge>
                    )}
                  </Button>
                  <Button
                    variant={reportsSubTab === 'banned' ? 'solid' : 'outline'}
                    colorScheme={reportsSubTab === 'banned' ? 'red' : 'gray'}
                    size="sm"
                    leftIcon={<Ban size={16} />}
                    onClick={async () => {
                      setReportsSubTab('banned');
                      if (bannedUsers.length === 0) {
                        setBannedUsersLoading(true);
                        const data = await reportService.getBannedUsers();
                        setBannedUsers(data);
                        setBannedUsersLoading(false);
                      }
                    }}
                  >
                    Banned Users
                  </Button>
                  <Button
                    variant={reportsSubTab === 'audit' ? 'solid' : 'outline'}
                    colorScheme={reportsSubTab === 'audit' ? 'purple' : 'gray'}
                    size="sm"
                    leftIcon={<FileText size={16} />}
                    onClick={async () => {
                      setReportsSubTab('audit');
                      if (auditLog.length === 0) {
                        setAuditLogLoading(true);
                        const data = await reportService.getAuditLog();
                        setAuditLog(data);
                        setAuditLogLoading(false);
                      }
                    }}
                  >
                    Audit Log
                  </Button>
                </HStack>

                {/* ==================== REPORTS SUB-TAB ==================== */}
                {reportsSubTab === 'reports' && (
                  <>
                    {/* Filters */}
                    <HStack spacing={4} flexWrap="wrap">
                      <InputGroup maxW="300px">
                        <InputLeftElement pointerEvents="none">
                          <Search size={18} color="gray" />
                        </InputLeftElement>
                        <Input
                          placeholder="Search reports..."
                          value={reportSearchQuery}
                          onChange={(e) => setReportSearchQuery(e.target.value)}
                          bg={POKER_COLORS.darkBg}
                          borderColor="gray.600"
                          color="white"
                          _placeholder={{ color: 'gray.500' }}
                        />
                      </InputGroup>

                      <Select
                        value={reportStatusFilter}
                        onChange={(e) => {
                          setReportStatusFilter(e.target.value as ReportStatus | '');
                          setReportsLoading(true);
                          reportService.getReports(e.target.value as ReportStatus || undefined)
                            .then(setReports)
                            .finally(() => setReportsLoading(false));
                        }}
                        bg={POKER_COLORS.darkBg}
                        borderColor="gray.600"
                        color="white"
                        maxW="200px"
                      >
                        <option value="" style={{ background: POKER_COLORS.darkBg }}>All Status</option>
                        <option value="pending" style={{ background: POKER_COLORS.darkBg }}>Pending</option>
                        <option value="under_review" style={{ background: POKER_COLORS.darkBg }}>Under Review</option>
                        <option value="action_taken" style={{ background: POKER_COLORS.darkBg }}>Action Taken</option>
                        <option value="dismissed" style={{ background: POKER_COLORS.darkBg }}>Dismissed</option>
                      </Select>

                      <IconButton
                        aria-label="Refresh"
                        icon={<RefreshCw size={18} />}
                        onClick={async () => {
                          setReportsLoading(true);
                          const [newReports, newStats] = await Promise.all([
                            reportService.getReports(reportStatusFilter || undefined),
                            reportService.getReportStats()
                          ]);
                          setReports(newReports);
                          setReportStats(newStats);
                          setReportsLoading(false);
                        }}
                        variant="outline"
                        colorScheme="cyan"
                      />
                    </HStack>

                    {/* Reports Table */}
                    <PokerCard>
                      {reportsLoading ? (
                        <Box p={8} textAlign="center">
                          <Spinner color="cyan.400" size="lg" />
                          <Text color="gray.400" mt={2}>Loading reports...</Text>
                        </Box>
                      ) : reports.filter(r => {
                        if (!reportSearchQuery) return true;
                        const q = reportSearchQuery.toLowerCase();
                        return r.reportedUsername.toLowerCase().includes(q) ||
                               r.reporterUsername.toLowerCase().includes(q) ||
                               r.reasonLabel.toLowerCase().includes(q);
                      }).length === 0 ? (
                        <Box p={8} textAlign="center">
                          <Shield size={48} color="gray" style={{ margin: '0 auto' }} />
                          <Text color="gray.400" mt={4}>No reports found</Text>
                          <Text color="gray.500" fontSize="sm">User reports will appear here</Text>
                        </Box>
                      ) : (
                        <Box overflowX="auto">
                          <Table size="sm">
                            <Thead>
                              <Tr>
                                <Th color="gray.400">Reported User</Th>
                                <Th color="gray.400">Reason</Th>
                                <Th color="gray.400">Reported By</Th>
                                <Th color="gray.400">Status</Th>
                                <Th color="gray.400">Date</Th>
                                <Th color="gray.400">Action</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {reports.filter(r => {
                                if (!reportSearchQuery) return true;
                                const q = reportSearchQuery.toLowerCase();
                                return r.reportedUsername.toLowerCase().includes(q) ||
                                       r.reporterUsername.toLowerCase().includes(q) ||
                                       r.reasonLabel.toLowerCase().includes(q);
                              }).map((report) => (
                                <Tr 
                                  key={report.id} 
                                  _hover={{ bg: 'whiteAlpha.50' }}
                                  cursor="pointer"
                                  onClick={() => {
                                    setSelectedReport(report);
                                    setSelectedReportAction('none');
                                    setReportActionNotes('');
                                    setTempBanDuration(24);
                                    onReportDetailOpen();
                                  }}
                                >
                                  <Td>
                                    <HStack>
                                      <Box
                                        w={8}
                                        h={8}
                                        borderRadius="full"
                                        bg="gray.600"
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        overflow="hidden"
                                      >
                                        {report.reportedPhotoURL ? (
                                          <img src={report.reportedPhotoURL} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        ) : (
                                          <User size={16} color="white" />
                                        )}
                                      </Box>
                                      <Text color="white" fontWeight="medium">
                                        {report.reportedUsername}
                                      </Text>
                                    </HStack>
                                  </Td>
                                  <Td>
                                    <HStack>
                                      <Text>{getReasonIcon(report.reason)}</Text>
                                      <Text color="gray.300" fontSize="sm" noOfLines={1} maxW="200px">
                                        {report.reasonLabel}
                                      </Text>
                                      {(report as any).evidenceUrls?.length > 0 && (
                                        <Badge colorScheme="cyan" display="inline-flex" alignItems="center" gap={1} title="Screenshot attached">
                                          <Paperclip size={10} /> {(report as any).evidenceUrls.length}
                                        </Badge>
                                      )}
                                    </HStack>
                                  </Td>
                                  <Td>
                                    <Text color="gray.400" fontSize="sm">
                                      {report.reporterUsername}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Badge colorScheme={STATUS_LABELS[report.status]?.color || 'gray'} fontSize="xs">
                                      {STATUS_LABELS[report.status]?.label || report.status}
                                    </Badge>
                                  </Td>
                                  <Td>
                                    <Text color="gray.500" fontSize="xs">
                                      {report.createdAt?.toDate?.().toLocaleDateString() || 'Unknown'}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Tooltip label="View Details">
                                      <IconButton
                                        aria-label="View"
                                        icon={<Eye size={16} />}
                                        size="sm"
                                        variant="ghost"
                                        colorScheme="cyan"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setSelectedReport(report);
                                          setSelectedReportAction('none');
                                          setReportActionNotes('');
                                          setTempBanDuration(24);
                                          onReportDetailOpen();
                                        }}
                                      />
                                    </Tooltip>
                                  </Td>
                                </Tr>
                              ))}
                            </Tbody>
                          </Table>
                        </Box>
                      )}
                    </PokerCard>
                  </>
                )}

                {/* ==================== APPEALS SUB-TAB ==================== */}
                {reportsSubTab === 'appeals' && (
                  <>
                    {/* Filters */}
                    <HStack spacing={4} flexWrap="wrap">
                      <Select
                        value={appealStatusFilter}
                        onChange={(e) => {
                          const newFilter = e.target.value as 'pending' | 'approved' | 'rejected' | '';
                          setAppealStatusFilter(newFilter);
                          setAppealsLoading(true);
                          reportService.getBanAppeals(newFilter || undefined)
                            .then(setAppeals)
                            .finally(() => setAppealsLoading(false));
                        }}
                        bg={POKER_COLORS.darkBg}
                        borderColor="gray.600"
                        color="white"
                        maxW="200px"
                      >
                        <option value="" style={{ background: POKER_COLORS.darkBg }}>All Appeals</option>
                        <option value="pending" style={{ background: POKER_COLORS.darkBg }}>Pending</option>
                        <option value="approved" style={{ background: POKER_COLORS.darkBg }}>Approved</option>
                        <option value="rejected" style={{ background: POKER_COLORS.darkBg }}>Rejected</option>
                      </Select>

                      <IconButton
                        aria-label="Refresh"
                        icon={<RefreshCw size={18} />}
                        onClick={async () => {
                          setAppealsLoading(true);
                          const data = await reportService.getBanAppeals(appealStatusFilter || undefined);
                          setAppeals(data);
                          const newStats = await reportService.getReportStats();
                          setReportStats(newStats);
                          setAppealsLoading(false);
                        }}
                        variant="outline"
                        colorScheme="orange"
                      />
                    </HStack>

                    {/* Appeals Table */}
                    <PokerCard>
                      {appealsLoading ? (
                        <Box p={8} textAlign="center">
                          <Spinner color="orange.400" size="lg" />
                          <Text color="gray.400" mt={2}>Loading appeals...</Text>
                        </Box>
                      ) : appeals.length === 0 ? (
                        <Box p={8} textAlign="center">
                          <MessageCircle size={48} color="gray" style={{ margin: '0 auto' }} />
                          <Text color="gray.400" mt={4}>No appeals found</Text>
                          <Text color="gray.500" fontSize="sm">Ban appeals will appear here</Text>
                        </Box>
                      ) : (
                        <Box overflowX="auto">
                          <Table size="sm">
                            <Thead>
                              <Tr>
                                <Th color="gray.400">User</Th>
                                <Th color="gray.400">Ban Reason</Th>
                                <Th color="gray.400">Ban Type</Th>
                                <Th color="gray.400">Appeal Message</Th>
                                <Th color="gray.400">Status</Th>
                                <Th color="gray.400">Submitted</Th>
                                <Th color="gray.400">Action</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {appeals.map((appeal) => (
                                <Tr key={appeal.id} _hover={{ bg: 'whiteAlpha.50' }}>
                                  <Td>
                                    <VStack align="start" spacing={0}>
                                      <Text color="white" fontWeight="medium">{appeal.username}</Text>
                                      <Text color="gray.500" fontSize="xs">{appeal.email}</Text>
                                    </VStack>
                                  </Td>
                                  <Td>
                                    <Text color="gray.300" fontSize="sm" noOfLines={2} maxW="150px">
                                      {appeal.banReason}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Badge colorScheme={appeal.banType === 'permanent' ? 'red' : 'orange'} fontSize="xs">
                                      {appeal.banType}
                                    </Badge>
                                  </Td>
                                  <Td>
                                    <Text color="gray.400" fontSize="sm" noOfLines={2} maxW="200px">
                                      {appeal.appealMessage}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Badge 
                                      colorScheme={
                                        appeal.status === 'pending' ? 'yellow' : 
                                        appeal.status === 'approved' ? 'green' : 'red'
                                      } 
                                      fontSize="xs"
                                    >
                                      {appeal.status}
                                    </Badge>
                                  </Td>
                                  <Td>
                                    <Text color="gray.500" fontSize="xs">
                                      {appeal.createdAt?.toDate?.().toLocaleDateString() || 'Unknown'}
                                    </Text>
                                  </Td>
                                  <Td>
                                    {appeal.status === 'pending' ? (
                                      <HStack spacing={1}>
                                        <Tooltip label="Approve (Unban User)">
                                          <IconButton
                                            aria-label="Approve"
                                            icon={<CheckCircle size={16} />}
                                            size="sm"
                                            colorScheme="green"
                                            variant="ghost"
                                            onClick={() => {
                                              setSelectedAppeal(appeal);
                                              setAppealReviewNotes('');
                                              onAppealDetailOpen();
                                            }}
                                          />
                                        </Tooltip>
                                        <Tooltip label="View Details">
                                          <IconButton
                                            aria-label="View"
                                            icon={<Eye size={16} />}
                                            size="sm"
                                            colorScheme="cyan"
                                            variant="ghost"
                                            onClick={() => {
                                              setSelectedAppeal(appeal);
                                              setAppealReviewNotes('');
                                              onAppealDetailOpen();
                                            }}
                                          />
                                        </Tooltip>
                                      </HStack>
                                    ) : (
                                      <Text color="gray.500" fontSize="xs">
                                        {appeal.reviewedByUsername || 'Admin'}
                                      </Text>
                                    )}
                                  </Td>
                                </Tr>
                              ))}
                            </Tbody>
                          </Table>
                        </Box>
                      )}
                    </PokerCard>
                  </>
                )}

                {/* ==================== BANNED USERS SUB-TAB ==================== */}
                {reportsSubTab === 'banned' && (
                  <>
                    {/* Refresh Button */}
                    <HStack>
                      <IconButton
                        aria-label="Refresh"
                        icon={<RefreshCw size={18} />}
                        onClick={async () => {
                          setBannedUsersLoading(true);
                          const data = await reportService.getBannedUsers();
                          setBannedUsers(data);
                          setBannedUsersLoading(false);
                        }}
                        variant="outline"
                        colorScheme="red"
                      />
                      <Text color="gray.400" fontSize="sm">
                        {bannedUsers.length} banned user{bannedUsers.length !== 1 ? 's' : ''}
                      </Text>
                    </HStack>

                    {/* Banned Users Table */}
                    <PokerCard>
                      {bannedUsersLoading ? (
                        <Box p={8} textAlign="center">
                          <Spinner color="red.400" size="lg" />
                          <Text color="gray.400" mt={2}>Loading banned users...</Text>
                        </Box>
                      ) : bannedUsers.length === 0 ? (
                        <Box p={8} textAlign="center">
                          <Ban size={48} color="gray" style={{ margin: '0 auto' }} />
                          <Text color="gray.400" mt={4}>No banned users</Text>
                          <Text color="gray.500" fontSize="sm">Banned users will appear here</Text>
                        </Box>
                      ) : (
                        <Box overflowX="auto">
                          <Table size="sm">
                            <Thead>
                              <Tr>
                                <Th color="gray.400">User</Th>
                                <Th color="gray.400">Ban Type</Th>
                                <Th color="gray.400">Reason</Th>
                                <Th color="gray.400">Banned At</Th>
                                <Th color="gray.400">Expires</Th>
                                <Th color="gray.400">Warnings</Th>
                                <Th color="gray.400">Action</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {bannedUsers.map((user) => (
                                <Tr key={user.id} _hover={{ bg: 'whiteAlpha.50' }}>
                                  <Td>
                                    <HStack>
                                      <Box
                                        w={8}
                                        h={8}
                                        borderRadius="full"
                                        bg="gray.600"
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        overflow="hidden"
                                      >
                                        {user.photoURL ? (
                                          <img src={user.photoURL} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        ) : (
                                          <User size={16} color="white" />
                                        )}
                                      </Box>
                                      <VStack align="start" spacing={0}>
                                        <Text color="white" fontWeight="medium">{user.username}</Text>
                                        <Text color="gray.500" fontSize="xs">{user.email}</Text>
                                      </VStack>
                                    </HStack>
                                  </Td>
                                  <Td>
                                    <Badge colorScheme={user.banType === 'permanent' ? 'red' : 'orange'} fontSize="xs">
                                      {user.banType}
                                    </Badge>
                                  </Td>
                                  <Td>
                                    <Text color="gray.300" fontSize="sm" noOfLines={2} maxW="200px">
                                      {user.banReason}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Text color="gray.500" fontSize="xs">
                                      {user.bannedAt?.toDate?.().toLocaleDateString() || 'Unknown'}
                                    </Text>
                                  </Td>
                                  <Td>
                                    {user.banType === 'temporary' && user.banExpiresAt ? (
                                      <Text color="orange.400" fontSize="xs">
                                        {user.banExpiresAt?.toDate?.().toLocaleString() || 'N/A'}
                                      </Text>
                                    ) : (
                                      <Text color="red.400" fontSize="xs">Never</Text>
                                    )}
                                  </Td>
                                  <Td>
                                    <Text color="gray.400" fontSize="sm">
                                      {user.warningsReceived || 0}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <PokerButton
                                      size="sm"
                                      variant="secondary"
                                      isLoading={unbanLoading === user.id}
                                      onClick={async () => {
                                        if (!window.confirm(`Are you sure you want to unban ${user.username}?`)) return;
                                        setUnbanLoading(user.id);
                                        try {
                                          await reportService.unbanUser(user.id, 'Admin manual unban');
                                          toast({ title: 'User Unbanned', description: `${user.username} has been unbanned`, status: 'success', duration: 3000 });
                                          // Refresh list
                                          const data = await reportService.getBannedUsers();
                                          setBannedUsers(data);
                                        } catch (err: any) {
                                          toast({ title: 'Error', description: err.message, status: 'error', duration: 3000 });
                                        } finally {
                                          setUnbanLoading(null);
                                        }
                                      }}
                                    >
                                      Unban
                                    </PokerButton>
                                  </Td>
                                </Tr>
                              ))}
                            </Tbody>
                          </Table>
                        </Box>
                      )}
                    </PokerCard>
                  </>
                )}

                {/* ==================== AUDIT LOG SUB-TAB ==================== */}
                {reportsSubTab === 'audit' && (
                  <>
                    {/* Filters */}
                    <HStack spacing={4} flexWrap="wrap">
                      <Select
                        value={auditActionFilter}
                        onChange={(e) => {
                          setAuditActionFilter(e.target.value);
                          setAuditLogLoading(true);
                          reportService.getAuditLog(e.target.value || undefined)
                            .then(setAuditLog)
                            .finally(() => setAuditLogLoading(false));
                        }}
                        bg={POKER_COLORS.darkBg}
                        borderColor="gray.600"
                        color="white"
                        maxW="250px"
                      >
                        <option value="" style={{ background: POKER_COLORS.darkBg }}>All Actions</option>
                        <option value="report_dismiss" style={{ background: POKER_COLORS.darkBg }}>Report Dismissed</option>
                        <option value="report_warning" style={{ background: POKER_COLORS.darkBg }}>Warning Issued</option>
                        <option value="report_temporary_ban" style={{ background: POKER_COLORS.darkBg }}>Temporary Ban</option>
                        <option value="report_permanent_ban" style={{ background: POKER_COLORS.darkBg }}>Permanent Ban</option>
                        <option value="user_unbanned" style={{ background: POKER_COLORS.darkBg }}>User Unbanned</option>
                        <option value="appeal_approve" style={{ background: POKER_COLORS.darkBg }}>Appeal Approved</option>
                        <option value="appeal_reject" style={{ background: POKER_COLORS.darkBg }}>Appeal Rejected</option>
                        <option value="report_deleted" style={{ background: POKER_COLORS.darkBg }}>Report Deleted</option>
                      </Select>

                      <IconButton
                        aria-label="Refresh"
                        icon={<RefreshCw size={18} />}
                        onClick={async () => {
                          setAuditLogLoading(true);
                          const data = await reportService.getAuditLog(auditActionFilter || undefined);
                          setAuditLog(data);
                          setAuditLogLoading(false);
                        }}
                        variant="outline"
                        colorScheme="purple"
                      />
                    </HStack>

                    {/* Audit Log Table */}
                    <PokerCard>
                      {auditLogLoading ? (
                        <Box p={8} textAlign="center">
                          <Spinner color="purple.400" size="lg" />
                          <Text color="gray.400" mt={2}>Loading audit log...</Text>
                        </Box>
                      ) : auditLog.length === 0 ? (
                        <Box p={8} textAlign="center">
                          <FileText size={48} color="gray" style={{ margin: '0 auto' }} />
                          <Text color="gray.400" mt={4}>No audit log entries</Text>
                          <Text color="gray.500" fontSize="sm">Admin actions will be logged here</Text>
                        </Box>
                      ) : (
                        <Box overflowX="auto">
                          <Table size="sm">
                            <Thead>
                              <Tr>
                                <Th color="gray.400">Timestamp</Th>
                                <Th color="gray.400">Admin</Th>
                                <Th color="gray.400">Action</Th>
                                <Th color="gray.400">Target User</Th>
                                <Th color="gray.400">Details</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {auditLog.map((entry) => (
                                <Tr key={entry.id} _hover={{ bg: 'whiteAlpha.50' }}>
                                  <Td>
                                    <Text color="gray.500" fontSize="xs">
                                      {entry.timestamp?.toDate?.().toLocaleString() || 'Unknown'}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Text color="cyan.400" fontWeight="medium" fontSize="sm">
                                      {entry.adminUsername}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Badge 
                                      colorScheme={
                                        entry.action.includes('ban') ? 'red' :
                                        entry.action.includes('unban') || entry.action.includes('approve') ? 'green' :
                                        entry.action.includes('warning') ? 'yellow' :
                                        entry.action.includes('dismiss') ? 'gray' : 'purple'
                                      } 
                                      fontSize="xs"
                                    >
                                      {entry.action.replace(/_/g, ' ').toUpperCase()}
                                    </Badge>
                                  </Td>
                                  <Td>
                                    <Text color="white" fontWeight="medium" fontSize="sm">
                                      {entry.targetUsername}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Text color="gray.400" fontSize="xs" noOfLines={2} maxW="250px">
                                      {entry.details?.actionNotes || entry.details?.reviewNotes || entry.details?.reason || '-'}
                                    </Text>
                                  </Td>
                                </Tr>
                              ))}
                            </Tbody>
                          </Table>
                        </Box>
                      )}
                    </PokerCard>
                  </>
                )}
              </VStack>
            </TabPanel>

            {/*  NEW: Settings Tab */}


            {/*  NEW: Settings Tab */}

            <TabPanel px={0}>
              <VStack spacing={6} align="stretch">
                {/* Geo Restrictions */}
                <PokerCard>
                  <HStack justify="space-between" mb={4}>
                    <VStack align="start" spacing={0}>
                      <Text color="purple.400" fontWeight="bold" fontSize="lg">
                        <MapPin size={18} style={{ display: 'inline', marginRight: '8px' }} />
                        Geo Restrictions
                      </Text>
                      <Text color="gray.500" fontSize="sm">Manage states where PKCash play is restricted</Text>
                    </VStack>
                  </HStack>

                  {/* Hardcoded States Warning */}
                  <Box p={3} bg="red.900" borderRadius="md" mb={4} border="1px solid" borderColor="red.600">
                    <Text color="red.200" fontWeight="bold" fontSize="sm" mb={1}>
                       Hardcoded in geoService.ts (Always Blocked):

                    </Text>
                    <HStack spacing={2} flexWrap="wrap">
                      {RESTRICTED_STATES.map(code => (
                        <Badge key={code} colorScheme="red" fontSize="sm">
                          {code} - {RESTRICTED_STATE_NAMES[code]}
                        </Badge>
                      ))}
                    </HStack>
                    <Text color="red.300" fontSize="xs" mt={2}>
                      These states require code changes to unblock. Contact developer to modify geoService.ts
                    </Text>
                  </Box>

                  {/* Dynamically Managed States */}
                  <Text color="gray.300" fontWeight="bold" fontSize="sm" mb={2}>
                    Additional Blocks (Platform Settings):
                  </Text>
                  <SimpleGrid columns={{ base: 5, md: 10 }} spacing={2}>
                    {Object.entries(US_STATES).map(([code, name]) => {
                      const isHardcoded = RESTRICTED_STATES.includes(code);
                      const isDynamicBlocked = platformSettings.restrictedStates?.includes(code);
                      return (
                        <Tooltip key={code} label={`${name}${isHardcoded ? ' (Hardcoded)' : ''}`}>
                          <Button
                            size="sm"
                            variant={isHardcoded || isDynamicBlocked ? 'solid' : 'outline'}
                            colorScheme={isHardcoded ? 'red' : isDynamicBlocked ? 'orange' : 'gray'}
                            onClick={() => !isHardcoded && toggleRestrictedState(code)}
                            isDisabled={isHardcoded}
                            opacity={isHardcoded ? 0.7 : 1}
                            _disabled={{ cursor: 'not-allowed' }}
                          >
                            {code}
                          </Button>
                        </Tooltip>
                      );
                    })}
                  </SimpleGrid>

                  <HStack mt={4} spacing={4} flexWrap="wrap">
                    <HStack>
                      <Box w={3} h={3} bg="red.500" borderRadius="sm" />
                      <Text color="gray.400" fontSize="xs">Hardcoded Block</Text>
                    </HStack>
                    <HStack>
                      <Box w={3} h={3} bg="orange.500" borderRadius="sm" />
                      <Text color="gray.400" fontSize="xs">Admin Block</Text>
                    </HStack>
                    <HStack>
                      <Box w={3} h={3} bg="gray.600" borderRadius="sm" border="1px solid" borderColor="gray.500" />
                      <Text color="gray.400" fontSize="xs">Allowed</Text>
                    </HStack>
                  </HStack>

                  <Text color="gray.500" fontSize="xs" mt={4}>
                    Currently blocked: {[...RESTRICTED_STATES, ...(platformSettings.restrictedStates?.filter(s => !RESTRICTED_STATES.includes(s)) || [])].join(', ') || 'None'}
                  </Text>
                </PokerCard>

                {/* AMOE Settings */}
                <PokerCard>
                  <Text color="purple.400" fontWeight="bold" fontSize="lg" mb={4}>
                    <Gift size={18} style={{ display: 'inline', marginRight: '8px' }} />
                    AMOE Settings (Free Entry)
                  </Text>

                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                    <FormControl>
                      <FormLabel color="gray.300">AMOE Amount ($)</FormLabel>
                      <NumberInput
                        value={platformSettings.amoeAmount}
                        onChange={(_, v) => setPlatformSettings({ ...platformSettings, amoeAmount: v || 1 })}
                        min={0.01}
                        max={10}
                        step={0.25}
                      >
                        <NumberInputField bg={POKER_COLORS.darkBg} borderColor="purple.500" color="white" />
                      </NumberInput>
                    </FormControl>

                    <FormControl>
                      <FormLabel color="gray.300">Free voice minutes per week</FormLabel>
                      <NumberInput
                        value={platformSettings.freeVoiceMinutesPerWeek ?? 45}
                        onChange={(_, v) => setPlatformSettings({ ...platformSettings, freeVoiceMinutesPerWeek: Number.isFinite(v) ? v : 45 })}
                        min={0}
                        max={10080}
                        step={5}
                      >
                        <NumberInputField bg={POKER_COLORS.darkBg} borderColor="cyan.500" color="white" />
                      </NumberInput>
                      <Text fontSize="xs" color="gray.500" mt={1}>Every player gets this much voice and video free each week (resets Monday, Pacific). 0 turns the free tier off.</Text>
                    </FormControl>

                    <FormControl>
                      <FormLabel color="gray.300">Cooldown (hours)</FormLabel>
                      <NumberInput
                        value={platformSettings.amoeCooldownHours}
                        onChange={(_, v) => setPlatformSettings({ ...platformSettings, amoeCooldownHours: v || 24 })}
                        min={1}
                        max={168}
                      >
                        <NumberInputField bg={POKER_COLORS.darkBg} borderColor="purple.500" color="white" />
                      </NumberInput>
                    </FormControl>
                  </SimpleGrid>
                </PokerCard>

                {/* Redemption Limits */}
                <PokerCard>
                  <Text color="purple.400" fontWeight="bold" fontSize="lg" mb={4}>
                    <DollarSign size={18} style={{ display: 'inline', marginRight: '8px' }} />
                    Redemption Limits
                  </Text>

                  <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
                    <FormControl>
                      <FormLabel color="gray.300">Minimum Redemption ($)</FormLabel>
                      <NumberInput
                        value={platformSettings.minRedemption}
                        onChange={(_, v) => setPlatformSettings({ ...platformSettings, minRedemption: v || 10 })}
                        min={1}
                      >
                        <NumberInputField bg={POKER_COLORS.darkBg} borderColor="purple.500" color="white" />
                      </NumberInput>
                    </FormControl>

                    <FormControl>
                      <FormLabel color="gray.300">Max Daily ($)</FormLabel>
                      <NumberInput
                        value={platformSettings.maxRedemptionDaily}
                        onChange={(_, v) => setPlatformSettings({ ...platformSettings, maxRedemptionDaily: v || 500 })}
                        min={10}
                      >
                        <NumberInputField bg={POKER_COLORS.darkBg} borderColor="purple.500" color="white" />
                      </NumberInput>
                    </FormControl>

                    <FormControl>
                      <FormLabel color="gray.300">Max Weekly ($)</FormLabel>
                      <NumberInput
                        value={platformSettings.maxRedemptionWeekly}
                        onChange={(_, v) => setPlatformSettings({ ...platformSettings, maxRedemptionWeekly: v || 2000 })}
                        min={100}
                      >
                        <NumberInputField bg={POKER_COLORS.darkBg} borderColor="purple.500" color="white" />
                      </NumberInput>
                    </FormControl>
                  </SimpleGrid>

                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mt={4}>
                    <FormControl>
                      <FormLabel color="gray.300">Playthrough Requirement (x)</FormLabel>
                      <NumberInput
                        value={platformSettings.playthroughRequirement}
                        onChange={(_, v) => setPlatformSettings({ ...platformSettings, playthroughRequirement: v || 1 })}
                        min={0}
                        max={10}
                        step={0.5}
                      >
                        <NumberInputField bg={POKER_COLORS.darkBg} borderColor="purple.500" color="white" />
                      </NumberInput>
                      <Text color="gray.500" fontSize="xs" mt={1}>1x = play through deposit once before withdrawal</Text>
                    </FormControl>

                    <FormControl display="flex" alignItems="center" pt={8}>
                      <Switch
                        isChecked={platformSettings.kycRequiredForRedemption}
                        onChange={(e) => setPlatformSettings({ ...platformSettings, kycRequiredForRedemption: e.target.checked })}
                        colorScheme="purple"
                        mr={3}
                      />
                      <FormLabel color="gray.300" mb={0}>Require KYC for Redemption</FormLabel>
                    </FormControl>
                  </SimpleGrid>
                </PokerCard>

                {/* VPN & Security */}
                <PokerCard>
                  <Text color="purple.400" fontWeight="bold" fontSize="lg" mb={4}>
                    <Shield size={18} style={{ display: 'inline', marginRight: '8px' }} />
                    Security Settings
                  </Text>

                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                    <FormControl display="flex" alignItems="center">
                      <Switch
                        isChecked={platformSettings.vpnBlockingEnabled}
                        onChange={(e) => setPlatformSettings({ ...platformSettings, vpnBlockingEnabled: e.target.checked })}
                        colorScheme="purple"
                        mr={3}
                      />
                      <FormLabel color="gray.300" mb={0}>Block VPN/Proxy Users</FormLabel>
                    </FormControl>

                    <FormControl>
                      <FormLabel color="gray.300">Minimum Age</FormLabel>
                      <NumberInput
                        value={platformSettings.minimumAge}
                        onChange={(_, v) => setPlatformSettings({ ...platformSettings, minimumAge: v || 18 })}
                        min={18}
                        max={21}
                      >
                        <NumberInputField bg={POKER_COLORS.darkBg} borderColor="purple.500" color="white" />
                      </NumberInput>
                    </FormControl>
                  </SimpleGrid>
                </PokerCard>

                {/* Save Button */}
                <HStack justify="flex-end">
                  <PokerButton
                    variant="primary"
                    size="lg"
                    leftIcon={<CheckCircle size={18} />}
                    onClick={handleSaveSettings}
                    isLoading={savingSettings}
                    loadingText="Saving..."
                    bg="purple.500"
                    _hover={{ bg: 'purple.400' }}
                  >
                    Save Settings
                  </PokerButton>
                </HStack>
              </VStack>
            </TabPanel>

            {/*  Monthly Challenges Tab */}

            <TabPanel px={0}>
              <PokerCard>
                <VStack spacing={6} align="stretch">
                  <HStack justify="space-between" flexWrap="wrap" gap={2}>
                    <HStack>
                      <Trophy size={24} color="#fbbf24" />
                      <Text color="yellow.400" fontWeight="bold" fontSize="xl">Monthly Challenges</Text>
                    </HStack>
                    <PokerButton
                      variant="secondary"
                      size="sm"
                      onClick={async () => {
                        // Refresh current challenge
                        try {
                          const response = await fetch(
                            `${API_BASE}/challenges/current`
                          );
                          const result = await response.json();
                          const display = document.getElementById('current-challenge-display');
                          if (display) {
                            if (result.challenge) {
                              const c = result.challenge;
                              display.innerHTML = `
                                <div style="padding: 16px; background: rgba(0,255,136,0.1); border: 1px solid #00ff88; border-radius: 8px;">
                                  <div style="color: #00ff88; font-weight: bold; font-size: 18px; margin-bottom: 8px;">
                                     Active Challenge: ${c.name}

                                  </div>
                                  <div style="color: #9ca3af; font-size: 14px;">
                                    <div>ID: ${c.id}</div>
                                    <div>Type: ${c.type}</div>
                                    <div>Status: ${c.status}</div>
                                    <div>Prize Pool: $${c.prizePool || 15}</div>
                                    <div>Total Hands: ${c.totalHands || 0}</div>
                                    <div>Participants: ${c.totalParticipants || 0}</div>
                                  </div>
                                </div>
                              `;
                            } else {
                              display.innerHTML = `
                                <div style="padding: 16px; background: rgba(255,100,100,0.1); border: 1px solid #f87171; border-radius: 8px;">
                                  <div style="color: #f87171; font-weight: bold;"> No Active Challenge</div>

                                  <div style="color: #9ca3af; font-size: 14px;">Use the form below to create one.</div>
                                </div>
                              `;
                            }
                          }
                          toast({ title: 'Refreshed', status: 'info', duration: 1000 });
                        } catch (error) {
                          toast({ title: 'Failed to refresh', status: 'error', duration: 2000 });
                        }
                      }}
                    >
                       Refresh Status

                    </PokerButton>
                  </HStack>

                  {/* Current Challenge Status */}
                  <Box id="current-challenge-display">
                    <Box p={4} bg="rgba(100,100,100,0.2)" borderRadius="lg" border="1px dashed" borderColor="gray.600">
                      <Text color="gray.400">Click "Refresh Status" to load current challenge</Text>
                    </Box>
                  </Box>

                  {/* Admin Actions */}
                  <Box bg="rgba(0,0,0,0.3)" p={4} borderRadius="lg" border="1px solid" borderColor="gray.600">
                    <Text color="cyan.400" fontWeight="bold" mb={4}> Admin Actions</Text>

                    <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
                      {/* Initialize */}
                      <VStack align="stretch" spacing={2}>
                        <Text color="gray.300" fontSize="sm" fontWeight="bold">Create New Challenge</Text>
                        <Select
                          id="challenge-type-select"
                          size="sm"
                          bg="#0a1929"
                          borderColor="gray.600"
                          color="white"
                        >
                          <option value="" style={{ background: '#0a1929' }}>Auto (Rotation)</option>
                          <option value="hands_won" style={{ background: '#0a1929' }}> Hands Champion</option>

                          <option value="biggest_pot" style={{ background: '#0a1929' }}> Pot King</option>

                          <option value="win_streak" style={{ background: '#0a1929' }}> Streak Master</option>

                          <option value="hands_played" style={{ background: '#0a1929' }}> Grind Lord</option>

                        </Select>
                        <PokerButton
                          variant="primary"
                          size="sm"
                          onClick={async () => {
                            try {
                              const token = await auth.currentUser?.getIdToken();
                              const select = document.getElementById('challenge-type-select') as HTMLSelectElement;
                              const selectedType = select?.value || '';
                              
                              const body: any = {};
                              if (selectedType) body.forceType = selectedType;
                              
                              const response = await fetch(
                                `${API_BASE}/challenges/initialize`,
                                {
                                  method: 'POST',
                                  headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${token}`,
                                  },
                                  body: JSON.stringify(body),
                                }
                              );
                              const result = await response.json();
                              if (response.ok && result.success) {
                                toast({
                                  title: 'Challenge Created',
                                  description: `${result.name} initialized for ${result.challengeId}`,
                                  status: 'success',
                                  duration: 3000,
                                });
                              } else {
                                toast({
                                  title: 'Error',
                                  description: result.error || 'Failed to create',
                                  status: 'error',
                                  duration: 3000,
                                });
                              }
                            } catch (error: any) {
                              toast({
                                title: 'Error',
                                description: error.message || 'Failed',
                                status: 'error',
                                duration: 3000,
                              });
                            }
                          }}
                        >
                          <Plus size={14} />
                          <Text ml={1}>Initialize</Text>
                        </PokerButton>
                      </VStack>

                      {/* Finalize */}
                      <VStack align="stretch" spacing={2}>
                        <Text color="gray.300" fontSize="sm" fontWeight="bold">End & Pay Prizes</Text>
                        <Text color="gray.500" fontSize="xs">Distributes prizes to top 3 and marks complete</Text>
                        <PokerButton
                          variant="secondary"
                          size="sm"
                          bg="green.600"
                          _hover={{ bg: 'green.500' }}
                          onClick={async () => {
                            if (!window.confirm('Finalize challenge and distribute prizes? This cannot be undone.')) return;
                            try {
                              const now = new Date();
                              const challengeId = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
                              const token = await auth.currentUser?.getIdToken();
                              const response = await fetch(
                                `${API_BASE}/challenges/finalize`,
                                {
                                  method: 'POST',
                                  headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${token}`,
                                  },
                                  body: JSON.stringify({ challengeId }),
                                }
                              );
                              const result = await response.json();
                              if (response.ok && result.success) {
                                toast({
                                  title: 'Challenge Finalized!',
                                  description: `$${result.prizePool} distributed to ${result.winners?.length || 0} winners`,
                                  status: 'success',
                                  duration: 5000,
                                });
                              } else {
                                toast({
                                  title: 'Error',
                                  description: result.error,
                                  status: 'error',
                                  duration: 3000,
                                });
                              }
                            } catch (error) {
                              toast({
                                title: 'Error',
                                description: 'Failed to finalize',
                                status: 'error',
                                duration: 3000,
                              });
                            }
                          }}
                        >
                           Finalize & Pay

                        </PokerButton>
                      </VStack>

                      {/* Delete */}
                      <VStack align="stretch" spacing={2}>
                        <Text color="gray.300" fontSize="sm" fontWeight="bold">Delete Challenge</Text>
                        <Text color="gray.500" fontSize="xs">Cancel challenge (no prizes paid)</Text>
                        <PokerButton
                          variant="secondary"
                          size="sm"
                          bg="red.600"
                          _hover={{ bg: 'red.500' }}
                          onClick={async () => {
                            if (!window.confirm('DELETE this month\'s challenge? All progress will be lost. This cannot be undone.')) return;
                            try {
                              const now = new Date();
                              const challengeId = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
                              const token = await auth.currentUser?.getIdToken();
                              const response = await fetch(
                                `${API_BASE}/challenges/${challengeId}`,
                                {
                                  method: 'DELETE',
                                  headers: {
                                    'Authorization': `Bearer ${token}`,
                                  },
                                }
                              );
                              const result = await response.json();
                              if (response.ok && result.success) {
                                toast({
                                  title: 'Challenge Deleted',
                                  description: `${result.entriesDeleted} entries removed`,
                                  status: 'success',
                                  duration: 3000,
                                });
                              } else {
                                toast({
                                  title: 'Error',
                                  description: result.error,
                                  status: 'error',
                                  duration: 3000,
                                });
                              }
                            } catch (error) {
                              toast({
                                title: 'Error',
                                description: 'Failed to delete',
                                status: 'error',
                                duration: 3000,
                              });
                            }
                          }}
                        >
                           Delete Challenge

                        </PokerButton>
                      </VStack>
                    </SimpleGrid>
                  </Box>

                  {/* Challenge Types Reference */}
                  <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4}>
                    <Box bg="rgba(255,215,0,0.1)" p={4} borderRadius="lg" border="1px solid" borderColor="yellow.600">
                      <Text color="yellow.400" fontWeight="bold"> Hands Champion</Text>

                      <Text color="gray.400" fontSize="sm">Win the most hands</Text>
                      <Badge colorScheme="yellow" mt={2}>PKCash 2x • PlayCoins 1x</Badge>
                    </Box>
                    <Box bg="rgba(255,215,0,0.1)" p={4} borderRadius="lg" border="1px solid" borderColor="yellow.600">
                      <Text color="yellow.400" fontWeight="bold"> Pot King</Text>

                      <Text color="gray.400" fontSize="sm">Biggest single pot</Text>
                      <Badge colorScheme="orange" mt={2}>PKCash Only</Badge>
                    </Box>
                    <Box bg="rgba(255,215,0,0.1)" p={4} borderRadius="lg" border="1px solid" borderColor="yellow.600">
                      <Text color="yellow.400" fontWeight="bold"> Streak Master</Text>

                      <Text color="gray.400" fontSize="sm">Longest win streak</Text>
                      <Badge colorScheme="yellow" mt={2}>PKCash 2x • PlayCoins 1x</Badge>
                    </Box>
                    <Box bg="rgba(255,215,0,0.1)" p={4} borderRadius="lg" border="1px solid" borderColor="yellow.600">
                      <Text color="yellow.400" fontWeight="bold"> Grind Lord</Text>

                      <Text color="gray.400" fontSize="sm">Most hands played</Text>
                      <Badge colorScheme="yellow" mt={2}>PKCash 1.5x • PlayCoins 1x</Badge>
                    </Box>
                  </SimpleGrid>

                  {/* Prize Pool Info */}
                  <Box bg="rgba(0,0,0,0.3)" p={4} borderRadius="lg" border="1px solid" borderColor="gray.600">
                    <Text color="cyan.400" fontWeight="bold" mb={2}> Prize Pool Structure</Text>

                    <VStack align="start" spacing={1}>
                      <Text color="gray.400" fontSize="sm">• Base: $15</Text>
                      <Text color="gray.400" fontSize="sm">• + 0.5% of monthly rake</Text>
                      <Text color="gray.400" fontSize="sm">• Maximum: $100</Text>
                      <Text color="gray.400" fontSize="sm">• Top 3: 50% / 30% / 20%</Text>
                    </VStack>
                  </Box>
                </VStack>
              </PokerCard>
            </TabPanel>

            {/* System Tab */}
            <TabPanel px={0}>
              <VStack spacing={6} align="stretch">
                {/* ===== ONBOARDING TOUR PREVIEW ===== */}
                <PokerCard>
                  <VStack spacing={3} align="stretch">
                    <HStack>
                      <Play size={22} color="#FFD700" />
                      <Text color={POKER_COLORS.gold} fontWeight="bold" fontSize="lg">
                        Onboarding Tour
                      </Text>
                    </HStack>
                    <Text color="gray.400" fontSize="sm">
                      Runs the guided tour exactly as a brand-new player sees it: wallet,
                      deposits, prize redemption, referrals, Quick Match, tables, private
                      tables, tournaments, training, Pack Drop, daily spin, leaderboard,
                      slots, support. Resets your own completion flag first, so it always
                      plays.
                    </Text>
                    <Button colorScheme="yellow" variant="outline" alignSelf="flex-start"
                      onClick={handlePreviewTour}>
                      Preview the tour
                    </Button>
                  </VStack>
                </PokerCard>

                {/* ===== HOLE-CARD PRIVACY SCRUB ===== */}
                <PokerCard>
                  <VStack spacing={3} align="stretch">
                    <HStack>
                      <Shield size={22} color="#22C55E" />
                      <Text color="green.300" fontWeight="bold" fontSize="lg">
                        Hole-Card Privacy Scrub
                      </Text>
                    </HStack>
                    <Text color="gray.400" fontSize="sm">
                      Hands recorded before the privacy fix stored every player's dealt
                      cards inside the readable history docs. This moves those maps into
                      the server-only store and strips them from the shared docs. Run once
                      after deploying the fix - safe to press again, it just finds nothing.
                    </Text>
                    {scrubResult && (
                      <Alert status={scrubResult.ok ? 'success' : 'error'} borderRadius="md"
                        bg={scrubResult.ok ? 'green.900' : 'red.900'}>
                        <AlertIcon />
                        <Text fontSize="sm" color="white">{scrubResult.msg}</Text>
                      </Alert>
                    )}
                    <Button colorScheme="green" variant="outline" alignSelf="flex-start"
                      isLoading={scrubbing} loadingText="Scrubbing…" onClick={handlePrivacyScrub}>
                      Run privacy scrub
                    </Button>
                  </VStack>
                </PokerCard>

                {/* ===== POKER INTEL REBUILD ===== */}
                <PokerCard>
                  <VStack spacing={3} align="stretch">
                    <HStack>
                      <BarChart3 size={22} color="#00D9D9" />
                      <Text color={POKER_COLORS.cyan} fontWeight="bold" fontSize="lg">
                        Rebuild Player Stats
                      </Text>
                    </HStack>
                    <Text color="gray.400" fontSize="sm">
                      Recomputes every player's VPIP / PFR / showdown stats from the retained
                      hand histories (newest ~25 hands per table). Use once after the intel
                      update so existing players aren't stuck at a handful of hands. A player
                      is only overwritten when the rebuild finds at least as many hands as
                      they currently show.
                    </Text>
                    {intelRebuildResult && (
                      <Alert status={intelRebuildResult.ok ? 'success' : 'error'} borderRadius="md"
                        bg={intelRebuildResult.ok ? 'green.900' : 'red.900'}>
                        <AlertIcon />
                        <Text fontSize="sm" color="white">{intelRebuildResult.msg}</Text>
                      </Alert>
                    )}
                    <Button
                      colorScheme="cyan" variant="outline" alignSelf="flex-start"
                      isLoading={intelRebuilding} loadingText="Scanning hands…"
                      onClick={handleRebuildIntel}
                    >
                      Rebuild from hand histories
                    </Button>
                  </VStack>
                </PokerCard>

                {/* ===== MAINTENANCE MODE ===== */}
                <PokerCard>
                  <VStack spacing={4} align="stretch">
                    <HStack justify="space-between">
                      <HStack>
                        <Settings size={24} color={maintenanceMode.enabled ? '#f56565' : '#00D9D9'} />
                        <Text color={maintenanceMode.enabled ? 'red.400' : POKER_COLORS.cyan} fontWeight="bold" fontSize="xl">
                          Maintenance Mode
                        </Text>
                        {maintenanceMode.enabled && (
                          <Badge colorScheme="red" fontSize="md" px={3}>ACTIVE</Badge>
                        )}
                      </HStack>
                      <Switch
                        isChecked={maintenanceMode.enabled}
                        onChange={(e) => handleToggleMaintenance(e.target.checked)}
                        isDisabled={loadingMaintenance}
                        colorScheme={maintenanceMode.enabled ? 'red' : 'cyan'}
                        size="lg"
                      />
                    </HStack>

                    <Text color="gray.400" fontSize="sm">
                      When enabled, users will see a maintenance message and won't be able to play. Use this before running updates.
                    </Text>

                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                      <FormControl>
                        <FormLabel color="gray.300" fontSize="sm">Maintenance Message</FormLabel>
                        <Textarea
                          value={maintenanceMode.message}
                          onChange={(e) => setMaintenanceMode(prev => ({ ...prev, message: e.target.value }))}
                          placeholder="System is under maintenance. Please check back soon."
                          bg={POKER_COLORS.darkBg}
                          borderColor="gray.600"
                          color="white"
                          rows={2}
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel color="gray.300" fontSize="sm">Estimated Duration (minutes)</FormLabel>
                        <NumberInput
                          value={maintenanceMode.estimatedDuration}
                          onChange={(_, v) => setMaintenanceMode(prev => ({ ...prev, estimatedDuration: v || 30 }))}
                          min={5}
                          max={480}
                        >
                          <NumberInputField bg={POKER_COLORS.darkBg} borderColor="gray.600" color="white" />
                        </NumberInput>
                      </FormControl>
                    </SimpleGrid>
                  </VStack>
                </PokerCard>

                {/* ===== PAYMENTS & KYC HOLD ===== */}
                <PokerCard>
                  <VStack spacing={4} align="stretch">
                    <HStack justify="space-between">
                      <HStack>
                        <Ban size={24} color={paymentsHold.enabled ? '#fb923c' : '#00D9D9'} />
                        <Text color={paymentsHold.enabled ? 'orange.300' : POKER_COLORS.cyan} fontWeight="bold" fontSize="xl">
                          Payments &amp; KYC Hold
                        </Text>
                        {paymentsHold.enabled && (
                          <Badge colorScheme="orange" fontSize="md" px={3}>ACTIVE</Badge>
                        )}
                      </HStack>
                      <Switch
                        isChecked={paymentsHold.enabled}
                        onChange={(e) => savePaymentsHold({ ...paymentsHold, enabled: e.target.checked })}
                        isDisabled={savingPaymentsHold}
                        colorScheme={paymentsHold.enabled ? 'orange' : 'cyan'}
                        size="lg"
                      />
                    </HStack>

                    <Text color="gray.400" fontSize="sm">
                      While ON, every player sees a notice they cannot dismiss, on every page, until you switch it OFF.
                      The checked actions are also blocked on the server, so nobody can buy by card, start ID verification or redeem while you change providers. Games and balances are untouched. Apple App Store purchases are separate from the card processor and stay on unless you check the last box; receipts Apple has already charged are always credited.
                    </Text>

                    <FormControl>
                      <FormLabel color="gray.300" fontSize="sm">Notice shown to players</FormLabel>
                      <Textarea
                        value={paymentsHold.message}
                        onChange={(e) => { setPaymentsHold(prev => ({ ...prev, message: e.target.value })); setPaymentsHoldDirty(true); }}
                        placeholder={DEFAULT_PAYMENTS_HOLD_MESSAGE}
                        bg={POKER_COLORS.darkBg}
                        borderColor="gray.600"
                        color="white"
                        rows={3}
                      />
                    </FormControl>

                    <HStack spacing={6} flexWrap="wrap">
                      <Checkbox colorScheme="orange" isChecked={paymentsHold.blockPurchases} onChange={(e) => { setPaymentsHold(prev => ({ ...prev, blockPurchases: e.target.checked })); setPaymentsHoldDirty(true); }}>
                        <Text color="gray.200" fontSize="sm">Block deposits</Text>
                      </Checkbox>
                      <Checkbox colorScheme="orange" isChecked={paymentsHold.blockKyc} onChange={(e) => { setPaymentsHold(prev => ({ ...prev, blockKyc: e.target.checked })); setPaymentsHoldDirty(true); }}>
                        <Text color="gray.200" fontSize="sm">Block ID verification</Text>
                      </Checkbox>
                      <Checkbox colorScheme="orange" isChecked={paymentsHold.blockCashOuts} onChange={(e) => { setPaymentsHold(prev => ({ ...prev, blockCashOuts: e.target.checked })); setPaymentsHoldDirty(true); }}>
                        <Text color="gray.200" fontSize="sm">Block redemptions</Text>
                      </Checkbox>
                      <Checkbox colorScheme="orange" isChecked={paymentsHold.blockIap} onChange={(e) => { setPaymentsHold(prev => ({ ...prev, blockIap: e.target.checked })); setPaymentsHoldDirty(true); }}>
                        <Text color="gray.200" fontSize="sm">Also block Apple App Store purchases<Text as="span" display="block" fontSize="xs" color="gray.500">Off: iPhone players keep buying through Apple, which is unaffected by the card processor</Text></Text>
                      </Checkbox>
                    </HStack>

                    <HStack justify="flex-end">
                      <PokerButton
                        variant="primary"
                        size="sm"
                        onClick={() => savePaymentsHold(paymentsHold)}
                        isLoading={savingPaymentsHold}
                        isDisabled={!paymentsHoldDirty}
                      >
                        Save notice and options
                      </PokerButton>
                    </HStack>
                  </VStack>
                </PokerCard>

                {/* ===== SYSTEM ANNOUNCEMENTS ===== */}
                <PokerCard>
                  <VStack spacing={4} align="stretch">
                    <HStack>
                      <Bell size={24} color="#D4AF37" />
                      <Text color={POKER_COLORS.gold} fontWeight="bold" fontSize="xl">System Announcements</Text>
                    </HStack>

                    <Text color="gray.400" fontSize="sm">
                      Send a banner message to all users currently in the app.
                    </Text>

                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                      <FormControl>
                        <FormLabel color="gray.300" fontSize="sm">Title</FormLabel>
                        <Input
                          value={announcementForm.title}
                          onChange={(e) => setAnnouncementForm(prev => ({ ...prev, title: e.target.value }))}
                          placeholder="Scheduled Maintenance"
                          bg={POKER_COLORS.darkBg}
                          borderColor="gray.600"
                          color="white"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel color="gray.300" fontSize="sm">Type</FormLabel>
                        <Select
                          value={announcementForm.type}
                          onChange={(e) => setAnnouncementForm(prev => ({ ...prev, type: e.target.value as any }))}
                          bg={POKER_COLORS.darkBg}
                          borderColor="gray.600"
                          color="white"
                        >
                          <option value="info" style={{ background: '#0D1B2A' }}>ℹ Info</option>

                          <option value="warning" style={{ background: '#0D1B2A' }}> Warning</option>

                          <option value="maintenance" style={{ background: '#0D1B2A' }}> Maintenance</option>

                          <option value="update" style={{ background: '#0D1B2A' }}> Update</option>

                        </Select>
                      </FormControl>
                    </SimpleGrid>

                    <FormControl>
                      <FormLabel color="gray.300" fontSize="sm">Message</FormLabel>
                      <Textarea
                        value={announcementForm.message}
                        onChange={(e) => setAnnouncementForm(prev => ({ ...prev, message: e.target.value }))}
                        placeholder="Scheduled maintenance in 15 minutes. Please finish your hands and cash out."
                        bg={POKER_COLORS.darkBg}
                        borderColor="gray.600"
                        color="white"
                        rows={2}
                      />
                    </FormControl>

                    <HStack justify="flex-end" spacing={3}>
                      <PokerButton
                        variant="secondary"
                        onClick={handleClearAnnouncement}
                        size="sm"
                      >
                        Clear Active Announcement
                      </PokerButton>
                      <PokerButton
                        variant="primary"
                        onClick={handleSendAnnouncement}
                        isLoading={sendingAnnouncement}
                        bg={POKER_COLORS.gold}
                        color="black"
                        leftIcon={<Send size={16} />}
                      >
                        Send Announcement
                      </PokerButton>
                    </HStack>
                  </VStack>
                </PokerCard>

                {/* ===== EMERGENCY CONTROLS ===== */}
                <PokerCard>
                  <VStack spacing={4} align="stretch">
                    <HStack>
                      <AlertTriangle size={24} color="#f56565" />
                      <Text color="red.400" fontWeight="bold" fontSize="xl">Emergency Controls</Text>
                    </HStack>

                    <Box p={4} bg="red.900" borderRadius="lg" border="1px solid" borderColor="red.500">
                      <VStack spacing={3} align="stretch">
                        <Text color="red.200" fontWeight="bold"> Force Kick All Players</Text>

                        <Text color="gray.300" fontSize="sm">
                          Immediately remove all players from all tables. Their chips will be refunded to their wallets.
                          Use this before enabling maintenance mode.
                        </Text>
                        
                        {!showKickConfirm ? (
                          <PokerButton
                            variant="danger"
                            onClick={() => setShowKickConfirm(true)}
                            leftIcon={<XCircle size={18} />}
                            bg="red.600"
                            _hover={{ bg: 'red.500' }}
                          >
                            Force Kick All Players
                          </PokerButton>
                        ) : (
                          <VStack spacing={2}>
                            <Text color="yellow.300" fontWeight="bold" fontSize="sm">
                              Are you sure? This will end all active games!
                            </Text>
                            <HStack>
                              <PokerButton
                                variant="secondary"
                                onClick={() => setShowKickConfirm(false)}
                                size="sm"
                              >
                                Cancel
                              </PokerButton>
                              <PokerButton
                                variant="danger"
                                onClick={handleForceKickAll}
                                isLoading={kickingAllPlayers}
                                bg="red.600"
                                size="sm"
                              >
                                Yes, Kick Everyone
                              </PokerButton>
                            </HStack>
                          </VStack>
                        )}
                      </VStack>
                    </Box>

                    <Box p={4} bg="orange.900" borderRadius="lg" border="1px solid" borderColor="orange.500">
                      <Text color="orange.200" fontWeight="bold" mb={2}> Maintenance Procedure</Text>

                      <VStack align="stretch" spacing={1} fontSize="sm" color="gray.300">
                        <Text>1. Send announcement warning users (15 min notice)</Text>
                        <Text>2. Wait for users to finish hands and cash out</Text>
                        <Text>3. Send final warning announcement (5 min notice)</Text>
                        <Text>4. Force kick all remaining players</Text>
                        <Text>5. Enable maintenance mode</Text>
                        <Text>6. Perform updates</Text>
                        <Text>7. Disable maintenance mode</Text>
                      </VStack>
                    </Box>
                  </VStack>
                </PokerCard>

                {/* ===== FEATURED TABLES MANAGEMENT ===== */}
                <PokerCard>
                  <VStack spacing={4} align="stretch">
                    <HStack>
                      <Star size={24} color="#a855f7" />
                      <Text color="purple.400" fontWeight="bold" fontSize="xl">Featured Tables</Text>
                    </HStack>

                    <Box p={4} bg="rgba(168,85,247,0.1)" borderRadius="lg" border="1px solid" borderColor="purple.600">
                      <VStack spacing={3} align="stretch">
                        <Text color="purple.200" fontWeight="bold"> Reset Featured Tables</Text>

                        <Text color="gray.300" fontSize="sm">
                          Deletes ALL featured tables, clears all chat messages, and recreates fresh from config.
                          Use after deploying new bot code to make changes take effect.
                        </Text>
                        <PokerButton
                          variant="primary"
                          bg="purple.600"
                          _hover={{ bg: 'purple.500' }}
                          onClick={async () => {
                            if (!window.confirm('Reset ALL featured tables?\n\nThis will:\n• Delete all 4 featured tables\n• Clear all chat messages\n• Recreate fresh tables from config\n• Re-seed bots with updated code\n\nContinue?')) return;
                            try {
                              const token = await auth.currentUser?.getIdToken();
                              // Step 1: Delete all featured tables + clear chats
                              const resetRes = await fetch(
                                `${API_BASE}/admin/resetFeaturedTables`,
                                {
                                  method: 'POST',
                                  headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${token}`,
                                  },
                                }
                              );
                              const resetResult = await resetRes.json();

                              // Step 2: Recreate via ensureFeaturedTables
                              const { getFunctions, httpsCallable } = await import('firebase/functions');
                              const functions = getFunctions();
                              const ensure = httpsCallable(functions, 'ensureFeaturedTables');
                              const ensureResult: any = await ensure();

                              // Step 3: Re-seed bots on PlayCoin tables
                              await fetch(
                                `${API_BASE}/admin/seedFeaturedBots`,
                                {
                                  method: 'POST',
                                  headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${token}`,
                                  },
                                }
                              );

                              toast({
                                title: 'Featured Tables Reset',

                                description: `Deleted ${resetResult.removed || 0} tables, cleared ${resetResult.messagesCleared || 0} messages, recreated ${ensureResult.data?.created?.length || 0} tables, bots re-seeded`,
                                status: 'success',
                                duration: 5000,
                              });
                            } catch (error: any) {
                              toast({
                                title: 'Error resetting tables',
                                description: error.message,
                                status: 'error',
                                duration: 5000,
                              });
                            }
                          }}
                        >
                           Reset & Recreate Featured Tables

                        </PokerButton>
                        
                        <Text color="gray.500" fontSize="xs">
                          Current config: PlayCoins Low, Sophia's VIP (Premium), PKCash Micro, PKCash Low
                        </Text>
                      </VStack>
                    </Box>

                    <Box p={4} bg="rgba(0,217,217,0.1)" borderRadius="lg" border="1px solid" borderColor="cyan.600">
                      <VStack spacing={3} align="stretch">
                        <Text color="cyan.200" fontWeight="bold"> Seed Featured Bots</Text>

                        <Text color="gray.300" fontSize="sm">
                          Pre-seeds house bots on empty PlayCoin featured tables so they appear active in the lobby.
                        </Text>
                        <PokerButton
                          variant="primary"
                          onClick={async () => {
                            try {
                              const token = await auth.currentUser?.getIdToken();
                              const response = await fetch(
                                `${API_BASE}/admin/seedFeaturedBots`,
                                {
                                  method: 'POST',
                                  headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${token}`,
                                  },
                                }
                              );
                              const result = await response.json();
                              toast({
                                title: 'Bots Seeded',

                                description: `Seeded: ${result.seeded}, Skipped: ${result.skipped}`,
                                status: 'success',
                                duration: 3000,
                              });
                            } catch (error: any) {
                              toast({
                                title: 'Error seeding bots',
                                description: error.message,
                                status: 'error',
                                duration: 5000,
                              });
                            }
                          }}
                        >
                           Seed Bots on Featured Tables

                        </PokerButton>
                      </VStack>
                    </Box>

                  </VStack>
                </PokerCard>

                {/* ===== LAUNCH PREPARATION (existing) ===== */}
                <PokerCard>
                  <VStack spacing={6} align="stretch">
                    <Box>
                      <HStack mb={4}>
                        <AlertTriangle size={24} color="#f56565" />
                        <Text color="red.400" fontWeight="bold" fontSize="xl">Launch Preparation</Text>
                      </HStack>
                      <Text color="gray.400" mb={4}>
                        Use these tools to prepare your app for production launch. These actions are irreversible.
                      </Text>
                    </Box>

                    <Box 
                      p={6} 
                      bg="red.900" 
                      borderRadius="lg" 
                      border="2px solid" 
                      borderColor="red.500"
                    >
                      <VStack spacing={4} align="stretch">
                        <HStack>
                          <AlertTriangle size={20} color="#fc8181" />
                          <Text color="red.300" fontWeight="bold" fontSize="lg">Reset All User Data</Text>
                        </HStack>
                        
                        <Text color="gray.300" fontSize="sm">
                          This will reset ALL user balances, delete ALL transactions, remove ALL tables, 
                          clear rake history (including tournament rake), reset referral earnings, and delete ALL tournaments.
                          Users will keep their accounts but start fresh with 1,000 PlayCoins.
                        </Text>
                        
                        <Box bg="blackAlpha.400" p={4} borderRadius="md">
                          <Text color="yellow.300" fontWeight="bold" fontSize="sm" mb={2}> THIS ACTION CANNOT BE UNDONE</Text>

                          <Text color="gray.400" fontSize="xs">
                            Only use this when transitioning from Stripe test mode to production.
                            Make sure all beta testing is complete.
                          </Text>
                        </Box>
                        
                        <PokerButton 
                          variant="danger"
                          leftIcon={<Trash2 size={18} />}
                          onClick={() => setShowResetDialog(true)}
                          bg="red.600"
                          _hover={{ bg: 'red.500' }}
                          color="white"
                        >
                          Reset All Data for Production Launch
                        </PokerButton>
                      </VStack>
                    </Box>

                    <Box p={6} bg={`${POKER_COLORS.darkTeal}aa`} borderRadius="lg" border="1px solid" borderColor={`${POKER_COLORS.cyan}33`}>
                      <Text color={POKER_COLORS.cyan} fontWeight="bold" mb={4}> Launch Checklist</Text>

                      <VStack align="stretch" spacing={2}>
                        <HStack><Text color="gray.400"></Text><Text color="gray.300">Switch Stripe from test mode to live mode</Text></HStack>

                        <HStack><Text color="gray.400"></Text><Text color="gray.300">Configure Stripe Identity webhooks</Text></HStack>

                        <HStack><Text color="gray.400"></Text><Text color="gray.300">Configure Stripe Connect webhooks</Text></HStack>

                        <HStack><Text color="gray.400"></Text><Text color="gray.300">Deploy Cloud Functions</Text></HStack>

                        <HStack><Text color="gray.400"></Text><Text color="gray.300">Verify Firebase security rules</Text></HStack>

                        <HStack><Text color="gray.400"></Text><Text color="gray.300">Test KYC verification flow</Text></HStack>

                        <HStack><Text color="gray.400"></Text><Text color="gray.300">Test payout flow with Stripe Connect</Text></HStack>

                        <HStack><Text color="gray.400"></Text><Text color="gray.300">Reset all beta test data (button above)</Text></HStack>

                        <HStack><Text color="gray.400"></Text><Text color="gray.300">Generate first week of tournaments</Text></HStack>

                      </VStack>
                    </Box>
                  </VStack>
                </PokerCard>
              </VStack>
            </TabPanel>

            {/*  NEW: Push Notifications Tab */}

            <TabPanel px={0}>
              <VStack spacing={6} align="stretch">
                {/* Push Stats Cards */}
                <SimpleGrid columns={{ base: 2, md: 4 }} spacing={4}>
                  <PokerCard>
                    <Stat>
                      <StatLabel color="gray.400">
                        <HStack><Smartphone size={14} /><Text>Push Enabled Users</Text></HStack>
                      </StatLabel>
                      <StatNumber color="white" fontSize="2xl">
                        {stats.pushEnabledUsers}
                      </StatNumber>
                      <StatHelpText color="gray.500">
                        {stats.androidPushUsers} Android • {stats.iosPushUsers} iOS
                      </StatHelpText>
                    </Stat>
                  </PokerCard>

                  <PokerCard>
                    <Stat>
                      <StatLabel color="gray.400">
                        <HStack><Bell size={14} /><Text>Announcements Sent</Text></HStack>
                      </StatLabel>
                      <StatNumber color={POKER_COLORS.cyan} fontSize="2xl">
                        {stats.totalAnnouncements}
                      </StatNumber>
                      <StatHelpText color="gray.500">All time</StatHelpText>
                    </Stat>
                  </PokerCard>

                  <PokerCard>
                    <Stat>
                      <StatLabel color="gray.400">
                        <HStack><CheckCircle size={14} /><Text>Android</Text></HStack>
                      </StatLabel>
                      <StatNumber color="green.400" fontSize="2xl">
                        {stats.androidPushUsers}
                      </StatNumber>
                      <StatHelpText color="gray.500">Ready now</StatHelpText>
                    </Stat>
                  </PokerCard>

                  <PokerCard>
                    <Stat>
                      <StatLabel color="gray.400">
                        <HStack><Smartphone size={14} /><Text>iOS</Text></HStack>
                      </StatLabel>
                      <StatNumber color="blue.400" fontSize="2xl">
                        {stats.iosPushUsers}
                      </StatNumber>
                      <StatHelpText color="gray.500">When approved</StatHelpText>
                    </Stat>
                  </PokerCard>
                </SimpleGrid>

                {/* Send Announcement Form */}
                <PokerCard>
                  <VStack spacing={4} align="stretch">
                    <HStack justify="space-between">
                      <HStack>
                        <SendIcon size={20} color={POKER_COLORS.cyan} />
                        <Heading size="md" color="white">Send Announcement</Heading>
                      </HStack>
                      <PokerButton
                        variant="ghost"
                        size="sm"
                        onClick={async () => {
                          setLoadingPushData(true);
                          try {
                            // Reload push stats
                            const usersSnapshot = await getDocs(query(
                              collection(db, 'users'),
                              where('fcmToken', '!=', null)
                            ));
                            let androidCount = 0;
                            let iosCount = 0;
                            usersSnapshot.docs.forEach(doc => {
                              const data = doc.data();
                              if (data.fcmPlatform === 'android') androidCount++;
                              else if (data.fcmPlatform === 'ios') iosCount++;
                            });
                            setStats(prev => ({
                              ...prev,
                              pushEnabledUsers: usersSnapshot.size,
                              androidPushUsers: androidCount,
                              iosPushUsers: iosCount,
                            }));
                            
                            // Reload announcements
                            const announcementsSnapshot = await getDocs(query(
                              collection(db, 'announcements'),
                              orderBy('sentAt', 'desc'),
                              limit(20)
                            ));
                            setPushAnnouncements(announcementsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
                            setStats(prev => ({ ...prev, totalAnnouncements: announcementsSnapshot.size }));
                            
                            toast({ title: 'Refreshed', status: 'success', duration: 2000 });
                          } catch (err) {
                            console.error('Error refreshing push data:', err);
                          } finally {
                            setLoadingPushData(false);
                          }
                        }}
                        isLoading={loadingPushData}
                        leftIcon={<RefreshCw size={14} />}
                      >
                        Refresh
                      </PokerButton>
                    </HStack>

                    <Divider borderColor="gray.700" />

                    {stats.pushEnabledUsers === 0 ? (
                      <Box bg="orange.900" p={4} borderRadius="md">
                        <HStack>
                          <AlertTriangle size={20} color="orange" />
                          <VStack align="start" spacing={0}>
                            <Text color="white" fontWeight="bold">No Users with Push Notifications</Text>
                            <Text color="gray.300" fontSize="sm">
                              No users have enabled push notifications yet. Users need to install the mobile app and grant notification permissions.
                            </Text>
                          </VStack>
                        </HStack>
                      </Box>
                    ) : (
                      <>
                        <Box>
                          <Text color="gray.400" fontSize="sm" mb={2}>Recipient</Text>
                          {pushTarget ? (
                            <HStack bg={POKER_COLORS.darkBg} p={3} borderRadius="md" border="1px solid" borderColor="cyan.700">
                              <Badge colorScheme="cyan">TARGETED</Badge>
                              <Text color="white" fontWeight="bold" flex={1}>{pushTarget.username}</Text>
                              <Button
                                size="xs"
                                variant="ghost"
                                color="gray.400"
                                onClick={() => {
                                  setPushTarget(null);
                                  setPushTargetQuery('');
                                  setPushTargetResults([]);
                                }}
                              >
                                Clear (send to everyone)
                              </Button>
                            </HStack>
                          ) : (
                            <VStack align="stretch" spacing={2}>
                              <HStack>
                                <Input
                                  value={pushTargetQuery}
                                  onChange={(e) => setPushTargetQuery(e.target.value)}
                                  onKeyDown={async (e) => {
                                    if (e.key === 'Enter' && pushTargetQuery.trim()) {
                                      setPushTargetSearching(true);
                                      const r = await gameApiService.searchUsers(pushTargetQuery.trim(), 10);
                                      setPushTargetSearching(false);
                                      setPushTargetResults(r.success && r.users ? r.users : []);
                                    }
                                  }}
                                  placeholder="Everyone (or search a username to target one user)"
                                  bg={POKER_COLORS.darkBg}
                                  borderColor="gray.600"
                                  color="white"
                                  _placeholder={{ color: 'gray.500' }}
                                />
                                <Button
                                  colorScheme="cyan"
                                  variant="outline"
                                  leftIcon={<Search size={14} />}
                                  isLoading={pushTargetSearching}
                                  isDisabled={!pushTargetQuery.trim()}
                                  onClick={async () => {
                                    setPushTargetSearching(true);
                                    const r = await gameApiService.searchUsers(pushTargetQuery.trim(), 10);
                                    setPushTargetSearching(false);
                                    setPushTargetResults(r.success && r.users ? r.users : []);
                                  }}
                                >
                                  Find
                                </Button>
                              </HStack>
                              {pushTargetResults.length > 0 && (
                                <VStack align="stretch" spacing={1} maxH="180px" overflowY="auto">
                                  {pushTargetResults.map(u => (
                                    <HStack
                                      key={u.id}
                                      px={3}
                                      py={2}
                                      bg={POKER_COLORS.darkBg}
                                      borderRadius="sm"
                                      cursor="pointer"
                                      _hover={{ bg: 'gray.700' }}
                                      onClick={() => {
                                        setPushTarget({ id: u.id, username: u.username });
                                        setPushTargetResults([]);
                                      }}
                                    >
                                      <Text fontSize="sm" color="white" flex={1}>{u.username}</Text>
                                      <Text fontSize="xs" color="gray.500">{u.id.substring(0, 10)}…</Text>
                                    </HStack>
                                  ))}
                                </VStack>
                              )}
                              {pushTargetResults.length === 0 && !pushTargetSearching && pushTargetQuery.trim() === '' && (
                                <Text color="gray.500" fontSize="xs">
                                  Leave empty to broadcast to all {stats.pushEnabledUsers} push-enabled users.
                                </Text>
                              )}
                            </VStack>
                          )}
                        </Box>

                        <Box>
                          <Text color="gray.400" fontSize="sm" mb={2}>Title *</Text>
                          <Input
                            value={pushAnnouncementTitle}
                            onChange={(e) => setPushAnnouncementTitle(e.target.value)}
                            placeholder="Announcement title..."
                            bg={POKER_COLORS.darkBg}
                            borderColor="gray.600"
                            color="white"
                            _placeholder={{ color: 'gray.500' }}
                            maxLength={100}
                          />
                          <Text color="gray.500" fontSize="xs" mt={1} textAlign="right">
                            {pushAnnouncementTitle.length}/100
                          </Text>
                        </Box>

                        <Box>
                          <Text color="gray.400" fontSize="sm" mb={2}>Message *</Text>
                          <Textarea
                            value={pushAnnouncementBody}
                            onChange={(e) => setPushAnnouncementBody(e.target.value)}
                            placeholder="Enter your announcement message..."
                            bg={POKER_COLORS.darkBg}
                            borderColor="gray.600"
                            color="white"
                            _placeholder={{ color: 'gray.500' }}
                            rows={4}
                            maxLength={500}
                          />
                          <Text color="gray.500" fontSize="xs" mt={1} textAlign="right">
                            {pushAnnouncementBody.length}/500
                          </Text>
                        </Box>

                        {/* Preview */}
                        {(pushAnnouncementTitle || pushAnnouncementBody) && (
                          <Box bg={POKER_COLORS.darkBg} p={4} borderRadius="lg" border="1px solid" borderColor="gray.700">
                            <Text color="gray.400" fontSize="xs" mb={2}>PREVIEW</Text>
                            <HStack align="start" spacing={3}>
                              <Box bg="cyan.600" p={2} borderRadius="md">
                                <Bell size={20} color="white" />
                              </Box>
                              <VStack align="start" spacing={0}>
                                <Text color="white" fontWeight="bold">{pushAnnouncementTitle || 'Title'}</Text>
                                <Text color="gray.400" fontSize="sm">{pushAnnouncementBody || 'Message'}</Text>
                              </VStack>
                            </HStack>
                          </Box>
                        )}

                        <HStack justify="space-between" pt={2}>
                          <Text color="gray.500" fontSize="sm">
                            {pushTarget
                              ? `Sending only to ${pushTarget.username}`
                              : `Will be sent to ${stats.pushEnabledUsers} users`}
                          </Text>
                          <PokerButton
                            variant="primary"
                            onClick={async () => {
                              if (!pushAnnouncementTitle.trim() || !pushAnnouncementBody.trim()) {
                                toast({ title: 'Missing fields', description: 'Please enter both title and message', status: 'warning', duration: 3000 });
                                return;
                              }
                              const confirmText = pushTarget
                                ? `Send this announcement to ${pushTarget.username} only?\n\nTitle: ${pushAnnouncementTitle}\nMessage: ${pushAnnouncementBody}`
                                : `Send this announcement to ${stats.pushEnabledUsers} users?\n\nTitle: ${pushAnnouncementTitle}\nMessage: ${pushAnnouncementBody}`;
                              if (!window.confirm(confirmText)) {
                                return;
                              }
                              setSendingPushAnnouncement(true);
                              try {
                                if (pushTarget) {
                                  // Single-recipient send through the admin test
                                  // endpoint, tagged as an announcement so the
                                  // client routes the tap like a real one.
                                  const r = await gameApiService.sendTestPush(
                                    pushTarget.id,
                                    pushAnnouncementTitle,
                                    pushAnnouncementBody,
                                    { type: 'announcement' }
                                  );
                                  if (!r.success) {
                                    const codes = (r.report || [])
                                      .map(t => t.errorCode)
                                      .filter(Boolean)
                                      .join(', ');
                                    throw new Error(
                                      r.message || r.error ||
                                      (codes
                                        ? `Delivery failed on all ${r.tokensTried} device(s): ${codes}`
                                        : `Delivery failed on all ${r.tokensTried ?? 0} device(s)`)
                                    );
                                  }
                                  toast({
                                    title: 'Sent!',
                                    description: `Delivered to ${r.successCount}/${r.tokensTried} of ${pushTarget.username}'s devices${r.failureCount ? ` (${r.failureCount} failed)` : ''}`,
                                    status: 'success',
                                    duration: 5000,
                                  });
                                  setPushAnnouncementTitle('');
                                  setPushAnnouncementBody('');
                                  setSendingPushAnnouncement(false);
                                  return;
                                }

                                const user = auth.currentUser;
                                if (!user) throw new Error('Not authenticated');
                                const idToken = await user.getIdToken();

                                const response = await fetch(
                                  `${API_BASE}/sendAnnouncement`,
                                  {
                                    method: 'POST',
                                    headers: {
                                      'Content-Type': 'application/json',
                                      'Authorization': `Bearer ${idToken}`,
                                    },
                                    body: JSON.stringify({
                                      title: pushAnnouncementTitle,
                                      body: pushAnnouncementBody
                                    }),
                                  }
                                );
                                const result = await response.json();

                                if (!response.ok) {
                                  throw new Error(result.error || 'Failed to send announcement');
                                }

                                toast({
                                  title: 'Announcement Sent!',

                                  description: `Sent to ${result.sent} users (${result.failed} failed)`,
                                  status: 'success',
                                  duration: 5000,
                                });

                                // Clear form
                                setPushAnnouncementTitle('');
                                setPushAnnouncementBody('');

                                // Reload announcements
                                const announcementsSnapshot = await getDocs(query(
                                  collection(db, 'announcements'),
                                  orderBy('sentAt', 'desc'),
                                  limit(20)
                                ));
                                setPushAnnouncements(announcementsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
                                setStats(prev => ({ ...prev, totalAnnouncements: announcementsSnapshot.size }));

                              } catch (err: any) {
                                toast({ title: 'Error', description: err.message, status: 'error', duration: 5000 });
                              } finally {
                                setSendingPushAnnouncement(false);
                              }
                            }}
                            isLoading={sendingPushAnnouncement}
                            loadingText="Sending..."
                            isDisabled={!pushAnnouncementTitle.trim() || !pushAnnouncementBody.trim()}
                            leftIcon={<SendIcon size={16} />}
                          >
                            {pushTarget ? `Send to ${pushTarget.username}` : 'Send Announcement'}
                          </PokerButton>
                        </HStack>
                      </>
                    )}
                  </VStack>
                </PokerCard>

                {/* Announcement History */}
                <PokerCard>
                  <VStack spacing={4} align="stretch">
                    <HStack>
                      <Clock size={20} color={POKER_COLORS.gold} />
                      <Heading size="md" color="white">Announcement History</Heading>
                    </HStack>

                    <Divider borderColor="gray.700" />

                    {pushAnnouncements.length === 0 ? (
                      <Text color="gray.500" textAlign="center" py={6}>
                        No announcements sent yet
                      </Text>
                    ) : (
                      <Box overflowX="auto">
                        <Table variant="simple" size="sm">
                          <Thead>
                            <Tr>
                              <Th color="gray.400" borderColor="gray.700">Date</Th>
                              <Th color="gray.400" borderColor="gray.700">Title</Th>
                              <Th color="gray.400" borderColor="gray.700">Message</Th>
                              <Th color="gray.400" borderColor="gray.700" isNumeric>Sent</Th>
                              <Th color="gray.400" borderColor="gray.700" isNumeric>Failed</Th>
                              <Th color="gray.400" borderColor="gray.700">Sent By</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {pushAnnouncements.map((announcement: any) => (
                              <Tr key={announcement.id}>
                                <Td borderColor="gray.700" color="gray.300" fontSize="xs">
                                  {announcement.sentAt?.toDate?.()?.toLocaleString() || 'Unknown'}
                                </Td>
                                <Td borderColor="gray.700" color="white" fontWeight="medium" maxW="150px" isTruncated>
                                  {announcement.title}
                                </Td>
                                <Td borderColor="gray.700" color="gray.400" maxW="200px" isTruncated>
                                  {announcement.body}
                                </Td>
                                <Td borderColor="gray.700" isNumeric>
                                  <Badge colorScheme="green">{announcement.successCount || 0}</Badge>
                                </Td>
                                <Td borderColor="gray.700" isNumeric>
                                  <Badge colorScheme={announcement.failedCount > 0 ? 'red' : 'gray'}>
                                    {announcement.failedCount || 0}
                                  </Badge>
                                </Td>
                                <Td borderColor="gray.700" color="gray.400" fontSize="xs">
                                  {announcement.sentByUsername || announcement.sentBy?.substring(0, 8) || 'Admin'}
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        </Table>
                      </Box>
                    )}
                  </VStack>
                </PokerCard>

                {/* Info Alert */}
                <Box bg="blue.900" p={4} borderRadius="lg">
                  <HStack align="start">
                    <Bell size={20} color="#63B3ED" />
                    <Box flex="1">
                      <Text color="white" fontWeight="bold">Push Notification Types</Text>
                      <VStack align="start" spacing={1} mt={2}>
                        <Text color="gray.300" fontSize="sm"> <strong>Announcements</strong> - Sent manually from this panel (admin only)</Text>

                        <Text color="gray.300" fontSize="sm"> <strong>Mentions</strong> - Auto-sent when user is @mentioned in feed/comments</Text>

                        <Text color="gray.300" fontSize="sm"> <strong>Direct Messages</strong> - Auto-sent for new DMs from friends</Text>

                        <Text color="gray.300" fontSize="sm"> <strong>Table Invites</strong> - Auto-sent when invited to a table</Text>

                        <Text color="gray.300" fontSize="sm">🃏 <strong>Game Alerts</strong> - Auto-sent for "your turn" notifications</Text>
                        <Text color="gray.300" fontSize="sm"> <strong>Promotions</strong> - Sent manually for special offers (opt-in)</Text>

                      </VStack>
                    </Box>
                  </HStack>
                </Box>
              </VStack>
            </TabPanel>

            {/* Tournament Testing Tab */}
            <TabPanel px={0}>
              <AdminTournamentTesting />
            </TabPanel>

            {/* Push Notification Testing Tab */}
            <TabPanel px={0}>
              <AdminPushTesting />
            </TabPanel>

            {/* Branded email broadcast Tab */}
            <TabPanel px={0}>
              <AdminEmailBroadcast />
            </TabPanel>

            {/* Training earnings audit Tab */}
            <TabPanel px={0}>
              <AdminTrainingEarnings />
            </TabPanel>

          </TabPanels>
        </Tabs>

        {/* Create Tournament Modal */}
        <Modal isOpen={isOpen} onClose={onClose} size="xl">
          <ModalOverlay bg="blackAlpha.700" />
          <ModalContent bg={POKER_COLORS.darkTeal} borderColor={POKER_COLORS.cyan} border="2px">
            <ModalHeader color={POKER_COLORS.cyan}><HStack><Trophy size={24} /><Text>Create Custom Tournament</Text></HStack></ModalHeader>
            <ModalCloseButton color={POKER_COLORS.cyan} />
            <ModalBody>
              <VStack spacing={4}>
                <FormControl isRequired>
                  <FormLabel color="gray.300">Name</FormLabel>
                  <Input placeholder="Sunday Showdown" value={tournamentForm.name} onChange={e => setTournamentForm({...tournamentForm, name: e.target.value})} bg={POKER_COLORS.darkBg} borderColor={POKER_COLORS.cyan} color="white" />
                </FormControl>
                <FormControl>
                  <FormLabel color="gray.300">Description</FormLabel>
                  <Textarea placeholder="Tournament description..." value={tournamentForm.description} onChange={e => setTournamentForm({...tournamentForm, description: e.target.value})} bg={POKER_COLORS.darkBg} borderColor={POKER_COLORS.cyan} color="white" />
                </FormControl>
                <HStack w="100%">
                  <FormControl isRequired>
                    <FormLabel color="gray.300">Date</FormLabel>
                    <Input type="date" value={tournamentForm.startDate} onChange={e => setTournamentForm({...tournamentForm, startDate: e.target.value})} bg={POKER_COLORS.darkBg} borderColor={POKER_COLORS.cyan} color="white" />
                  </FormControl>
                  <FormControl isRequired>
                    <FormLabel color="gray.300">Time</FormLabel>
                    <Input type="time" value={tournamentForm.startTime} onChange={e => setTournamentForm({...tournamentForm, startTime: e.target.value})} bg={POKER_COLORS.darkBg} borderColor={POKER_COLORS.cyan} color="white" />
                  </FormControl>
                </HStack>
                <HStack w="100%">
                  <FormControl>
                    <FormLabel color="gray.300">Buy-in</FormLabel>
                    <NumberInput value={tournamentForm.buyInAmount} onChange={(_, v) => setTournamentForm({...tournamentForm, buyInAmount: v || 0})}>
                      <NumberInputField bg={POKER_COLORS.darkBg} borderColor={POKER_COLORS.cyan} color="white" />
                    </NumberInput>
                  </FormControl>
                  <FormControl>
                    <FormLabel color="gray.300">Currency</FormLabel>
                    <Select value={tournamentForm.currency} onChange={e => setTournamentForm({...tournamentForm, currency: e.target.value as any})} bg={POKER_COLORS.darkBg} borderColor={POKER_COLORS.cyan} color="white">
                      <option value="playcoins" style={{background: '#0D1B2A'}}>PlayCoins</option>
                      <option value="pkcash" style={{background: '#0D1B2A'}}>PKCash</option>
                    </Select>
                  </FormControl>
                </HStack>
                <HStack w="100%">
                  <FormControl>
                    <FormLabel color="gray.300">Starting Chips</FormLabel>
                    <NumberInput value={tournamentForm.startingChips} onChange={(_, v) => setTournamentForm({...tournamentForm, startingChips: v || 0})}>
                      <NumberInputField bg={POKER_COLORS.darkBg} borderColor={POKER_COLORS.cyan} color="white" />
                    </NumberInput>
                  </FormControl>
                  <FormControl>
                    <FormLabel color="gray.300">Min Players</FormLabel>
                    <NumberInput value={tournamentForm.minPlayers} onChange={(_, v) => setTournamentForm({...tournamentForm, minPlayers: v || 2})}>
                      <NumberInputField bg={POKER_COLORS.darkBg} borderColor={POKER_COLORS.cyan} color="white" />
                    </NumberInput>
                  </FormControl>
                </HStack>
              </VStack>
            </ModalBody>
            <ModalFooter gap={3}>
              <PokerButton variant="secondary" onClick={onClose}>Cancel</PokerButton>
              <PokerButton variant="primary" onClick={handleCreateTournament}>Create Tournament</PokerButton>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Add Agent Modal */}
        <Modal isOpen={isAgentOpen} onClose={onAgentClose} size="md">
          <ModalOverlay bg="blackAlpha.700" />
          <ModalContent bg={POKER_COLORS.darkTeal} borderColor={POKER_COLORS.gold} border="2px">
            <ModalHeader color={POKER_COLORS.gold}><HStack><UserPlus size={24} /><Text>Add New Agent</Text></HStack></ModalHeader>
            <ModalCloseButton color={POKER_COLORS.gold} />
            <ModalBody>
              <VStack spacing={4}>
                <FormControl isRequired>
                  <FormLabel color="gray.300">Search User</FormLabel>
                  <InputGroup>
                    <InputLeftElement><Search size={16} color="#718096" /></InputLeftElement>
                    <Input 
                      placeholder="Search by username or email..." 
                      value={agentUserSearch}
                      onChange={e => setAgentUserSearch(e.target.value)}
                      bg={POKER_COLORS.darkBg} 
                      borderColor={POKER_COLORS.gold} 
                      color="white" 
                    />
                  </InputGroup>
                  {agentFilteredUsers.length > 0 && (
                    <Box mt={2} bg={POKER_COLORS.darkBg} borderRadius="md" maxH="200px" overflow="auto">
                      {agentFilteredUsers.map(user => (
                        <Box
                          key={user.id}
                          p={3}
                          cursor="pointer"
                          _hover={{ bg: `${POKER_COLORS.gold}22` }}
                          onClick={() => handleSelectAgentUser(user)}
                        >
                          <HStack justify="space-between">
                            <VStack align="start" spacing={0}>
                              <Text color="white" fontWeight="bold">{user.username}</Text>
                              <Text color="gray.500" fontSize="xs">{user.email}</Text>
                            </VStack>
                          </HStack>
                        </Box>
                      ))}
                    </Box>
                  )}
                  {selectedAgentUser && (
                    <Box mt={2} p={3} bg={`${POKER_COLORS.gold}22`} borderRadius="md" border="1px solid" borderColor={POKER_COLORS.gold}>
                      <HStack justify="space-between">
                        <Text color={POKER_COLORS.gold} fontWeight="bold">
                           Selected: {selectedAgentUser.username}

                        </Text>
                        <Button size="xs" onClick={() => setSelectedAgentUser(null)}>Clear</Button>
                      </HStack>
                    </Box>
                  )}
                </FormControl>
                <FormControl isRequired>
                  <FormLabel color="gray.300">Role</FormLabel>
                  <Select value={newAgentRole} onChange={e => setNewAgentRole(e.target.value as any)} bg={POKER_COLORS.darkBg} borderColor={POKER_COLORS.gold} color="white">
                    <option value="agent" style={{background: '#0D1B2A'}}>Agent / influencer (earns on their own players)</option>
                    <option value="manager" style={{background: '#0D1B2A'}}>Manager (earns a cut on their agents' players)</option>
                  </Select>
                </FormControl>
                {newAgentRole === 'agent' ? (
                  <>
                    <FormControl isRequired>
                      <FormLabel color="gray.300">Agent Tier</FormLabel>
                      <Select value={newAgentTier} onChange={e => setNewAgentTier(e.target.value as any)} bg={POKER_COLORS.darkBg} borderColor={POKER_COLORS.gold} color="white">
                        <option value="standard" style={{background: '#0D1B2A'}}>Standard (10% of rake)</option>
                        <option value="premium" style={{background: '#0D1B2A'}}>Premium (15% of rake)</option>
                        <option value="vip" style={{background: '#0D1B2A'}}>VIP (20% of rake)</option>
                      </Select>
                    </FormControl>
                    <FormControl>
                      <FormLabel color="gray.300">Manager (optional)</FormLabel>
                      <Select value={newAgentManagerId} onChange={e => setNewAgentManagerId(e.target.value)} bg={POKER_COLORS.darkBg} borderColor={POKER_COLORS.gold} color="white">
                        <option value="" style={{background: '#0D1B2A'}}>No manager</option>
                        {agents.filter(m => m.role === 'manager' && m.active).map(m => (
                          <option key={m.id} value={m.id} style={{background: '#0D1B2A'}}>{m.displayName}</option>
                        ))}
                      </Select>
                    </FormControl>
                  </>
                ) : (
                  <Box w="100%" p={3} bg={`${POKER_COLORS.gold}14`} border="1px solid" borderColor={`${POKER_COLORS.gold}55`} borderRadius="md">
                    <Text color="white" fontSize="sm">
                      A manager earns 5% of the rake from every player under their agents, on top of what those agents earn. The program is rake-only: nothing is paid on purchases. Nothing to configure.
                    </Text>
                  </Box>
                )}
                <FormControl>
                  <FormLabel color="gray.300">Custom code (optional)</FormLabel>
                  <Input placeholder="e.g. GATEWAY" value={newAgentCode} onChange={e => setNewAgentCode(e.target.value.toUpperCase())} maxLength={20} bg={POKER_COLORS.darkBg} borderColor={POKER_COLORS.gold} color="white" fontFamily="mono" />
                  <Text fontSize="xs" color="gray.500" mt={1}>3 to 20 letters or numbers. Players sign up with this code or the link ?ref=CODE. Leave blank to use their generated code.</Text>
                </FormControl>
              </VStack>
            </ModalBody>
            <ModalFooter gap={3}>
              <PokerButton variant="secondary" onClick={onAgentClose}>Cancel</PokerButton>
              <PokerButton variant="primary" onClick={handleCreateAgent} isLoading={creatingAgent} isDisabled={!selectedAgentUser}>{newAgentRole === 'manager' ? 'Create Manager' : 'Create Agent'}</PokerButton>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Agent settings modal */}
        <Modal isOpen={!!settingsAgent} onClose={() => setSettingsAgent(null)} size="md">
          <ModalOverlay bg="blackAlpha.700" />
          <ModalContent bg={POKER_COLORS.darkTeal} borderColor={POKER_COLORS.gold} border="2px">
            <ModalHeader color={POKER_COLORS.gold}><HStack><Settings size={22} /><Text>{settingsAgent?.displayName}: {settingsAgent?.role === 'manager' ? 'manager' : 'agent'} settings</Text></HStack></ModalHeader>
            <ModalCloseButton color={POKER_COLORS.gold} />
            <ModalBody>
              <VStack spacing={4}>
                <FormControl>
                  <FormLabel color="gray.300">Custom code</FormLabel>
                  <Input value={settingsForm.customCode} onChange={e => setSettingsForm({ ...settingsForm, customCode: e.target.value.toUpperCase() })} placeholder="e.g. GATEWAY (blank = generated code)" maxLength={20} bg={POKER_COLORS.darkBg} borderColor={POKER_COLORS.gold} color="white" fontFamily="mono" />
                </FormControl>
                <FormControl>
                  <FormLabel color="gray.300">Tier (their own players)</FormLabel>
                  <Select value={settingsForm.tier} onChange={e => setSettingsForm({ ...settingsForm, tier: e.target.value })} bg={POKER_COLORS.darkBg} borderColor={POKER_COLORS.gold} color="white">
                    <option value="standard" style={{background: '#0D1B2A'}}>Standard (10% of rake)</option>
                    <option value="premium" style={{background: '#0D1B2A'}}>Premium (15% of rake)</option>
                    <option value="vip" style={{background: '#0D1B2A'}}>VIP (20% of rake)</option>
                  </Select>
                </FormControl>
                {settingsAgent?.role === 'manager' ? (
                  <Box w="100%" p={3} bg={`${POKER_COLORS.gold}14`} border="1px solid" borderColor={`${POKER_COLORS.gold}55`} borderRadius="md">
                    <Text color="white" fontSize="sm">
                      Manager cut: 5% of the rake from every player under their agents, on top of what those agents earn. Rake-only, nothing on purchases.
                    </Text>
                  </Box>
                ) : (
                  <FormControl>
                    <FormLabel color="gray.300">Manager</FormLabel>
                    <Select value={settingsForm.managerId} onChange={e => setSettingsForm({ ...settingsForm, managerId: e.target.value })} bg={POKER_COLORS.darkBg} borderColor={POKER_COLORS.gold} color="white">
                      <option value="" style={{background: '#0D1B2A'}}>No manager</option>
                      {agents.filter(m => m.role === 'manager' && m.active && m.id !== settingsAgent?.id).map(m => (
                        <option key={m.id} value={m.id} style={{background: '#0D1B2A'}}>{m.displayName}</option>
                      ))}
                    </Select>
                    <Text fontSize="xs" color="gray.500" mt={1}>The manager earns their override on everything this agent's players generate. The agent's own cut is unchanged.</Text>
                  </FormControl>
                )}
                <Box w="100%" p={3} bg={`${POKER_COLORS.cyan}0D`} border="1px solid" borderColor={`${POKER_COLORS.cyan}44`} borderRadius="md">
                  <Text color={POKER_COLORS.cyan} fontWeight="bold" fontSize="sm" mb={2}>Creator program</Text>
                  <FormControl display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                    <FormLabel color="gray.300" fontSize="sm" mb={0}>Can host tournaments<Text as="span" display="block" fontSize="xs" color="gray.500">2 a month go live instantly, the 3rd waits for your approval</Text></FormLabel>
                    <Switch colorScheme="cyan" isChecked={settingsForm.canHostTournaments} onChange={e => setSettingsForm({ ...settingsForm, canHostTournaments: e.target.checked })} />
                  </FormControl>
                  <FormControl mb={2}>
                    <FormLabel color="gray.300" fontSize="sm">Voice / video on their tournaments</FormLabel>
                    <Select value={settingsForm.mediaAllowed} onChange={e => setSettingsForm({ ...settingsForm, mediaAllowed: e.target.value as any })} bg={POKER_COLORS.darkBg} borderColor={POKER_COLORS.gold} color="white" size="sm">
                      <option value="none" style={{background: '#0D1B2A'}}>Not allowed</option>
                      <option value="voice" style={{background: '#0D1B2A'}}>Voice only</option>
                      <option value="video" style={{background: '#0D1B2A'}}>Voice and video</option>
                    </Select>
                  </FormControl>
                  <FormControl display="flex" alignItems="center" justifyContent="space-between">
                    <FormLabel color="gray.300" fontSize="sm" mb={0}>PSS covers voice/video on their tournaments<Text as="span" display="block" fontSize="xs" color="gray.500">Off: players use their weekly free minutes or a pass</Text></FormLabel>
                    <Switch colorScheme="cyan" isChecked={settingsForm.mediaComped} onChange={e => setSettingsForm({ ...settingsForm, mediaComped: e.target.checked })} />
                  </FormControl>
                </Box>
                <FormControl display="flex" alignItems="center" justifyContent="space-between">
                  <FormLabel color="gray.300" mb={0}>Active</FormLabel>
                  <Switch isChecked={settingsForm.active} onChange={e => setSettingsForm({ ...settingsForm, active: e.target.checked })} colorScheme="green" />
                </FormControl>
              </VStack>
            </ModalBody>
            <ModalFooter gap={3}>
              <PokerButton variant="secondary" onClick={() => setSettingsAgent(null)}>Cancel</PokerButton>
              <PokerButton variant="primary" onClick={handleSaveAgentSettings} isLoading={savingAgentSettings}>Save</PokerButton>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Send Coins Modal (self-contained; see components/admin/AdminSendCoinsModal) */}
        <AdminSendCoinsModal
          isOpen={isSendOpen}
          onClose={onSendClose}
          users={users}
          preset={sendCoinsPreset}
          onDone={loadDashboardData}
        />

        {/*  NEW: Redemption Review Modal */}

        <Modal isOpen={isRedemptionOpen} onClose={onRedemptionClose} size="md">
          <ModalOverlay bg="blackAlpha.700" />
          <ModalContent bg={POKER_COLORS.darkTeal} borderColor={redemptionAction === 'approve' ? 'green.500' : 'red.500'} border="2px">
            <ModalHeader color={redemptionAction === 'approve' ? 'green.400' : 'red.400'}>
              <HStack>
                {redemptionAction === 'approve' ? <CheckCircle size={24} /> : <XCircle size={24} />}
                <Text>{redemptionAction === 'approve' ? 'Approve' : 'Reject'} Redemption</Text>
              </HStack>
            </ModalHeader>
            <ModalCloseButton color="gray.400" />
            <ModalBody>
              {selectedRedemption && (
                <VStack spacing={4} align="stretch">
                  <Box p={4} bg={POKER_COLORS.darkBg} borderRadius="md">
                    <SimpleGrid columns={2} spacing={2}>
                      <Text color="gray.500">User:</Text>
                      <Text color="white">{selectedRedemption.username}</Text>
                      <Text color="gray.500">Amount:</Text>
                      <Text color={POKER_COLORS.gold} fontWeight="bold">${selectedRedemption.amount.toFixed(2)}</Text>
                      <Text color="gray.500">KYC Status:</Text>
                      <Badge colorScheme="green">
                         Verified

                      </Badge>
                      <Text color="gray.500">Playthrough:</Text>
                      <Badge colorScheme="green">
                         Validated

                      </Badge>
                    </SimpleGrid>
                  </Box>

                  <FormControl>
                    <FormLabel color="gray.300">Review Note (optional)</FormLabel>
                    <Textarea
                      placeholder={redemptionAction === 'approve' ? 'Approved - verified user' : 'Reason for rejection...'}
                      value={redemptionNote}
                      onChange={e => setRedemptionNote(e.target.value)}
                      bg={POKER_COLORS.darkBg}
                      borderColor={redemptionAction === 'approve' ? 'green.500' : 'red.500'}
                      color="white"
                    />
                  </FormControl>

                  {redemptionAction === 'reject' && (
                    <Box p={3} bg="red.900" borderRadius="md">
                      <Text color="red.300" fontSize="sm">
                         Rejecting will return ${selectedRedemption.amount.toFixed(2)} to the user's wallet.

                      </Text>
                    </Box>
                  )}

                  {redemptionAction === 'approve' && (
                    <Box p={3} bg="green.900" borderRadius="md">
                      <Text color="green.200" fontSize="sm" fontWeight="bold" mb={1}>
                        Pay by {selectedRedemption.payoutMethod === 'usdc' ? 'USDC' : 'PayPal'}
                      </Text>
                      <Text color="green.300" fontSize="sm" fontFamily={selectedRedemption.payoutMethod === 'usdc' ? 'mono' : undefined} wordBreak="break-all">
                        {selectedRedemption.payoutDestination?.value || 'No destination on file'}
                        {selectedRedemption.payoutDestination?.network ? ` (${selectedRedemption.payoutDestination.network})` : ''}
                      </Text>
                      {selectedRedemption.kycName && <Text color="green.400" fontSize="xs" mt={1}>ID name: {selectedRedemption.kycName}</Text>}
                      {selectedRedemption.payoutError && <Text color="orange.300" fontSize="xs" mt={1}>Last attempt: {selectedRedemption.payoutError}</Text>}
                      {selectedRedemption.payoutMethod === 'usdc' ? (
                        usdcAwaitingCode ? (
                          <FormControl mt={3}>
                            <FormLabel color="gray.300" fontSize="sm">Verification code from the NOWPayments email</FormLabel>
                            <Input value={usdcCode} onChange={e => setUsdcCode(e.target.value)} placeholder="6-digit code" bg={POKER_COLORS.darkBg} borderColor="green.500" color="white" />
                          </FormControl>
                        ) : (
                          <Text color="green.400" fontSize="xs" mt={2}>Sending creates the withdrawal at NOWPayments and emails you a code. You enter it here to release it. It completes automatically when the network confirms.</Text>
                        )
                      ) : (
                        <FormControl mt={3}>
                          <FormLabel color="gray.300" fontSize="sm">Send it from PayPal first, then paste the transaction id</FormLabel>
                          <Input value={payoutReference} onChange={e => setPayoutReference(e.target.value)} placeholder="PayPal transaction id" bg={POKER_COLORS.darkBg} borderColor="green.500" color="white" />
                        </FormControl>
                      )}
                    </Box>
                  )}
                </VStack>
              )}
            </ModalBody>
            <ModalFooter gap={3}>
              <PokerButton variant="secondary" onClick={onRedemptionClose}>Cancel</PokerButton>
              <PokerButton
                variant="primary"
                onClick={handleProcessRedemption}
                isLoading={processingRedemption}
                isDisabled={redemptionAction === 'approve' && !!selectedRedemption && (
                  selectedRedemption.payoutMethod === 'usdc'
                    ? (usdcAwaitingCode && !usdcCode.trim())
                    : !payoutReference.trim()
                )}
                bg={redemptionAction === 'approve' ? 'green.500' : 'red.500'}
                _hover={{ opacity: 0.9 }}
                leftIcon={redemptionAction === 'approve' ? <CheckCircle size={18} /> : <XCircle size={18} />}
              >
                {redemptionAction === 'approve'
                  ? (selectedRedemption?.payoutMethod === 'usdc' ? (usdcAwaitingCode ? 'Verify & release USDC' : 'Approve & send USDC') : 'Approve & mark paid')
                  : 'Reject Redemption'}
              </PokerButton>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/*  NEW: Create Bypass Code Modal */}

        <Modal isOpen={isBypassCodeOpen} onClose={onBypassCodeClose} size="md">
          <ModalOverlay bg="blackAlpha.700" />
          <ModalContent bg={POKER_COLORS.darkTeal} borderColor={POKER_COLORS.cyan} border="2px">
            <ModalHeader color={POKER_COLORS.cyan}>
              <HStack>
                <Key size={24} />
                <Text>Create Bypass Code</Text>
              </HStack>
            </ModalHeader>
            <ModalCloseButton color={POKER_COLORS.cyan} />
            <ModalBody>
              <VStack spacing={4}>
                <Box p={4} bg={`${POKER_COLORS.cyan}11`} borderRadius="md" w="100%">
                  <Text color="gray.300" fontSize="sm">
                    This will create a new bypass code that can be shared with users to waive the $0.50 voice/video chat fee.
                    Codes are unique and can be deactivated at any time.
                  </Text>
                </Box>
                <FormControl>
                  <FormLabel color="gray.300">Description (optional)</FormLabel>
                  <Textarea 
                    placeholder="e.g., VIP player promo, Streamer code..."
                    value={bypassCodeDescription}
                    onChange={(e) => setBypassCodeDescription(e.target.value)}
                    bg={POKER_COLORS.darkBg}
                    borderColor={POKER_COLORS.cyan}
                    color="white"
                    rows={2}
                  />
                </FormControl>
                <Box p={3} bg="blackAlpha.400" borderRadius="md" w="100%">
                  <Text color="gray.500" fontSize="xs">
                     The code will be auto-generated as a unique 8-character alphanumeric string

                  </Text>
                </Box>
              </VStack>
            </ModalBody>
            <ModalFooter gap={3}>
              <PokerButton variant="secondary" onClick={onBypassCodeClose}>Cancel</PokerButton>
              <PokerButton 
                variant="primary" 
                onClick={handleCreateBypassCode}
                isLoading={creatingBypassCode}
                loadingText="Creating..."
                leftIcon={<Plus size={18} />}
              >
                Create Code
              </PokerButton>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Reset All Data Confirmation Dialog */}
        <AlertDialog
          isOpen={showResetDialog}
          leastDestructiveRef={cancelResetRef}
          onClose={() => !isResetting && setShowResetDialog(false)}
          isCentered
        >
          <AlertDialogOverlay bg="blackAlpha.800">
            <AlertDialogContent bg="gray.900" borderColor="red.500" border="2px">
              <AlertDialogHeader fontSize="lg" fontWeight="bold" color="red.400">
                <HStack>
                  <AlertTriangle size={24} />
                  <Text> DANGER: Reset All Data</Text>

                </HStack>
              </AlertDialogHeader>

              <AlertDialogBody>
                <VStack spacing={4} align="stretch">
                  <Text color="gray.300">
                    This will permanently delete:
                  </Text>
                  <Box bg="blackAlpha.400" p={3} borderRadius="md">
                    <VStack align="stretch" spacing={1}>
                      <Text color="red.300" fontSize="sm">• All user wallet balances</Text>
                      <Text color="red.300" fontSize="sm">• All transaction history</Text>
                      <Text color="red.300" fontSize="sm">• All poker tables</Text>
                      <Text color="red.300" fontSize="sm">• All rake history (cash game + tournament)</Text>
                      <Text color="red.300" fontSize="sm">• All referral earnings</Text>
                      <Text color="red.300" fontSize="sm">• All tournaments</Text>
                    </VStack>
                  </Box>
                  <Text color="yellow.300" fontWeight="bold">
                    Users will keep their accounts and start with 1,000 PlayCoins.
                  </Text>
                  
                  <FormControl>
                    <FormLabel color="gray.400" fontSize="sm">
                      Type <Text as="span" color="red.400" fontWeight="bold">RESET ALL DATA</Text> to confirm:
                    </FormLabel>
                    <Input
                      value={resetConfirmText}
                      onChange={(e) => setResetConfirmText(e.target.value)}
                      placeholder="RESET ALL DATA"
                      bg="blackAlpha.400"
                      borderColor="red.600"
                      color="white"
                      _focus={{ borderColor: 'red.400' }}
                      isDisabled={isResetting}
                    />
                  </FormControl>

                  {isResetting && (
                    <HStack justify="center" py={2}>
                      <Spinner color="red.400" size="sm" />
                      <Text color="red.300" fontSize="sm">{resetProgress}</Text>
                    </HStack>
                  )}
                </VStack>
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button 
                  ref={cancelResetRef} 
                  onClick={() => setShowResetDialog(false)}
                  isDisabled={isResetting}
                >
                  Cancel
                </Button>
                <Button 
                  colorScheme="red" 
                  onClick={handleResetAllData} 
                  ml={3}
                  isLoading={isResetting}
                  loadingText="Resetting..."
                  isDisabled={resetConfirmText !== 'RESET ALL DATA'}
                >
                  Reset Everything
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>

        {/*  NEW: Assign User to Agent Modal */}

        <Modal isOpen={isAssignUserOpen} onClose={onAssignUserClose} size="lg">
          <ModalOverlay bg="blackAlpha.700" />
          <ModalContent bg={POKER_COLORS.darkTeal} borderColor={POKER_COLORS.cyan} border="2px">
            <ModalHeader color={POKER_COLORS.cyan}>
              <HStack>
                <UserPlus size={24} />
                <Text>Assign Users to Agent</Text>
              </HStack>
            </ModalHeader>
            <ModalCloseButton color={POKER_COLORS.cyan} />
            <ModalBody>
              <VStack spacing={4}>
                {assignTargetAgent && (
                  <Box p={3} bg={`${POKER_COLORS.gold}22`} borderRadius="md" border="1px solid" borderColor={POKER_COLORS.gold} w="100%">
                    <Text color="gray.400" fontSize="sm">Assigning to Agent:</Text>
                    <Text color={POKER_COLORS.gold} fontWeight="bold" fontSize="lg">
                      {assignTargetAgent.displayName}
                    </Text>
                    <Text color="gray.500" fontSize="xs">{assignTargetAgent.email}</Text>
                    <Badge mt={1} colorScheme={assignTargetAgent.tier === 'vip' ? 'yellow' : assignTargetAgent.tier === 'premium' ? 'purple' : 'blue'}>
                      {assignTargetAgent.tier} ({assignTargetAgent.tier === 'vip' ? '20%' : assignTargetAgent.tier === 'premium' ? '15%' : '10%'} rake)
                    </Badge>
                  </Box>
                )}

                {/* Filter Toggle */}
                <HStack w="100%" justify="space-between" p={2} bg="blackAlpha.300" borderRadius="md">
                  <Text color="gray.300" fontSize="sm">Show only unassigned users</Text>
                  <Switch 
                    isChecked={showOnlyUnassigned}
                    onChange={(e) => setShowOnlyUnassigned(e.target.checked)}
                    colorScheme="cyan"
                  />
                </HStack>

                <FormControl>
                  <FormLabel color="gray.300">Search Users</FormLabel>
                  <InputGroup>
                    <InputLeftElement><Search size={16} color="#718096" /></InputLeftElement>
                    <Input 
                      placeholder="Filter by username or email..." 
                      value={assignUserSearch}
                      onChange={e => setAssignUserSearch(e.target.value)}
                      bg={POKER_COLORS.darkBg} 
                      borderColor={POKER_COLORS.cyan} 
                      color="white" 
                    />
                  </InputGroup>
                </FormControl>

                {/* User List - Always visible */}
                <Box w="100%">
                  <HStack justify="space-between" mb={2}>
                    <Text color="gray.400" fontSize="sm">
                      {assignFilteredUsers.length} user{assignFilteredUsers.length !== 1 ? 's' : ''} available
                    </Text>
                    {assignUserSearch && (
                      <Button size="xs" variant="ghost" colorScheme="cyan" onClick={() => setAssignUserSearch('')}>
                        Clear Filter
                      </Button>
                    )}
                  </HStack>
                  <Box bg={POKER_COLORS.darkBg} borderRadius="md" maxH="250px" overflow="auto" border="1px solid" borderColor="gray.700">
                    {assignFilteredUsers.length === 0 ? (
                      <Box p={4} textAlign="center">
                        <Text color="gray.500">
                          {showOnlyUnassigned ? 'No unassigned users found' : 'No users found'}
                        </Text>
                      </Box>
                    ) : (
                      assignFilteredUsers.map(user => (
                        <Box
                          key={user.id}
                          p={3}
                          cursor="pointer"
                          _hover={{ bg: `${POKER_COLORS.cyan}22` }}
                          onClick={() => handleSelectAssignUser(user)}
                          borderBottom="1px solid"
                          borderColor="gray.800"
                        >
                          <HStack justify="space-between">
                            <VStack align="start" spacing={0}>
                              <Text color="white" fontWeight="bold">{user.username}</Text>
                              <Text color="gray.500" fontSize="xs">{user.email}</Text>
                            </VStack>
                            <VStack align="end" spacing={0}>
                              {user.referrerId ? (
                                <Badge colorScheme="orange" fontSize="xs">Has Referrer</Badge>
                              ) : (
                                <Badge colorScheme="green" fontSize="xs">Unassigned</Badge>
                              )}
                            </VStack>
                          </HStack>
                        </Box>
                      ))
                    )}
                  </Box>
                </Box>

                {/* Selected Users */}
                {selectedAssignUsers.length > 0 && (
                  <Box w="100%" p={3} bg={`${POKER_COLORS.cyan}11`} borderRadius="md" border="1px solid" borderColor={POKER_COLORS.cyan}>
                    <Text color={POKER_COLORS.cyan} fontWeight="bold" mb={2}>
                      Selected Users ({selectedAssignUsers.length}):
                    </Text>
                    <Box display="flex" flexWrap="wrap" gap={2}>
                      {selectedAssignUsers.map(user => (
                        <Badge 
                          key={user.id} 
                          colorScheme="cyan" 
                          px={3} 
                          py={1} 
                          borderRadius="full"
                          display="flex"
                          alignItems="center"
                          gap={2}
                        >
                          {user.username}
                          <Box 
                            as="span" 
                            cursor="pointer" 
                            onClick={() => handleRemoveAssignUser(user.id)}
                            _hover={{ color: 'red.300' }}
                          >
                            

                          </Box>
                        </Badge>
                      ))}
                    </Box>
                  </Box>
                )}

                <Box p={3} bg="blackAlpha.400" borderRadius="md" w="100%">
                  <Text color="gray.400" fontSize="sm">
                     Selected users will be assigned under this agent's referral tree. 

                    The agent will earn rake commission on their play.
                  </Text>
                </Box>
              </VStack>
            </ModalBody>
            <ModalFooter gap={3}>
              <PokerButton variant="secondary" onClick={onAssignUserClose}>Cancel</PokerButton>
              <PokerButton 
                variant="primary" 
                onClick={handleAssignUserToAgent}
                isLoading={assigningUser}
                isDisabled={selectedAssignUsers.length === 0}
                leftIcon={<UserPlus size={18} />}
              >
                Assign {selectedAssignUsers.length > 0 ? `${selectedAssignUsers.length} User${selectedAssignUsers.length > 1 ? 's' : ''}` : 'Users'}
              </PokerButton>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/*  NEW: User Audit Modal */}

        <Modal isOpen={isUserAuditOpen} onClose={onUserAuditClose} size="4xl" scrollBehavior="inside">
          <ModalOverlay bg="blackAlpha.800" />
          <ModalContent bg={POKER_COLORS.darkBg} borderColor={POKER_COLORS.cyan} border="2px" maxH="90vh">
            <ModalHeader color={POKER_COLORS.cyan} borderBottom="1px solid" borderColor="gray.700">
              <HStack>
                <User size={24} />
                <Text>User Audit: {userAuditData?.username || 'Loading...'}</Text>
              </HStack>
            </ModalHeader>
            <ModalCloseButton color={POKER_COLORS.cyan} />
            <ModalBody py={4}>
              {loadingUserAudit ? (
                <VStack py={12}>
                  <Spinner size="xl" color={POKER_COLORS.cyan} />
                  <Text color="gray.400">Loading user data...</Text>
                </VStack>
              ) : userAuditData ? (
                <VStack spacing={6} align="stretch">
                  {/* User Profile Summary */}
                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                    <PokerCard>
                      <VStack align="start" spacing={3}>
                        <Text color="gray.500" fontSize="sm" fontWeight="bold">PROFILE</Text>
                        <Divider borderColor="gray.700" />
                        <HStack justify="space-between" w="100%">
                          <Text color="gray.400">Username:</Text>
                          <Text color="white" fontWeight="bold">{userAuditData.username}</Text>
                        </HStack>
                        <HStack justify="space-between" w="100%">
                          <Text color="gray.400">Email:</Text>
                          <Text color="white">{userAuditData.email}</Text>
                        </HStack>
                        <HStack justify="space-between" w="100%">
                          <Text color="gray.400">User ID:</Text>
                          <HStack>
                            <Text color="gray.500" fontSize="sm">{userAuditData.id.substring(0, 12)}...</Text>
                            <IconButton
                              aria-label="Copy"
                              icon={<Copy size={12} />}
                              size="xs"
                              variant="ghost"
                              onClick={() => {
                                navigator.clipboard.writeText(userAuditData.id);
                                toast({ title: 'Copied!', status: 'info', duration: 1000 });
                              }}
                            />
                          </HStack>
                        </HStack>
                        <HStack justify="space-between" w="100%">
                          <Text color="gray.400">KYC Status:</Text>
                          <Badge colorScheme={userAuditData.kycStatus === 'verified' ? 'green' : userAuditData.kycStatus === 'pending' ? 'yellow' : 'gray'}>
                            {userAuditData.kycStatus || 'None'}
                          </Badge>
                        </HStack>
                        <HStack justify="space-between" w="100%">
                          <Text color="gray.400">Created:</Text>
                          <Text color="gray.300">{userAuditData.createdAt.toLocaleDateString()}</Text>
                        </HStack>
                        {userAuditData.referrerName && (
                          <HStack justify="space-between" w="100%">
                            <Text color="gray.400">Referred By:</Text>
                            <Text color="orange.400">{userAuditData.referrerName}</Text>
                          </HStack>
                        )}
                        {userAuditData.isAgent && (
                          <HStack justify="space-between" w="100%">
                            <Text color="gray.400">Agent:</Text>
                            <Badge colorScheme="yellow">{userAuditData.agentTier || 'Standard'}</Badge>
                          </HStack>
                        )}
                      </VStack>
                    </PokerCard>

                    <PokerCard>
                      <VStack align="start" spacing={3}>
                        <Text color="gray.500" fontSize="sm" fontWeight="bold">WALLET & STATS</Text>
                        <Divider borderColor="gray.700" />
                        <HStack justify="space-between" w="100%">
                          <Text color="gray.400">PlayCoins:</Text>
                          <Text color={POKER_COLORS.cyan} fontWeight="bold" fontSize="lg">
                             {userAuditData.playCoins.toLocaleString()}

                          </Text>
                        </HStack>
                        <HStack justify="space-between" w="100%">
                          <Text color="gray.400">PKCash:</Text>
                          <Text color={POKER_COLORS.gold} fontWeight="bold" fontSize="lg">
                             ${userAuditData.pkCash.toFixed(2)}

                          </Text>
                        </HStack>
                        <Divider borderColor="gray.700" />
                        <HStack justify="space-between" w="100%">
                          <Text color="gray.400">Total Deposited:</Text>
                          <Text color="green.400">${userAuditData.totalDeposited.toFixed(2)}</Text>
                        </HStack>
                        <HStack justify="space-between" w="100%">
                          <Text color="gray.400">Total Withdrawn:</Text>
                          <Text color="red.400">${userAuditData.totalWithdrawn.toFixed(2)}</Text>
                        </HStack>
                        <HStack justify="space-between" w="100%">
                          <Text color="gray.400">Net:</Text>
                          <Text color={(userAuditData.totalDeposited - userAuditData.totalWithdrawn) >= 0 ? 'green.400' : 'red.400'} fontWeight="bold">
                            ${(userAuditData.totalDeposited - userAuditData.totalWithdrawn).toFixed(2)}
                          </Text>
                        </HStack>
                        <Divider borderColor="gray.700" />
                        <HStack justify="space-between" w="100%">
                          <Text color="gray.400">Games Played:</Text>
                          <Text color="white">{userAuditData.gamesPlayed}</Text>
                        </HStack>
                        <HStack justify="space-between" w="100%">
                          <Text color="gray.400">Hands Won:</Text>
                          <Text color="white">{userAuditData.handsWon}</Text>
                        </HStack>
                      </VStack>
                    </PokerCard>
                  </SimpleGrid>

                  {/* User Transactions */}
                  <PokerCard>
                    <VStack align="stretch" spacing={3}>
                      <HStack justify="space-between">
                        <Text color="gray.500" fontSize="sm" fontWeight="bold">
                          TRANSACTION HISTORY ({userAuditTransactions.length})
                        </Text>
                        <Badge colorScheme="cyan">{userAuditTransactions.length} transactions</Badge>
                      </HStack>
                      <Divider borderColor="gray.700" />
                      <Box maxH="300px" overflowY="auto">
                        <Table size="sm">
                          <Thead position="sticky" top={0} bg={POKER_COLORS.darkBg}>
                            <Tr>
                              <Th color="gray.500">Date</Th>
                              <Th color="gray.500">Type</Th>
                              <Th color="gray.500" isNumeric>Amount</Th>
                              <Th color="gray.500">Currency</Th>
                              <Th color="gray.500">Status</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {userAuditTransactions.slice(0, 100).map(tx => (
                              <Tr key={tx.id}>
                                <Td color="gray.400" fontSize="xs">{tx.createdAt.toLocaleString()}</Td>
                                <Td>
                                  <Badge 
                                    colorScheme={
                                      tx.type.includes('win') || tx.type.includes('bonus') || tx.type.includes('prize') ? 'green' :
                                      tx.type.includes('loss') || tx.type.includes('buy_in') ? 'red' :
                                      tx.type.includes('deposit') || tx.type.includes('purchase') ? 'teal' :
                                      tx.type.includes('withdrawal') ? 'orange' :
                                      'gray'
                                    }
                                    fontSize="xs"
                                  >
                                    {tx.type.replace(/_/g, ' ')}
                                  </Badge>
                                </Td>
                                <Td isNumeric color={tx.amount >= 0 ? 'green.400' : 'red.400'} fontWeight="medium">
                                  {tx.amount >= 0 ? '+' : ''}{tx.amount.toFixed(2)}
                                </Td>
                                <Td>
                                  <Badge colorScheme={tx.currency === 'pkcash' ? 'yellow' : 'cyan'} variant="outline" fontSize="xs">
                                    {tx.currency}
                                  </Badge>
                                </Td>
                                <Td>
                                  <Badge colorScheme={tx.status === 'completed' ? 'green' : 'yellow'} fontSize="xs">
                                    {tx.status}
                                  </Badge>
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        </Table>
                        {userAuditTransactions.length > 100 && (
                          <Text color="gray.500" fontSize="xs" textAlign="center" py={2}>
                            Showing first 100 of {userAuditTransactions.length} transactions
                          </Text>
                        )}
                      </Box>
                    </VStack>
                  </PokerCard>
                </VStack>
              ) : (
                <Text color="gray.500" textAlign="center" py={8}>No user data available</Text>
              )}
            </ModalBody>
            <ModalFooter borderTop="1px solid" borderColor="gray.700">
              <HStack spacing={3}>
                <PokerButton variant="secondary" onClick={onUserAuditClose}>Close</PokerButton>
                {userAuditData && (
                  <PokerButton 
                    variant="primary"
                    leftIcon={<Send size={14} />}
                    onClick={() => {
                      setSendCoinsPreset({ id: userAuditData.id, username: userAuditData.username });
                      onUserAuditClose();
                      onSendOpen();
                    }}
                  >
                    Send Coins
                  </PokerButton>
                )}
              </HStack>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* ===== USER MANAGEMENT MODAL ===== */}
        <Modal isOpen={isUserManageOpen} onClose={onUserManageClose} size="lg">
          <ModalOverlay bg="blackAlpha.700" />
          <ModalContent bg={POKER_COLORS.darkTeal} borderColor="red.500" border="2px">
            <ModalHeader color="red.400">
              <HStack>
                <Shield size={24} />
                <Text>Manage User: {selectedUserForManage?.username}</Text>
              </HStack>
            </ModalHeader>
            <ModalCloseButton color="gray.400" />
            <ModalBody>
              {selectedUserForManage && (
                <VStack spacing={4} align="stretch">
                  {/* User Info */}
                  <Box p={4} bg="blackAlpha.400" borderRadius="lg">
                    <SimpleGrid columns={2} spacing={2} fontSize="sm">
                      <Text color="gray.400">Email:</Text>
                      <Text color="white">{selectedUserForManage.email}</Text>
                      <Text color="gray.400">PlayCoins:</Text>
                      <Text color={POKER_COLORS.cyan}>{selectedUserForManage.playCoins.toLocaleString()}</Text>
                      <Text color="gray.400">PKCash:</Text>
                      <Text color={POKER_COLORS.gold}>${selectedUserForManage.pkCash.toFixed(2)}</Text>
                      <Text color="gray.400">Joined:</Text>
                      <Text color="white">{selectedUserForManage.createdAt.toLocaleDateString()}</Text>
                    </SimpleGrid>
                  </Box>

                  {/*  NEW: Geo Bypass Toggle */}

                  <Box p={4} bg="purple.900" borderRadius="lg" border="1px solid" borderColor="purple.500">
                    <HStack justify="space-between">
                      <VStack align="start" spacing={1}>
                        <HStack>
                          <MapPin size={18} color="#9F7AEA" />
                          <Text color="purple.200" fontWeight="bold">Geo Restriction Bypass</Text>
                        </HStack>
                        <Text fontSize="sm" color="gray.400">
                          Allow this user to access all features regardless of location.
                        </Text>
                      </VStack>
                      <Switch
                        isChecked={userGeoBypass}
                        onChange={handleToggleGeoBypass}
                        colorScheme="purple"
                        size="lg"
                      />
                    </HStack>
                    {userGeoBypass && (
                      <Badge colorScheme="purple" mt={2}>
                         Bypass active - Full PKCash access from any location

                      </Badge>
                    )}
                  </Box>

                  {/* Action Selection */}
                  {!userManageAction && (
                    <VStack spacing={3}>
                      <Text color="gray.300" fontWeight="bold">Choose Action:</Text>
                      <HStack spacing={3} w="100%">
                        <PokerButton
                          flex={1}
                          variant="danger"
                          onClick={() => setUserManageAction('ban')}
                          leftIcon={<XCircle size={18} />}
                          bg="orange.600"
                          _hover={{ bg: 'orange.500' }}
                        >
                          Ban User
                        </PokerButton>
                        <PokerButton
                          flex={1}
                          variant="danger"
                          onClick={() => setUserManageAction('delete')}
                          leftIcon={<Trash2 size={18} />}
                          bg="red.600"
                          _hover={{ bg: 'red.500' }}
                        >
                          Delete Account
                        </PokerButton>
                      </HStack>
                    </VStack>
                  )}

                  {/* Ban Form */}
                  {userManageAction === 'ban' && (
                    <VStack spacing={4} align="stretch">
                      <Box p={4} bg="orange.900" borderRadius="lg" border="1px solid" borderColor="orange.500">
                        <Text color="orange.200" fontWeight="bold" mb={2}> Ban User</Text>

                        <Text color="gray.300" fontSize="sm">
                          This will prevent the user from logging in and disable their Firebase Auth account.
                        </Text>
                      </Box>

                      <FormControl>
                        <FormLabel color="gray.300">Reason for Ban</FormLabel>
                        <Textarea
                          value={banReason}
                          onChange={(e) => setBanReason(e.target.value)}
                          placeholder="Violation of terms of service..."
                          bg={POKER_COLORS.darkBg}
                          borderColor="gray.600"
                          color="white"
                        />
                      </FormControl>

                      <FormControl>
                        <FormLabel color="gray.300">Ban Duration</FormLabel>
                        <Select
                          value={banDuration}
                          onChange={(e) => setBanDuration(parseInt(e.target.value))}
                          bg={POKER_COLORS.darkBg}
                          borderColor="gray.600"
                          color="white"
                        >
                          <option value={0} style={{ background: '#0D1B2A' }}>Permanent</option>
                          <option value={1} style={{ background: '#0D1B2A' }}>1 hour</option>
                          <option value={24} style={{ background: '#0D1B2A' }}>24 hours</option>
                          <option value={168} style={{ background: '#0D1B2A' }}>7 days</option>
                          <option value={720} style={{ background: '#0D1B2A' }}>30 days</option>
                        </Select>
                      </FormControl>

                      <HStack justify="flex-end" spacing={3}>
                        <PokerButton variant="secondary" onClick={() => setUserManageAction(null)}>
                          Back
                        </PokerButton>
                        <PokerButton
                          variant="danger"
                          onClick={handleBanUser}
                          isLoading={processingUserAction}
                          bg="orange.600"
                        >
                          Confirm Ban
                        </PokerButton>
                      </HStack>
                    </VStack>
                  )}

                  {/* Delete Form */}
                  {userManageAction === 'delete' && (
                    <VStack spacing={4} align="stretch">
                      <Box p={4} bg="red.900" borderRadius="lg" border="1px solid" borderColor="red.500">
                        <Text color="red.200" fontWeight="bold" mb={2}> Permanently Delete Account</Text>

                        <Text color="gray.300" fontSize="sm">
                          This will permanently delete all user data including:
                        </Text>
                        <VStack align="start" mt={2} spacing={0} fontSize="sm" color="gray.400">
                          <Text>• User profile and settings</Text>
                          <Text>• Wallet and all balances</Text>
                          <Text>• Transaction history</Text>
                          <Text>• Messages and follows</Text>
                          <Text>• Firebase Auth account</Text>
                        </VStack>
                        <Text color="red.300" fontWeight="bold" mt={3} fontSize="sm">
                          THIS ACTION CANNOT BE UNDONE!
                        </Text>
                      </Box>

                      <FormControl>
                        <FormLabel color="gray.300">Reason (optional)</FormLabel>
                        <Input
                          value={banReason}
                          onChange={(e) => setBanReason(e.target.value)}
                          placeholder="Reason for deletion..."
                          bg={POKER_COLORS.darkBg}
                          borderColor="gray.600"
                          color="white"
                        />
                      </FormControl>

                      <HStack justify="flex-end" spacing={3}>
                        <PokerButton variant="secondary" onClick={() => setUserManageAction(null)}>
                          Back
                        </PokerButton>
                        <PokerButton
                          variant="danger"
                          onClick={handleDeleteUser}
                          isLoading={processingUserAction}
                          bg="red.600"
                        >
                          Permanently Delete
                        </PokerButton>
                      </HStack>
                    </VStack>
                  )}
                </VStack>
              )}
            </ModalBody>
            <ModalFooter />
          </ModalContent>
        </Modal>

        {/* Mass Delete Confirmation Modal */}
        <Modal isOpen={isMassDeleteOpen} onClose={onMassDeleteClose} size="lg">
          <ModalOverlay backdropFilter="blur(4px)" />
          <ModalContent bg={POKER_COLORS.cardBg} border="1px solid" borderColor="red.500">
            <ModalHeader color="red.400">
              <HStack>
                <AlertTriangle size={24} />
                <Text> Mass Delete {selectedUsersForDelete.size} Users</Text>

              </HStack>
            </ModalHeader>
            <ModalCloseButton color="white" />
            <ModalBody>
              <VStack spacing={4} align="stretch">
                <Box bg="red.900" p={4} borderRadius="md" border="1px solid" borderColor="red.500">
                  <Text color="red.200" fontWeight="bold" mb={2}>
                     THIS ACTION CANNOT BE UNDONE!

                  </Text>
                  <Text color="gray.300" fontSize="sm">
                    You are about to permanently delete {selectedUsersForDelete.size} user accounts including:
                  </Text>
                  <VStack align="start" mt={2} spacing={1}>
                    <Text color="gray.400" fontSize="sm">• User profiles and settings</Text>
                    <Text color="gray.400" fontSize="sm">• Wallet and all balances</Text>
                    <Text color="gray.400" fontSize="sm">• Transaction history</Text>
                    <Text color="gray.400" fontSize="sm">• Messages and follows</Text>
                    <Text color="gray.400" fontSize="sm">• Firebase Auth accounts</Text>
                  </VStack>
                </Box>

                <Box>
                  <Text color="gray.400" fontSize="sm" mb={2}>Selected Users:</Text>
                  <Box maxH="150px" overflowY="auto" bg={POKER_COLORS.darkBg} p={2} borderRadius="md">
                    {Array.from(selectedUsersForDelete).slice(0, 20).map(userId => {
                      const user = filteredUsersList.find(u => u.id === userId);
                      return (
                        <Text key={userId} color="gray.300" fontSize="xs">
                          {user?.username || userId} ({user?.email || 'unknown'})
                        </Text>
                      );
                    })}
                    {selectedUsersForDelete.size > 20 && (
                      <Text color="gray.500" fontSize="xs" mt={1}>
                        ... and {selectedUsersForDelete.size - 20} more
                      </Text>
                    )}
                  </Box>
                </Box>

                <FormControl>
                  <FormLabel color="gray.400" fontSize="sm">Reason (optional)</FormLabel>
                  <Input
                    value={massDeleteReason}
                    onChange={(e) => setMassDeleteReason(e.target.value)}
                    placeholder="Reason for deletion..."
                    bg={POKER_COLORS.darkBg}
                    borderColor="gray.600"
                    color="white"
                  />
                </FormControl>
              </VStack>
            </ModalBody>
            <ModalFooter>
              <HStack spacing={3}>
                <Button variant="ghost" onClick={onMassDeleteClose} color="gray.400">
                  Cancel
                </Button>
                <Button
                  colorScheme="red"
                  onClick={handleMassDelete}
                  isLoading={processingMassDelete}
                  loadingText="Deleting..."
                  leftIcon={<Trash2 size={16} />}
                >
                  Permanently Delete {selectedUsersForDelete.size} Users
                </Button>
              </HStack>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/*  Report Detail Modal */}

        <Modal isOpen={isReportDetailOpen} onClose={onReportDetailClose} size="xl">
          <ModalOverlay backdropFilter="blur(4px)" />
          <ModalContent bg={POKER_COLORS.cardBg} border="1px solid" borderColor="gray.700">
            <ModalHeader color="white">
              <HStack>
                <AlertTriangle size={20} color="orange" />
                <Text>Report Details</Text>
              </HStack>
            </ModalHeader>
            <ModalCloseButton color="gray.400" />
            
            {selectedReport && (
              <ModalBody>
                <VStack spacing={4} align="stretch">
                  {/* Reported User */}
                  <Box bg={POKER_COLORS.darkBg} p={4} borderRadius="lg" border="1px solid" borderColor="red.800">
                    <Text color="gray.400" fontSize="xs" mb={2}>REPORTED USER</Text>
                    <HStack>
                      <Box 
                        w="48px" 
                        h="48px" 
                        borderRadius="full" 
                        bg="gray.600" 
                        display="flex" 
                        alignItems="center" 
                        justifyContent="center"
                        overflow="hidden"
                      >
                        {selectedReport.reportedPhotoURL ? (
                          <img src={selectedReport.reportedPhotoURL} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        ) : (
                          <User size={24} color="white" />
                        )}
                      </Box>
                      <VStack align="start" spacing={0}>
                        <Text color="white" fontWeight="bold">{selectedReport.reportedUsername}</Text>
                        <Text color="gray.500" fontSize="xs">ID: {selectedReport.reportedUserId}</Text>
                      </VStack>
                    </HStack>
                  </Box>

                  {/* Report Info */}
                  <SimpleGrid columns={2} spacing={4}>
                    <Box>
                      <Text color="gray.400" fontSize="xs" mb={1}>REASON</Text>
                      <HStack>
                        <Text fontSize="lg">{getReasonIcon(selectedReport.reason)}</Text>
                        <Text color="white">{selectedReport.reasonLabel}</Text>
                      </HStack>
                    </Box>
                    <Box>
                      <Text color="gray.400" fontSize="xs" mb={1}>STATUS</Text>
                      <Badge colorScheme={STATUS_LABELS[selectedReport.status]?.color || 'gray'}>
                        {STATUS_LABELS[selectedReport.status]?.label || selectedReport.status}
                      </Badge>
                      {selectedReport.action && selectedReport.action !== 'none' && (
                        <Box mt={1}>
                          <Badge colorScheme={ACTION_LABELS[selectedReport.action]?.color || 'gray'}>
                            {ACTION_LABELS[selectedReport.action]?.label || selectedReport.action}
                          </Badge>
                        </Box>
                      )}
                    </Box>
                  </SimpleGrid>

                  {/* Details */}
                  {selectedReport.details && (
                    <Box>
                      <Text color="gray.400" fontSize="xs" mb={1}>ADDITIONAL DETAILS</Text>
                      <Box bg={POKER_COLORS.darkBg} p={3} borderRadius="md">
                        <Text color="gray.300" fontSize="sm">{selectedReport.details}</Text>
                      </Box>
                    </Box>
                  )}

                  {(selectedReport as any).evidenceUrls?.length > 0 && (
                    <Box>
                      <Text color="gray.400" fontSize="xs" mb={1}>EVIDENCE (click to open full size)</Text>
                      <HStack spacing={2} flexWrap="wrap">
                        {((selectedReport as any).evidenceUrls as string[]).map((url, i) => (
                          <a key={i} href={url} target="_blank" rel="noopener noreferrer">
                            <img src={url} alt={`Evidence ${i + 1}`} style={{ width: 140, height: 100, objectFit: 'cover', borderRadius: 8, border: '1px solid #334155' }} />
                          </a>
                        ))}
                      </HStack>
                    </Box>
                  )}

                  {/* Reporter Info */}
                  <Box>
                    <Text color="gray.400" fontSize="xs" mb={1}>REPORTED BY</Text>
                    <HStack>
                      <User size={16} color="gray" />
                      <Text color="gray.300">{selectedReport.reporterUsername}</Text>
                      <Text color="gray.500" fontSize="xs">
                        on {selectedReport.createdAt?.toDate?.().toLocaleDateString() || 'Unknown'}
                      </Text>
                    </HStack>
                  </Box>

                  {/* Previous Review Info */}
                  {selectedReport.reviewedBy && (
                    <Box bg="blue.900" p={3} borderRadius="md" border="1px solid" borderColor="blue.700">
                      <Text color="blue.200" fontSize="xs" mb={1}>REVIEWED BY</Text>
                      <Text color="white">{selectedReport.reviewedByUsername || selectedReport.reviewedBy}</Text>
                      <Text color="gray.400" fontSize="xs">
                        {selectedReport.reviewedAt?.toDate?.().toLocaleDateString() || ''}
                      </Text>
                      {selectedReport.actionDetails && (
                        <Text color="gray.300" fontSize="sm" mt={2}>{selectedReport.actionDetails}</Text>
                      )}
                    </Box>
                  )}

                  <Divider borderColor="gray.700" />

                  {/* Action Form - Only show for pending/under_review */}
                  {(selectedReport.status === 'pending' || selectedReport.status === 'under_review') && (
                    <VStack spacing={4} align="stretch">
                      <Text color="white" fontWeight="bold">Take Action</Text>
                      
                      <Select
                        value={selectedReportAction}
                        onChange={(e) => setSelectedReportAction(e.target.value as ReportAction)}
                        bg={POKER_COLORS.darkBg}
                        borderColor="gray.600"
                        color="white"
                      >
                        <option value="none" style={{ background: POKER_COLORS.darkBg }}>Dismiss - No Action Needed</option>
                        <option value="warning_issued" style={{ background: POKER_COLORS.darkBg }}> Issue Warning</option>

                        <option value="temporary_ban" style={{ background: POKER_COLORS.darkBg }}> Temporary Ban</option>

                        <option value="permanent_ban" style={{ background: POKER_COLORS.darkBg }}> Permanent Ban</option>

                      </Select>

                      {/* Temp Ban Duration Selector */}
                      {selectedReportAction === 'temporary_ban' && (
                        <Box>
                          <Text color="gray.400" fontSize="sm" mb={2}>Ban Duration</Text>
                          <Select
                            value={tempBanDuration}
                            onChange={(e) => setTempBanDuration(Number(e.target.value))}
                            bg={POKER_COLORS.darkBg}
                            borderColor="gray.600"
                            color="white"
                          >
                            <option value={1} style={{ background: POKER_COLORS.darkBg }}>1 hour</option>
                            <option value={6} style={{ background: POKER_COLORS.darkBg }}>6 hours</option>
                            <option value={12} style={{ background: POKER_COLORS.darkBg }}>12 hours</option>
                            <option value={24} style={{ background: POKER_COLORS.darkBg }}>24 hours (1 day)</option>
                            <option value={48} style={{ background: POKER_COLORS.darkBg }}>48 hours (2 days)</option>
                            <option value={72} style={{ background: POKER_COLORS.darkBg }}>72 hours (3 days)</option>
                            <option value={168} style={{ background: POKER_COLORS.darkBg }}>7 days</option>
                            <option value={336} style={{ background: POKER_COLORS.darkBg }}>14 days</option>
                            <option value={720} style={{ background: POKER_COLORS.darkBg }}>30 days</option>
                          </Select>
                        </Box>
                      )}

                      <Textarea
                        placeholder="Add notes about your decision..."
                        value={reportActionNotes}
                        onChange={(e) => setReportActionNotes(e.target.value)}
                        bg={POKER_COLORS.darkBg}
                        borderColor="gray.600"
                        color="white"
                        _placeholder={{ color: 'gray.500' }}
                      />

                      <HStack spacing={3}>
                        {selectedReport.status === 'pending' && (
                          <PokerButton
                            variant="secondary"
                            onClick={async () => {
                              setReportActionLoading(true);
                              try {
                                await reportService.markReportUnderReview(selectedReport.id);
                                toast({ title: 'Marked as Under Review', status: 'info', duration: 2000 });
                                onReportDetailClose();
                                // Refresh reports
                                const newReports = await reportService.getReports(reportStatusFilter || undefined);
                                setReports(newReports);
                                const newStats = await reportService.getReportStats();
                                setReportStats(newStats);
                              } catch (err: any) {
                                toast({ title: 'Error', description: err.message, status: 'error', duration: 3000 });
                              } finally {
                                setReportActionLoading(false);
                              }
                            }}
                            isLoading={reportActionLoading}
                            leftIcon={<Clock size={16} />}
                          >
                            Mark Under Review
                          </PokerButton>
                        )}
                        <PokerButton
                          variant={selectedReportAction === 'none' ? 'secondary' : 'danger'}
                          bg={selectedReportAction === 'none' ? undefined : 'red.600'}
                          onClick={async () => {
                            setReportActionLoading(true);
                            try {
                              if (selectedReportAction === 'none') {
                                await reportService.takeReportAction(
                                  selectedReport.id,
                                  'dismiss',
                                  reportActionNotes || undefined
                                );
                                toast({ title: 'Report Dismissed', status: 'info', duration: 2000 });
                              } else {
                                // Map internal action names to Cloud Function action names
                                const actionMap: Record<string, 'dismiss' | 'warning' | 'temporary_ban' | 'permanent_ban'> = {
                                  'none': 'dismiss',
                                  'warning_issued': 'warning',
                                  'temporary_ban': 'temporary_ban',
                                  'permanent_ban': 'permanent_ban',
                                };
                                const action = actionMap[selectedReportAction] || 'dismiss';
                                
                                await reportService.takeReportAction(
                                  selectedReport.id,
                                  action,
                                  reportActionNotes || undefined,
                                  action === 'temporary_ban' ? tempBanDuration : undefined
                                );
                                toast({ 
                                  title: 'Action Taken', 
                                  description: ACTION_LABELS[selectedReportAction]?.label,
                                  status: 'success', 
                                  duration: 2000 
                                });
                              }
                              onReportDetailClose();
                              // Refresh reports
                              const newReports = await reportService.getReports(reportStatusFilter || undefined);
                              setReports(newReports);
                              const newStats = await reportService.getReportStats();
                              setReportStats(newStats);
                            } catch (err: any) {
                              toast({ title: 'Error', description: err.message, status: 'error', duration: 3000 });
                            } finally {
                              setReportActionLoading(false);
                            }
                          }}
                          isLoading={reportActionLoading}
                          leftIcon={selectedReportAction === 'none' ? <XCircle size={16} /> : <CheckCircle size={16} />}
                        >
                          {selectedReportAction === 'none' ? 'Dismiss Report' : 'Take Action'}
                        </PokerButton>
                      </HStack>
                    </VStack>
                  )}
                </VStack>
              </ModalBody>
            )}
            
            <ModalFooter borderTop="1px solid" borderColor="gray.700">
              <HStack spacing={3}>
                <Button
                  variant="ghost"
                  colorScheme="red"
                  size="sm"
                  leftIcon={<Trash2 size={14} />}
                  onClick={async () => {
                    if (!selectedReport) return;
                    if (window.confirm('Are you sure you want to delete this report?')) {
                      try {
                        await reportService.deleteReport(selectedReport.id);
                        toast({ title: 'Report Deleted', status: 'success', duration: 2000 });
                        onReportDetailClose();
                        const newReports = await reportService.getReports(reportStatusFilter || undefined);
                        setReports(newReports);
                        const newStats = await reportService.getReportStats();
                        setReportStats(newStats);
                      } catch (err: any) {
                        toast({ title: 'Error', description: err.message, status: 'error', duration: 3000 });
                      }
                    }
                  }}
                >
                  Delete Report
                </Button>
                <Button variant="ghost" onClick={onReportDetailClose}>
                  Close
                </Button>
              </HStack>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/*  Appeal Detail Modal */}

        <Modal isOpen={isAppealDetailOpen} onClose={onAppealDetailClose} size="xl">
          <ModalOverlay backdropFilter="blur(4px)" />
          <ModalContent bg={POKER_COLORS.cardBg} borderColor="orange.700" borderWidth={1}>
            <ModalHeader borderBottom="1px solid" borderColor="gray.700">
              <HStack>
                <MessageCircle size={20} color="#ED8936" />
                <Text color="white">Ban Appeal Details</Text>
              </HStack>
            </ModalHeader>
            <ModalCloseButton color="gray.400" />
            
            {selectedAppeal && (
              <ModalBody py={6}>
                <VStack spacing={4} align="stretch">
                  {/* User Info */}
                  <Box bg={POKER_COLORS.darkBg} p={4} borderRadius="md">
                    <Text color="gray.400" fontSize="xs" mb={2}>APPELLANT</Text>
                    <HStack>
                      <Box
                        w={12}
                        h={12}
                        borderRadius="full"
                        bg="gray.600"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <User size={24} color="white" />
                      </Box>
                      <VStack align="start" spacing={0}>
                        <Text color="white" fontWeight="bold" fontSize="lg">{selectedAppeal.username}</Text>
                        <Text color="gray.400" fontSize="sm">{selectedAppeal.email}</Text>
                        <Text color="gray.500" fontSize="xs">ID: {selectedAppeal.userId}</Text>
                      </VStack>
                    </HStack>
                  </Box>

                  {/* Ban Info */}
                  <SimpleGrid columns={2} spacing={4}>
                    <Box>
                      <Text color="gray.400" fontSize="xs" mb={1}>BAN TYPE</Text>
                      <Badge colorScheme={selectedAppeal.banType === 'permanent' ? 'red' : 'orange'} fontSize="sm">
                        {selectedAppeal.banType}
                      </Badge>
                    </Box>
                    <Box>
                      <Text color="gray.400" fontSize="xs" mb={1}>STATUS</Text>
                      <Badge 
                        colorScheme={
                          selectedAppeal.status === 'pending' ? 'yellow' : 
                          selectedAppeal.status === 'approved' ? 'green' : 'red'
                        } 
                        fontSize="sm"
                      >
                        {selectedAppeal.status}
                      </Badge>
                    </Box>
                  </SimpleGrid>

                  {/* Ban Reason */}
                  <Box>
                    <Text color="gray.400" fontSize="xs" mb={1}>BAN REASON</Text>
                    <Box bg={POKER_COLORS.darkBg} p={3} borderRadius="md">
                      <Text color="gray.300">{selectedAppeal.banReason}</Text>
                    </Box>
                  </Box>

                  {/* Appeal Message */}
                  <Box>
                    <Text color="gray.400" fontSize="xs" mb={1}>APPEAL MESSAGE</Text>
                    <Box bg={POKER_COLORS.darkBg} p={3} borderRadius="md" maxH="200px" overflowY="auto">
                      <Text color="white" whiteSpace="pre-wrap">{selectedAppeal.appealMessage}</Text>
                    </Box>
                  </Box>

                  {/* Submission Date */}
                  <Box>
                    <Text color="gray.400" fontSize="xs" mb={1}>SUBMITTED</Text>
                    <Text color="gray.300">
                      {selectedAppeal.createdAt?.toDate?.().toLocaleString() || 'Unknown'}
                    </Text>
                  </Box>

                  <Divider borderColor="gray.700" />

                  {/* Action Form - Only show for pending appeals */}
                  {selectedAppeal.status === 'pending' && (
                    <VStack spacing={4} align="stretch">
                      <Text color="white" fontWeight="bold">Review Appeal</Text>
                      
                      <Textarea
                        placeholder="Add review notes (optional)..."
                        value={appealReviewNotes}
                        onChange={(e) => setAppealReviewNotes(e.target.value)}
                        bg={POKER_COLORS.darkBg}
                        borderColor="gray.600"
                        color="white"
                        _placeholder={{ color: 'gray.500' }}
                      />

                      <HStack spacing={3}>
                        <PokerButton
                          variant="primary"
                          bg="green.600"
                          _hover={{ bg: 'green.500' }}
                          onClick={async () => {
                            if (!window.confirm(`Approve this appeal and UNBAN ${selectedAppeal.username}?`)) return;
                            setAppealActionLoading(true);
                            try {
                              await reportService.handleAppeal(
                                selectedAppeal.id,
                                'approve',
                                appealReviewNotes || undefined
                              );
                              toast({ 
                                title: 'Appeal Approved', 
                                description: `${selectedAppeal.username} has been unbanned`,
                                status: 'success', 
                                duration: 3000 
                              });
                              onAppealDetailClose();
                              // Refresh appeals and stats
                              const newAppeals = await reportService.getBanAppeals(appealStatusFilter || undefined);
                              setAppeals(newAppeals);
                              const newStats = await reportService.getReportStats();
                              setReportStats(newStats);
                              // Refresh banned users if on that tab
                              const newBanned = await reportService.getBannedUsers();
                              setBannedUsers(newBanned);
                            } catch (err: any) {
                              toast({ title: 'Error', description: err.message, status: 'error', duration: 3000 });
                            } finally {
                              setAppealActionLoading(false);
                            }
                          }}
                          isLoading={appealActionLoading}
                          leftIcon={<CheckCircle size={16} />}
                        >
                          Approve & Unban
                        </PokerButton>
                        <PokerButton
                          variant="danger"
                          bg="red.600"
                          onClick={async () => {
                            if (!window.confirm(`Reject this appeal? ${selectedAppeal.username} will remain banned.`)) return;
                            setAppealActionLoading(true);
                            try {
                              await reportService.handleAppeal(
                                selectedAppeal.id,
                                'reject',
                                appealReviewNotes || undefined
                              );
                              toast({ 
                                title: 'Appeal Rejected', 
                                description: 'User will remain banned',
                                status: 'info', 
                                duration: 3000 
                              });
                              onAppealDetailClose();
                              // Refresh appeals and stats
                              const newAppeals = await reportService.getBanAppeals(appealStatusFilter || undefined);
                              setAppeals(newAppeals);
                              const newStats = await reportService.getReportStats();
                              setReportStats(newStats);
                            } catch (err: any) {
                              toast({ title: 'Error', description: err.message, status: 'error', duration: 3000 });
                            } finally {
                              setAppealActionLoading(false);
                            }
                          }}
                          isLoading={appealActionLoading}
                          leftIcon={<XCircle size={16} />}
                        >
                          Reject Appeal
                        </PokerButton>
                      </HStack>
                    </VStack>
                  )}

                  {/* Already reviewed info */}
                  {selectedAppeal.status !== 'pending' && selectedAppeal.reviewedByUsername && (
                    <Box bg={selectedAppeal.status === 'approved' ? 'green.900' : 'red.900'} p={3} borderRadius="md">
                      <Text color={selectedAppeal.status === 'approved' ? 'green.200' : 'red.200'} fontSize="xs" mb={1}>
                        REVIEWED BY
                      </Text>
                      <Text color="white">{selectedAppeal.reviewedByUsername}</Text>
                      {selectedAppeal.reviewNotes && (
                        <Text color="gray.300" fontSize="sm" mt={2}>{selectedAppeal.reviewNotes}</Text>
                      )}
                    </Box>
                  )}
                </VStack>
              </ModalBody>
            )}
            
            <ModalFooter borderTop="1px solid" borderColor="gray.700">
              <Button variant="ghost" onClick={onAppealDetailClose}>
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </VStack>
    </Container>
  );
};

export default AdminDashboard;